
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("dKNUD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("2UCox")).CustomersAppLayout);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $2UCox = parcelRequire("2UCox");

});
parcelRegister("2UCox", function(module, exports) {

$parcel$export(module.exports, "CustomersAppLayout", () => $3578696900266d3e$export$77fba3c9350934ab);

var $5uXOq = parcelRequire("5uXOq");

var $cigQb = parcelRequire("cigQb");
var $4KBRy = parcelRequire("4KBRy");

var $jD5no = parcelRequire("jD5no");

var $9noxX = parcelRequire("9noxX");


var $aLLc7 = parcelRequire("aLLc7");

var $e9YVH = parcelRequire("e9YVH");

var $dAUxP = parcelRequire("dAUxP");

var $6Gu2f = parcelRequire("6Gu2f");

var $b2XdI = parcelRequire("b2XdI");

var $cf7yQ = parcelRequire("cf7yQ");

var $e33py = parcelRequire("e33py");

var $gq0sA = parcelRequire("gq0sA");

var $4S0uJ = parcelRequire("4S0uJ");

var $cz40O = parcelRequire("cz40O");

var $dxOZv = parcelRequire("dxOZv");

var $4dRjY = parcelRequire("4dRjY");

var $l8ruj = parcelRequire("l8ruj");

var $doZTA = parcelRequire("doZTA");
const $3578696900266d3e$var$CustomersTheme = {
    isNestedGrid: true,
    spacing: 'compact',
    columns: 1
};
const $3578696900266d3e$var$pageId = 'servicedesk-customers';
const $3578696900266d3e$export$77fba3c9350934ab = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const [{ data: pageContextData, error: error }] = (0, $gq0sA.usePageContext)();
    const { tenantContext: tenantContext, projectContext: projectContext } = pageContextData || {};
    const { projectName: projectName } = projectContext || {};
    const { baseUrl: baseUrl } = tenantContext || {};
    const { data: serviceProjectFeatureData } = (0, $b2XdI.default)();
    if (serviceProjectFeatureData?.[0, $3bae7046e293c392$export$6860c7a26d6d6d35]?.status === (0, $3bae7046e293c392$export$e927a5d1b72f0b68)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dxOZv.AsyncContactsAppLayout), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "servicedesk-customers-v2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cz40O.SpaPageWrapper), {
        pageId: $3578696900266d3e$var$pageId,
        baseUrl: baseUrl,
        currentUrl: match.url,
        // @ts-expect-error - TS2322 - Type '{ projectId: number; projectKey: string; projectName: string; projectType: ProjectType; isAdmin: boolean; isProjectSimplified: boolean; } | undefined' is not assignable to type 'ProjectContext | null | undefined'.
        projectContext: projectContext,
        isLoading: !pageContextData && !error,
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e33py.ServiceDeskDocumentTitle), {
        projectName: projectName,
        section: "customers"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        id: $3578696900266d3e$var$pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9noxX.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aLLc7.ServiceDeskErrorBoundary), {
        appName: (0, $e9YVH.APP_NAMES).CUSTOMERS,
        ErrorView: (0, $dAUxP.ErrorView)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4S0uJ.PageStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cigQb.default), {
        layout: "fluid",
        theme: $3578696900266d3e$var$CustomersTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4KBRy.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Gu2f.default), null)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cf7yQ.JsdGettingStartedPanelShouldRender), null));
};

});
parcelRegister("cigQb", function(module, exports) {

$parcel$export(module.exports, "default", () => $be71958c43737a5a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ggIgZ = parcelRequire("ggIgZ");

var $gUAUI = parcelRequire("gUAUI");

var $4KBRy = parcelRequire("4KBRy");

var $4VG9W = parcelRequire("4VG9W");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $be71958c43737a5a$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, $4VG9W.GridContext));
    const { medium: medium } = (0, $5uXOq.useContext)((0, $4KBRy.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $ggIgZ.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $ggIgZ.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4VG9W.GridContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gUAUI.Grid), {
            layout: layout,
            testId: testId,
            children: children
        })
    });
};
var $be71958c43737a5a$export$2e2bcd8739ae039 = $be71958c43737a5a$var$GridWrapper;

});
parcelRegister("ggIgZ", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $fdd4dd9b7cc1a587$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $fdd4dd9b7cc1a587$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $fdd4dd9b7cc1a587$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $fdd4dd9b7cc1a587$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $fdd4dd9b7cc1a587$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $fdd4dd9b7cc1a587$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $fdd4dd9b7cc1a587$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $fdd4dd9b7cc1a587$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $fdd4dd9b7cc1a587$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $fdd4dd9b7cc1a587$export$936829b4511db3e4);
const $fdd4dd9b7cc1a587$var$defaultGridSize = 8;
const $fdd4dd9b7cc1a587$export$74797698e12f8baa = 12;
const $fdd4dd9b7cc1a587$export$b8241a1616ab1b96 = $fdd4dd9b7cc1a587$var$defaultGridSize * 10;
const $fdd4dd9b7cc1a587$export$2a89a65a43bab52d = {
    comfortable: $fdd4dd9b7cc1a587$var$defaultGridSize * 5,
    cosy: $fdd4dd9b7cc1a587$var$defaultGridSize * 2,
    compact: $fdd4dd9b7cc1a587$var$defaultGridSize * 0.5
};
const $fdd4dd9b7cc1a587$export$8ec7372efd74b753 = 'cosy';
const $fdd4dd9b7cc1a587$export$d77f83c3d17a7b8a = 52;
const $fdd4dd9b7cc1a587$export$f8725d21f81f3e01 = 0;
const $fdd4dd9b7cc1a587$export$2303d2bd9eeff99a = 'fixed';
const $fdd4dd9b7cc1a587$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $fdd4dd9b7cc1a587$export$8b7e31f391e6e681 = '--ds-column-span';
const $fdd4dd9b7cc1a587$export$936829b4511db3e4 = '--ds-grid-spacing';

});

parcelRegister("gUAUI", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $dfafdfc07e588f65$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ggIgZ = parcelRequire("ggIgZ");

var $4VG9W = parcelRequire("4VG9W");
function $dfafdfc07e588f65$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dfafdfc07e588f65$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $ggIgZ.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $dfafdfc07e588f65$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $ggIgZ.varColumnsNum)}) * ${(0, $ggIgZ.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $dfafdfc07e588f65$var$nestedGridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $ggIgZ.varGridSpacing)}))`
});
const $dfafdfc07e588f65$export$ef2184bd89960b14 = ({ layout: layout = (0, $ggIgZ.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, $4VG9W.GridContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $dfafdfc07e588f65$var$gridStyles,
            $dfafdfc07e588f65$var$gridLayoutStyles[layout],
            isNested && $dfafdfc07e588f65$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $ggIgZ.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $ggIgZ.varGridSpacing)]: `${(0, $ggIgZ.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("4VG9W", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $6da7ed7449613c9c$export$11cae3e04ab99fae);

var $5uXOq = parcelRequire("5uXOq");

var $ggIgZ = parcelRequire("ggIgZ");
const $6da7ed7449613c9c$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $ggIgZ.defaultSpacing),
    columns: (0, $ggIgZ.defaultGridColumns)
});

});


parcelRegister("4KBRy", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $da4ea2268815c5f0$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $da4ea2268815c5f0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ggIgZ = parcelRequire("ggIgZ");

var $4VG9W = parcelRequire("4VG9W");
/**
 * Determines the method by which column width is calculated.
 */ var $da4ea2268815c5f0$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($da4ea2268815c5f0$var$ColumnVariant || {});
const $da4ea2268815c5f0$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $ggIgZ.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $da4ea2268815c5f0$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $da4ea2268815c5f0$var$singleColumnWidth = `(${$da4ea2268815c5f0$var$availableWidth} / var(${(0, $ggIgZ.varColumnsNum)}))`;
const $da4ea2268815c5f0$var$gridColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$da4ea2268815c5f0$var$singleColumnWidth} - var(${(0, $ggIgZ.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $ggIgZ.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $da4ea2268815c5f0$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $ggIgZ.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$da4ea2268815c5f0$var$singleColumnWidth} *  var(${(0, $ggIgZ.varColumnSpan)}) - var(${(0, $ggIgZ.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $ggIgZ.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $da4ea2268815c5f0$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    medium: (0, $ggIgZ.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $da4ea2268815c5f0$var$GridColumn = ({ medium: medium = (0, $ggIgZ.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $5uXOq.useContext)((0, $4VG9W.GridContext));
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $da4ea2268815c5f0$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($da4ea2268815c5f0$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $da4ea2268815c5f0$var$gridColumnStyles,
            $da4ea2268815c5f0$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $ggIgZ.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $da4ea2268815c5f0$export$2e2bcd8739ae039 = $da4ea2268815c5f0$var$GridColumn;

});


const $3bae7046e293c392$export$b45a36df7873757 = 'alerts';
const $3bae7046e293c392$export$a7952c5a5c371ddd = 'oncall';
const $3bae7046e293c392$export$de0bca182bc46c7f = 'services';
const $3bae7046e293c392$export$ed849d1eb34423e5 = 'similarIssues';
const $3bae7046e293c392$export$d4a1ed8524773042 = 'sentiment-analysis';
const $3bae7046e293c392$export$46f600f4680e5fd0 = 'jsm-ai-context';
const $3bae7046e293c392$export$3d2ce10d3ca55e3c = 'automaticallySetRequestType';
const $3bae7046e293c392$export$cae2404f62c0f4d7 = 'change-management';
const $3bae7046e293c392$export$31ffe79c2b019cf = 'incident-management';
const $3bae7046e293c392$export$3a20074cc38cbf69 = 'problem-management';
const $3bae7046e293c392$export$a364d86306d4a6d4 = 'service-request';
const $3bae7046e293c392$export$71f1a79e03f525 = 'post-incident-review';
const $3bae7046e293c392$export$6860c7a26d6d6d35 = 'csm-customer-context';
const $3bae7046e293c392$export$7c5ee80fcb40e9d3 = 'developer-escalation';
const $3bae7046e293c392$export$28fc94ee6c61f632 = 'products-and-entitlements';
const $3bae7046e293c392$export$93b42272f76473c9 = 'jsm-views';
const $3bae7046e293c392$export$1eb399d8c2d53748 = 'jsm-board';
const $3bae7046e293c392$export$abbcecf25bfa1e87 = 'jsm-calendar';
const $3bae7046e293c392$export$891877b4a4d60ea2 = 'jsm-project-summary';
const $3bae7046e293c392$export$66ede2c1de447f8f = 'developer-escalation';
const $3bae7046e293c392$export$c54f3fef3b7893c1 = 'request-type-category'; // remove when cleaning request_type_table_uplift
const $3bae7046e293c392$export$1ee9c534405b9b35 = 'playbooks';
const $3bae7046e293c392$export$ac0832132e8992d7 = 'automation-discoverability';
const $3bae7046e293c392$export$fc77e86331b0e2c7 = 'jcs-customer-support-escalation';
const $3bae7046e293c392$export$e927a5d1b72f0b68 = 'ENABLED';
const $3bae7046e293c392$export$8cd212c10b4124d2 = 'DISABLED';

parcelRegister("aLLc7", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskErrorBoundary", () => $8803d19bf51a79cd$export$d999c9325a45f4cf);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $e9YVH = parcelRequire("e9YVH");
/**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */ const $8803d19bf51a79cd$var$triggerAnalyticsEvent = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $8803d19bf51a79cd$var$toErrorOrUndefined = (error)=>{
    if (error instanceof Error) return error;
    if (typeof error === 'string') return new Error(error);
    return undefined;
};
class $8803d19bf51a79cd$export$d999c9325a45f4cf extends (0, $5uXOq.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    constructor(props){
        super(props), this.state = {
            hasError: false
        };
        this.triggerEvent = $8803d19bf51a79cd$var$triggerAnalyticsEvent(`${props.appName}`);
    }
    componentDidCatch(error) {
        const { onErrorHandler: onErrorHandler, ErrorView: ErrorView, appName: appName } = this.props;
        const data = error instanceof Error ? {
            message: error.message,
            stack: error.stack
        } : {
            message: error
        };
        this.triggerEvent('error-boundary.error-caught', data);
        (0, $jcw0u.default)({
            meta: {
                id: 'unhandled',
                packageName: (0, $e9YVH.toPackageName)(appName) || 'jiraServicedeskCommon'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            event: this.triggerEvent,
            error: $8803d19bf51a79cd$var$toErrorOrUndefined(error),
            sendToPrivacyUnsafeSplunk: true
        });
        // If error view is present then allow error view to handle errors.
        if (ErrorView) return;
        // Some of the non spa apps uses this call back function which doesn't have any error view
        if (onErrorHandler) onErrorHandler(error);
        else // Rethrow for error boundary handling by app-base
        throw error;
    }
    render() {
        const { hasError: hasError } = this.state;
        const { ErrorView: ErrorView, children: children } = this.props;
        if (hasError && ErrorView) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorView, null);
        return children;
    }
}

});

parcelRegister("dAUxP", function(module, exports) {

$parcel$export(module.exports, "ErrorView", () => $1a452c20404e1a5f$export$8c68b6013ae44ca6);

var $5uXOq = parcelRequire("5uXOq");

var $5oFIy = parcelRequire("5oFIy");

var $8pMQX = parcelRequire("8pMQX");
const $1a452c20404e1a5f$export$8c68b6013ae44ca6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        eventName: "customersOrgsErrorView loaded"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.GenericError), null));

});
parcelRegister("8pMQX", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $951f6bd200bf8b89$export$849d319c342682a2);
$parcel$export(module.exports, "ServiceHubNotFound", () => $951f6bd200bf8b89$export$1fbf518ac538659c);
$parcel$export(module.exports, "GenericError", () => $951f6bd200bf8b89$export$7d465be8efa67280);

var $5uXOq = parcelRequire("5uXOq");

var $aatTc = parcelRequire("aatTc");

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");

var $3s0xG = parcelRequire("3s0xG");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $7xBz2 = parcelRequire("7xBz2");

var $lVQn8 = parcelRequire("lVQn8");

var $id7K0 = parcelRequire("id7K0");

var $bTyOW = parcelRequire("bTyOW");

var $fC09Q = parcelRequire("fC09Q");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $hjSul = parcelRequire("hjSul");

var $4R6GH = parcelRequire("4R6GH");

var $4AdE6 = parcelRequire("4AdE6");
const $951f6bd200bf8b89$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fC09Q.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).notFoundTitle),
        description: formatMessage((0, $4AdE6.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
            to: projectsPath
        }, formatMessage((0, $4AdE6.default).notFoundAction))
    }));
};
const $951f6bd200bf8b89$export$1fbf518ac538659c = ()=>{
    const projectsPath = '/jira/projects';
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $4AdE6.default).customerHubNotFoundDocumentTitleJsm : (0, $4AdE6.default).serviceHubNotFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fC09Q.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $4AdE6.default).customerHubNotFoundTitle : (0, $4AdE6.default).serviceHubNotFoundTitle),
        description: formatMessage((0, $4AdE6.default).serviceHubNotFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
            to: projectsPath
        }, formatMessage((0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $4AdE6.default).customerHubNotFoundAction : (0, $4AdE6.default).serviceHubNotFoundAction))
    }));
};
const $951f6bd200bf8b89$export$7d465be8efa67280 = ()=>{
    const interactionId = (0, $5uXOq.useContext)((0, $32M8E.default)).current;
    const labelStack = (0, $5uXOq.useContext)((0, $aatTc.default))?.labelStack;
    const traceId = (0, $5uXOq.useMemo)(()=>{
        const traceContext = (0, $7xBz2.getActiveTrace)();
        return traceContext?.traceId;
    }, []);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let description = formatMessage((0, $4AdE6.default).genericErrorDescription);
    if (traceId) {
        const error = new Error('An error occurred while loading this page');
        description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: $951f6bd200bf8b89$var$styles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lVQn8.ErrorHashAndTraceId), {
            error: error,
            traceId: traceId
        })));
        if ((0, $4R6GH.fg)('add_ufo_error_in_service_desk_genericerror')) {
            const name = 'serviceDeskGenericError';
            if (interactionId) {
                (0, $lAOer.addError)(interactionId, name, labelStack ?? null, error.name, error.message, error.stack);
                // NOTE: to account for awaiting BM3 TTI in UFO code, however we don't need to wait for BM3 TTI when there is an error
                // https://atlassian.slack.com/archives/C01AY8132S3/p1736380314352749?thread_ts=1736377740.484469&cid=C01AY8132S3
                const activeInteraction = (0, $lAOer.getActiveInteraction)();
                activeInteraction?.holdActive.forEach((_, holdId)=>{
                    (0, $lAOer.removeHoldByID)(activeInteraction.id, holdId);
                });
            } else (0, $lAOer.addErrorToAll)(name, labelStack ?? null, error.name, error.message, error.stack);
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $bTyOW.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).genericErrorTitle),
        description: description
    }));
};
const $951f6bd200bf8b89$var$styles = (0, $2s57o.xcss)({
    marginTop: 'space.100'
});

});
parcelRegister("lVQn8", function(module, exports) {

$parcel$export(module.exports, "ErrorHashAndTraceId", () => $6bb63dde5e44a95e$export$61354a7dde2c2d3c);

var $5uXOq = parcelRequire("5uXOq");

var $5oFIy = parcelRequire("5oFIy");

var $kobfu = parcelRequire("kobfu");

var $hurrh = parcelRequire("hurrh");
const $6bb63dde5e44a95e$export$61354a7dde2c2d3c = ({ error: error, traceId: traceId })=>{
    const errorHash = (0, $kobfu.getErrorHash)(error);
    const source = `Hash ${errorHash}\nTrace ${traceId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        action: "rendered",
        actionSubject: "errorHashAndTraceId",
        attributes: {
            errorHash: errorHash,
            traceId: traceId
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "note"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hurrh.CodeBlockWithCopyButton), {
        source: source,
        copyCodeActionSubjectId: "copyErrorHashAndTraceId"
    })));
};

});
parcelRegister("hurrh", function(module, exports) {

$parcel$export(module.exports, "CodeBlockWithCopyButton", () => $e48150d967598599$export$ced1fc74d907d387);

var $5uXOq = parcelRequire("5uXOq");

var $fzUGr = parcelRequire("fzUGr");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $irzxp = parcelRequire("irzxp");
const $e48150d967598599$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $e48150d967598599$var$wrapperStyles,
        role: "region"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irzxp.ActionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irzxp.CopyAction), {
        source: source,
        actionSubjectId: copyCodeActionSubjectId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fzUGr.default), {
        text: source,
        showLineNumbers: false,
        shouldWrapLongLines: false
    })));
const $e48150d967598599$var$wrapperStyles = (0, $2s57o.xcss)({
    width: '100%',
    position: 'relative'
});

});
parcelRegister("fzUGr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a96956312d74a20$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $la5nd = parcelRequire("la5nd");

var $jhA2F = parcelRequire("jhA2F");

var $bEVVW = parcelRequire("bEVVW");

var $gCl68 = parcelRequire("gCl68");
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $0a96956312d74a20$var$CodeBlock = /*#__PURE__*/ (0, $5uXOq.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false }) {
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const theme = (0, $5uXOq.useMemo)(()=>(0, $jhA2F.getCodeBlockTheme)(numLines), [
        numLines
    ]);
    const getStyles = (0, $5uXOq.useMemo)(()=>(0, $jhA2F.getCodeBlockStyles)(theme), [
        theme
    ]);
    const styles = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        getStyles(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)), [
        highlightedStartText,
        highlightedEndText,
        showLineNumbers,
        shouldWrapLongLines,
        getStyles
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $la5nd.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $5uXOq.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $5uXOq.useMemo)(()=>(0, $bEVVW.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]);
    // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gCl68.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        css: styles,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // shouldCreateParentElementForLines is needed to pass down props to each line.
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        text: text
    });
});
$0a96956312d74a20$var$CodeBlock.displayName = 'CodeBlock';
var $0a96956312d74a20$export$2e2bcd8739ae039 = $0a96956312d74a20$var$CodeBlock;

});
parcelRegister("la5nd", function(module, exports) {

$parcel$export(module.exports, "useHighlightLines", () => $d16fc758e2d4acef$export$84415a200bdf33ed);

var $5uXOq = parcelRequire("5uXOq");
const $d16fc758e2d4acef$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $d16fc758e2d4acef$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$d16fc758e2d4acef$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $d16fc758e2d4acef$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $d16fc758e2d4acef$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $5uXOq.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $5uXOq.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $d16fc758e2d4acef$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$d16fc758e2d4acef$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $d16fc758e2d4acef$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};

});

parcelRegister("jhA2F", function(module, exports) {

$parcel$export(module.exports, "getCodeBlockStyles", () => $612757b728dd1aa7$export$b571c24d82780698);
$parcel$export(module.exports, "getCodeStyles", () => $612757b728dd1aa7$export$d5fcf1b7ff23707b);
$parcel$export(module.exports, "getCodeBlockTheme", () => $612757b728dd1aa7$export$57a2d4b573afd64a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2bzvJ = parcelRequire("2bzvJ");

var $k4iY2 = parcelRequire("k4iY2");
const $612757b728dd1aa7$export$cb7aec0206b595d2 = (numLines)=>{
    if (!numLines) return '1ch';
    return `${numLines.toFixed(0).length}ch`;
};
const $612757b728dd1aa7$var$lineNumberStyle = (theme)=>({
        // width of the line number gutter
        minWidth: `calc(${theme.lineNumberWidth} + ${0, $2bzvJ.LINE_NUMBER_GUTTER}px) !important`,
        // this needs to be important or it gets overwritten by inline styles
        fontStyle: 'normal !important',
        // this needs to be important or it gets overwritten by inline styles
        color: `${theme.lineNumberColor} !important`,
        flexShrink: 0,
        // needed to replicate existing design spec
        boxSizing: 'border-box',
        paddingRight: `${0, $2bzvJ.SPACING}px !important`,
        paddingLeft: (0, $2bzvJ.SPACING),
        marginRight: (0, $2bzvJ.SPACING),
        textAlign: 'right',
        userSelect: 'none',
        // this is to fix SSR spacing issue
        display: 'block',
        // This is how we are preventing line numbers being copied to clipboard.
        // (`user-select: none;` was not sufficent).
        // https://product-fabric.atlassian.net/browse/DSP-2729
        '&::after': {
            content: `attr(data-ds--line-number)`
        }
    });
// order of these keys does matter as it will affect the css precedence
const $612757b728dd1aa7$var$syntaxKeywordColors = (theme)=>({
        '.token': {
            // this specifically stops prism css cascading.
            '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                all: 'unset'
            },
            // additional specificity required to match the all: unset
            '&.key,&.keyword': {
                color: theme.keywordColor,
                fontWeight: 'bolder'
            },
            '&.attr-name': {
                color: theme.attributeColor
            },
            '&.selector': {
                color: theme.selectorTagColor
            },
            '&.comment,&.block-comment': {
                color: theme.commentColor,
                fontFamily: theme.fontFamilyItalic,
                fontStyle: 'italic'
            },
            '&.function-name': {
                color: theme.sectionColor
            },
            '&.doctype': {
                color: theme.docTagColor
            },
            '&.substr': {
                color: theme.substringColor
            },
            '&.namespace': {
                color: theme.nameColor
            },
            '&.builtin': {
                color: theme.builtInColor
            },
            '&.entity': {
                color: theme.literalColor
            },
            '&.bullet': {
                color: theme.bulletColor
            },
            '&.code': {
                color: theme.codeColor
            },
            '&.regex': {
                color: theme.regexpColor
            },
            '&.symbol': {
                color: theme.symbolColor
            },
            '&.variable': {
                color: theme.variableColor
            },
            '&.url': {
                color: theme.linkColor
            },
            '&.selector-attr': {
                color: theme.selectorAttributeColor
            },
            '&.selector-pseudo': {
                color: theme.selectorPseudoColor
            },
            '&.type': {
                color: theme.typeColor
            },
            '&.quote': {
                color: theme.quoteColor
            },
            '&.tag': {
                color: theme.templateTagColor
            },
            '&.string': {
                color: theme.stringColor
            },
            '&.class-name': {
                color: theme.sectionColor
            },
            '&.title': {
                color: theme.titleColor
            },
            '&.section': {
                color: theme.sectionColor
            },
            '&.meta-keyword': {
                color: theme.metaKeywordColor
            },
            '&.meta': {
                color: theme.metaColor
            },
            '&.italic': {
                fontStyle: 'italic'
            },
            '&.bold': {
                fontWeight: 'bolder'
            },
            '&.function': {
                color: theme.functionColor
            },
            '&.number': {
                color: theme.numberColor
            },
            '&.attr-value': {
                color: theme.attributeColor
            },
            '&.prolog': {
                color: theme.prologColor
            },
            '&.cdata': {
                color: theme.cdataColor
            },
            '&.punctuation': {
                color: theme.punctuationColor
            },
            '&.property': {
                color: theme.propertyColor
            },
            '&.constant': {
                color: theme.constantColor
            },
            '&.deleted': {
                color: theme.deletedColor
            },
            '&.boolean': {
                color: theme.booleanColor
            },
            '&.char': {
                color: theme.charColor
            },
            '&.inserted': {
                color: theme.insertedColor
            },
            '&.operator': {
                color: theme.operatorColor
            },
            '&.atrule': {
                color: theme.atruleColor
            },
            '&.important': {
                color: theme.importantColor,
                fontWeight: "var(--ds-font-weight-bold, 700)"
            }
        }
    });
/**
 * Styles applied at the root element level, common across code/codeblock
 */ const $612757b728dd1aa7$var$getBaseCodeStyles = (theme)=>({
        fontSize: (0, $2bzvJ.CODE_FONT_SIZE),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: theme.fontFamily,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(${0, $2bzvJ.VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
        color: theme.textColor,
        borderStyle: 'none',
        borderRadius: "var(--ds-border-radius, 3px)"
    });
const $612757b728dd1aa7$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
            // this is required to account for prismjs styles leaking into the codeblock
            'code[class*="language-"], pre[class*="language-"], code': {
                all: 'unset',
                padding: showLineNumbers ? `${0, $2bzvJ.SPACING}px 0` : (0, $2bzvJ.SPACING),
                tabSize: 4
            },
            display: 'flex',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $2bzvJ.CODE_LINE_HEIGHT),
            overflowX: 'auto',
            whiteSpace: 'pre',
            direction: 'ltr',
            ...$612757b728dd1aa7$var$getBaseCodeStyles(theme),
            ...$612757b728dd1aa7$var$syntaxKeywordColors(theme),
            // this is to account for SSR spacing issue once loaded in browser
            '& .linenumber, .ds-sh-line-number': $612757b728dd1aa7$var$lineNumberStyle(theme),
            '& .linenumber': {
                display: 'inline-block !important',
                float: 'left'
            },
            // these styles are for line highlighting
            '& [data-ds--code--row]': {
                display: showLineNumbers ? 'flex' : 'block',
                paddingRight: `${0, $2bzvJ.SPACING}px !important`,
                marginRight: `-${0, $2bzvJ.SPACING}px`
            },
            '& [data-ds--code--row--highlight]': {
                background: `${theme.highlightedLineBgColor}`,
                // eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
                '&::before, &::after': {
                    clipPath: 'inset(100%)',
                    clip: 'rect(1px, 1px, 1px, 1px)',
                    height: '1px',
                    overflow: 'hidden',
                    position: 'absolute',
                    whiteSpace: 'nowrap',
                    width: '1px'
                },
                // The formatting here is an accessibility convention
                '&::before': {
                    content: `" [${highlightedStartText}] "`
                },
                '&::after': {
                    content: `" [${highlightedEndText}] "`
                }
            },
            '& [data-ds--code--row--highlight] .linenumber': {
                borderLeft: `${0, $2bzvJ.HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                paddingLeft: `${(0, $2bzvJ.SPACING) / 2}px !important`,
                position: 'relative'
            },
            // fill in space caused by parent border top
            '& [data-ds--code--row--highlight] .linenumber::before': {
                content: '""',
                position: 'absolute',
                width: (0, $2bzvJ.HIGHLIGHT_BORDER_WIDTH),
                top: '-1px',
                left: `-${0, $2bzvJ.HIGHLIGHT_BORDER_WIDTH}`,
                borderTop: `1px solid ${theme.highlightedLineBorderColor}`
            },
            '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                borderTop: '1px dashed transparent'
            },
            '[data-ds--code--row--highlight]:last-child': {
                borderBottom: '1px dashed transparent'
            },
            '& code:first-of-type': {
                paddingRight: `0px !important`,
                backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, $2bzvJ.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, $2bzvJ.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, $2bzvJ.LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, $2bzvJ.LINE_NUMBER_GUTTER}px), transparent)` : undefined
            },
            // we need to use last-of-type because when Code is SSR'd
            // 2 <code> elements are created and we don't want this style
            // applied to the first one
            '& code:last-of-type': {
                paddingRight: `${0, $2bzvJ.SPACING}px !important`,
                flexBasis: 'auto',
                flexGrow: 1,
                // Needed for the highlight line to extend full-width
                flexShrink: shouldWrapLongLines ? 1 : 0,
                wordBreak: 'break-word'
            },
            // Prevents empty code blocks from vertically collapsing
            'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                content: '" "'
            }
        });
const $612757b728dd1aa7$export$d5fcf1b7ff23707b = ()=>{
    const theme = (0, $k4iY2.getBaseTheme)();
    const baseStyles = $612757b728dd1aa7$var$getBaseCodeStyles(theme);
    return {
        ...baseStyles,
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    };
};
const $612757b728dd1aa7$export$57a2d4b573afd64a = (maxLines)=>{
    return {
        ...(0, $k4iY2.getBaseTheme)(),
        ...(0, $k4iY2.getColorPalette)(),
        lineNumberWidth: maxLines ? $612757b728dd1aa7$export$cb7aec0206b595d2(maxLines) : undefined
    };
};

});
parcelRegister("2bzvJ", function(module, exports) {

$parcel$export(module.exports, "CODE_FONT_SIZE", () => $951cda86c3f7ec2a$export$431ac46d758d98c8);
$parcel$export(module.exports, "CODE_LINE_HEIGHT", () => $951cda86c3f7ec2a$export$8e3c04032121c606);
$parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", () => $951cda86c3f7ec2a$export$c8b5dc30e9f2b86e);
$parcel$export(module.exports, "SPACING", () => $951cda86c3f7ec2a$export$82ea42e772d49e5b);
$parcel$export(module.exports, "LINE_NUMBER_GUTTER", () => $951cda86c3f7ec2a$export$eeeea0ff98e06fff);
$parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", () => $951cda86c3f7ec2a$export$254015fe817dcb9e);
$parcel$export(module.exports, "VAR_CODE_BG_COLOR", () => $951cda86c3f7ec2a$export$1758fda69688282e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $b4a3S = parcelRequire("b4a3S");
const $951cda86c3f7ec2a$export$431ac46d758d98c8 = 12;
const $951cda86c3f7ec2a$export$8e3c04032121c606 = '20px';
const $951cda86c3f7ec2a$export$c8b5dc30e9f2b86e = '4px';
const $951cda86c3f7ec2a$export$82ea42e772d49e5b = (0, $b4a3S.gridSize)();
const $951cda86c3f7ec2a$export$eeeea0ff98e06fff = $951cda86c3f7ec2a$export$82ea42e772d49e5b * 2;
const $951cda86c3f7ec2a$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
const $951cda86c3f7ec2a$export$1758fda69688282e = '--ds--code--bg-color';
const $951cda86c3f7ec2a$export$2cd00c745c539a1 = `data-ds--code--code-block`;

});

parcelRegister("k4iY2", function(module, exports) {

$parcel$export(module.exports, "getBaseTheme", () => $4e08fe6f3ebd682e$export$4464aa303b3e4fda);
$parcel$export(module.exports, "getColorPalette", () => $4e08fe6f3ebd682e$export$fe2a6478976e8b17);

var $8QpSo = parcelRequire("8QpSo");


var $zbAwE = parcelRequire("zbAwE");
// Hardcoded values have been used due to the current color palette not having any
// accessible color options for Teal and Yellow and +20A
const $4e08fe6f3ebd682e$var$T800 = '#067384';
const $4e08fe6f3ebd682e$var$Y1100 = '#7A5D1A';
const $4e08fe6f3ebd682e$export$4464aa303b3e4fda = ()=>({
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamilyItalic: `SFMono-MediumItalic, ${(0, $zbAwE.default)('font.family.code')}`,
        backgroundColor: `var(--ds-background-neutral, ${$a7f8c6b391092279$export$9fdfb749e33cdf97})`,
        textColor: `var(--ds-text, ${$a7f8c6b391092279$export$7d61b15e0da132af})`,
        lineNumberColor: `var(--ds-text-subtlest, ${$a7f8c6b391092279$export$eece5f492e429f08})`,
        lineNumberBgColor: `var(--ds-background-neutral, ${$a7f8c6b391092279$export$3e51e8f1440314ba})`
    });
const $4e08fe6f3ebd682e$export$fe2a6478976e8b17 = (0, $8QpSo.default)(()=>{
    return {
        highlightedLineBgColor: `var(--ds-background-neutral, ${$a7f8c6b391092279$export$3e51e8f1440314ba})`,
        highlightedLineBorderColor: `var(--ds-border-focused, ${$a7f8c6b391092279$export$215b7063051591f1})`,
        substringColor: `var(--ds-text-subtlest, ${$a7f8c6b391092279$export$eece5f492e429f08})`,
        keywordColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        attributeColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        selectorTagColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        docTagColor: `var(--ds-text-accent-yellow, ${$4e08fe6f3ebd682e$var$Y1100})`,
        nameColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        builtInColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        literalColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        bulletColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        codeColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        regexpColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        symbolColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        variableColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        templateVariableColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        linkColor: `var(--ds-text-accent-purple, ${$a7f8c6b391092279$export$b48405b95304b5a1})`,
        selectorAttributeColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        selectorPseudoColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        typeColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        stringColor: `var(--ds-text-accent-green, ${$a7f8c6b391092279$export$6fa04827ac68a4fb})`,
        selectorIdColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        selectorClassColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        quoteColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        templateTagColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        titleColor: `var(--ds-text-accent-purple, ${$a7f8c6b391092279$export$b48405b95304b5a1})`,
        sectionColor: `var(--ds-text-accent-purple, ${$a7f8c6b391092279$export$b48405b95304b5a1})`,
        commentColor: `var(--ds-text-subtlest, ${$a7f8c6b391092279$export$eece5f492e429f08})`,
        metaKeywordColor: `var(--ds-text-accent-green, ${$a7f8c6b391092279$export$6fa04827ac68a4fb})`,
        metaColor: `var(--ds-text-subtlest, ${$a7f8c6b391092279$export$eece5f492e429f08})`,
        functionColor: `var(--ds-text, ${$a7f8c6b391092279$export$7d61b15e0da132af})`,
        numberColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        prologColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        cdataColor: `var(--ds-text-subtlest, ${$a7f8c6b391092279$export$eece5f492e429f08})`,
        punctuationColor: `var(--ds-text, ${$a7f8c6b391092279$export$7d61b15e0da132af})`,
        propertyColor: `var(--ds-text-accent-purple, ${$a7f8c6b391092279$export$b48405b95304b5a1})`,
        constantColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        booleanColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        charColor: `var(--ds-text, ${$a7f8c6b391092279$export$7d61b15e0da132af})`,
        insertedColor: `var(--ds-text-accent-green, ${$a7f8c6b391092279$export$6fa04827ac68a4fb})`,
        deletedColor: `var(--ds-text-accent-red, ${$a7f8c6b391092279$export$2837b5a1a71d5c02})`,
        operatorColor: `var(--ds-text, ${$a7f8c6b391092279$export$7d61b15e0da132af})`,
        atruleColor: `var(--ds-text-accent-green, ${$a7f8c6b391092279$export$6fa04827ac68a4fb})`,
        importantColor: `var(--ds-text-accent-yellow, ${$4e08fe6f3ebd682e$var$Y1100})`
    };
});
const $4e08fe6f3ebd682e$var$getTheme = ()=>({
        ...$4e08fe6f3ebd682e$export$4464aa303b3e4fda(),
        ...$4e08fe6f3ebd682e$export$fe2a6478976e8b17()
    });
var $4e08fe6f3ebd682e$export$2e2bcd8739ae039 = $4e08fe6f3ebd682e$var$getTheme;

});
var $a7f8c6b391092279$exports = {};

$parcel$export($a7f8c6b391092279$exports, "R50", () => $a7f8c6b391092279$export$4b84fd0e2c617bd);
$parcel$export($a7f8c6b391092279$exports, "R75", () => $a7f8c6b391092279$export$b34b069eff244586);
$parcel$export($a7f8c6b391092279$exports, "R100", () => $a7f8c6b391092279$export$be802dd0d8b57f35);
$parcel$export($a7f8c6b391092279$exports, "R200", () => $a7f8c6b391092279$export$60847d42f9da92a6);
$parcel$export($a7f8c6b391092279$exports, "R300", () => $a7f8c6b391092279$export$4a7404f376229999);
$parcel$export($a7f8c6b391092279$exports, "R400", () => $a7f8c6b391092279$export$2010d0fb4295b346);
$parcel$export($a7f8c6b391092279$exports, "R500", () => $a7f8c6b391092279$export$2837b5a1a71d5c02);
$parcel$export($a7f8c6b391092279$exports, "Y50", () => $a7f8c6b391092279$export$8d9596b529bbb9cf);
$parcel$export($a7f8c6b391092279$exports, "Y75", () => $a7f8c6b391092279$export$41060a744ab0b7ae);
$parcel$export($a7f8c6b391092279$exports, "Y100", () => $a7f8c6b391092279$export$1cc05bbbf340e559);
$parcel$export($a7f8c6b391092279$exports, "Y200", () => $a7f8c6b391092279$export$5aae31392d72caaa);
$parcel$export($a7f8c6b391092279$exports, "Y300", () => $a7f8c6b391092279$export$c6930421db9fa514);
$parcel$export($a7f8c6b391092279$exports, "Y400", () => $a7f8c6b391092279$export$59619663aa6500fb);
$parcel$export($a7f8c6b391092279$exports, "Y500", () => $a7f8c6b391092279$export$874739ea9e379ab6);
$parcel$export($a7f8c6b391092279$exports, "G50", () => $a7f8c6b391092279$export$8a6341c32b6a3ee6);
$parcel$export($a7f8c6b391092279$exports, "G75", () => $a7f8c6b391092279$export$69a3bf21b9686c2b);
$parcel$export($a7f8c6b391092279$exports, "G100", () => $a7f8c6b391092279$export$afbce1382ec95f73);
$parcel$export($a7f8c6b391092279$exports, "G200", () => $a7f8c6b391092279$export$747d86715d4175de);
$parcel$export($a7f8c6b391092279$exports, "G300", () => $a7f8c6b391092279$export$940e1f69e873f202);
$parcel$export($a7f8c6b391092279$exports, "G400", () => $a7f8c6b391092279$export$a49394138f7b8e85);
$parcel$export($a7f8c6b391092279$exports, "G500", () => $a7f8c6b391092279$export$6fa04827ac68a4fb);
$parcel$export($a7f8c6b391092279$exports, "B50", () => $a7f8c6b391092279$export$226de0355ed012f8);
$parcel$export($a7f8c6b391092279$exports, "B75", () => $a7f8c6b391092279$export$8c13c2ee36917869);
$parcel$export($a7f8c6b391092279$exports, "B100", () => $a7f8c6b391092279$export$ecfc1dff386a3e7a);
$parcel$export($a7f8c6b391092279$exports, "B200", () => $a7f8c6b391092279$export$215b7063051591f1);
$parcel$export($a7f8c6b391092279$exports, "B300", () => $a7f8c6b391092279$export$e62e8919cca44969);
$parcel$export($a7f8c6b391092279$exports, "B400", () => $a7f8c6b391092279$export$b3de0ae08da2ce64);
$parcel$export($a7f8c6b391092279$exports, "B500", () => $a7f8c6b391092279$export$a6ee3d71bc067634);
$parcel$export($a7f8c6b391092279$exports, "B600", () => $a7f8c6b391092279$export$67f15409e87642a1);
$parcel$export($a7f8c6b391092279$exports, "B700", () => $a7f8c6b391092279$export$f0539dbc42dbb067);
$parcel$export($a7f8c6b391092279$exports, "P50", () => $a7f8c6b391092279$export$363e4475840015bb);
$parcel$export($a7f8c6b391092279$exports, "P75", () => $a7f8c6b391092279$export$4b0a4417ed59760f);
$parcel$export($a7f8c6b391092279$exports, "P100", () => $a7f8c6b391092279$export$6011520a64d9a187);
$parcel$export($a7f8c6b391092279$exports, "P200", () => $a7f8c6b391092279$export$a7175d4e9206bc80);
$parcel$export($a7f8c6b391092279$exports, "P300", () => $a7f8c6b391092279$export$b48405b95304b5a1);
$parcel$export($a7f8c6b391092279$exports, "P400", () => $a7f8c6b391092279$export$c71e4279dd54a18d);
$parcel$export($a7f8c6b391092279$exports, "P500", () => $a7f8c6b391092279$export$147899de772240ec);
$parcel$export($a7f8c6b391092279$exports, "T50", () => $a7f8c6b391092279$export$2cf711fe14c66f06);
$parcel$export($a7f8c6b391092279$exports, "T75", () => $a7f8c6b391092279$export$7a8f4d33f6f9772c);
$parcel$export($a7f8c6b391092279$exports, "T100", () => $a7f8c6b391092279$export$776c9c497ef08533);
$parcel$export($a7f8c6b391092279$exports, "T200", () => $a7f8c6b391092279$export$69cb3ca10c1e330e);
$parcel$export($a7f8c6b391092279$exports, "T300", () => $a7f8c6b391092279$export$9dc1ef0f3f48059b);
$parcel$export($a7f8c6b391092279$exports, "T400", () => $a7f8c6b391092279$export$7c835c78b6fcdef8);
$parcel$export($a7f8c6b391092279$exports, "T500", () => $a7f8c6b391092279$export$6036577f95c3877e);
$parcel$export($a7f8c6b391092279$exports, "N0", () => $a7f8c6b391092279$export$29a4f05edc054374);
$parcel$export($a7f8c6b391092279$exports, "N10", () => $a7f8c6b391092279$export$e655ef011c4aa1a2);
$parcel$export($a7f8c6b391092279$exports, "N20", () => $a7f8c6b391092279$export$9fdfb749e33cdf97);
$parcel$export($a7f8c6b391092279$exports, "N30", () => $a7f8c6b391092279$export$3e51e8f1440314ba);
$parcel$export($a7f8c6b391092279$exports, "N40", () => $a7f8c6b391092279$export$1ce2d1575d444ceb);
$parcel$export($a7f8c6b391092279$exports, "N50", () => $a7f8c6b391092279$export$8754fc7e6d8b3000);
$parcel$export($a7f8c6b391092279$exports, "N60", () => $a7f8c6b391092279$export$c2e91cbeada39b8b);
$parcel$export($a7f8c6b391092279$exports, "N70", () => $a7f8c6b391092279$export$5f71e19f3a7ad9de);
$parcel$export($a7f8c6b391092279$exports, "N80", () => $a7f8c6b391092279$export$eaa8c8a70ac22806);
$parcel$export($a7f8c6b391092279$exports, "N90", () => $a7f8c6b391092279$export$7c87d337fb91a97d);
$parcel$export($a7f8c6b391092279$exports, "N100", () => $a7f8c6b391092279$export$d6447c357493214f);
$parcel$export($a7f8c6b391092279$exports, "N200", () => $a7f8c6b391092279$export$f563ee71e9ee74cd);
$parcel$export($a7f8c6b391092279$exports, "N300", () => $a7f8c6b391092279$export$e2ef2124cf4024b1);
$parcel$export($a7f8c6b391092279$exports, "N400", () => $a7f8c6b391092279$export$eece5f492e429f08);
$parcel$export($a7f8c6b391092279$exports, "N500", () => $a7f8c6b391092279$export$c39c0fe0f26207ae);
$parcel$export($a7f8c6b391092279$exports, "N600", () => $a7f8c6b391092279$export$7090862dc3038a9f);
$parcel$export($a7f8c6b391092279$exports, "N700", () => $a7f8c6b391092279$export$ad0bacf983b7ddaa);
$parcel$export($a7f8c6b391092279$exports, "N800", () => $a7f8c6b391092279$export$7d61b15e0da132af);
$parcel$export($a7f8c6b391092279$exports, "N900", () => $a7f8c6b391092279$export$fbda843f0a27fe96);
$parcel$export($a7f8c6b391092279$exports, "N10A", () => $a7f8c6b391092279$export$791e57b27ca738ef);
$parcel$export($a7f8c6b391092279$exports, "N20A", () => $a7f8c6b391092279$export$8d43898f60b96a82);
$parcel$export($a7f8c6b391092279$exports, "N30A", () => $a7f8c6b391092279$export$920c0d5c49070351);
$parcel$export($a7f8c6b391092279$exports, "N40A", () => $a7f8c6b391092279$export$46987b49aab6d1a8);
$parcel$export($a7f8c6b391092279$exports, "N50A", () => $a7f8c6b391092279$export$7d3359664e8bb0e5);
$parcel$export($a7f8c6b391092279$exports, "N60A", () => $a7f8c6b391092279$export$d2d3bedfb276cac0);
$parcel$export($a7f8c6b391092279$exports, "N70A", () => $a7f8c6b391092279$export$6e5e7499ff054f6d);
$parcel$export($a7f8c6b391092279$exports, "N80A", () => $a7f8c6b391092279$export$59264b346c877fa7);
$parcel$export($a7f8c6b391092279$exports, "N90A", () => $a7f8c6b391092279$export$d092757d7c64925c);
$parcel$export($a7f8c6b391092279$exports, "N100A", () => $a7f8c6b391092279$export$486ab785e4bac3c6);
$parcel$export($a7f8c6b391092279$exports, "N200A", () => $a7f8c6b391092279$export$fba592bbc6419fea);
$parcel$export($a7f8c6b391092279$exports, "N300A", () => $a7f8c6b391092279$export$13609db0e6812ab8);
$parcel$export($a7f8c6b391092279$exports, "N400A", () => $a7f8c6b391092279$export$fbae4efaa892d883);
$parcel$export($a7f8c6b391092279$exports, "N500A", () => $a7f8c6b391092279$export$f13946d26f440ce6);
$parcel$export($a7f8c6b391092279$exports, "N600A", () => $a7f8c6b391092279$export$19f58225ac52a306);
$parcel$export($a7f8c6b391092279$exports, "N700A", () => $a7f8c6b391092279$export$6384f09da70e7b62);
$parcel$export($a7f8c6b391092279$exports, "N800A", () => $a7f8c6b391092279$export$d0dccc730683edc2);
$parcel$export($a7f8c6b391092279$exports, "DN900", () => $a7f8c6b391092279$export$2f6319cf7d736c2a);
$parcel$export($a7f8c6b391092279$exports, "DN800", () => $a7f8c6b391092279$export$95126bc8884d6634);
$parcel$export($a7f8c6b391092279$exports, "DN700", () => $a7f8c6b391092279$export$8338d8c35d44ff1);
$parcel$export($a7f8c6b391092279$exports, "DN600", () => $a7f8c6b391092279$export$5368d76ae4fbbda7);
$parcel$export($a7f8c6b391092279$exports, "DN500", () => $a7f8c6b391092279$export$9f0a771d16ec8d36);
$parcel$export($a7f8c6b391092279$exports, "DN400", () => $a7f8c6b391092279$export$abcf8c38338b4aa5);
$parcel$export($a7f8c6b391092279$exports, "DN300", () => $a7f8c6b391092279$export$97e81faa16a182c7);
$parcel$export($a7f8c6b391092279$exports, "DN200", () => $a7f8c6b391092279$export$bfe21c59123ecf33);
$parcel$export($a7f8c6b391092279$exports, "DN100", () => $a7f8c6b391092279$export$ee82aa2ea6a1558);
$parcel$export($a7f8c6b391092279$exports, "DN90", () => $a7f8c6b391092279$export$682927c6ed76be02);
$parcel$export($a7f8c6b391092279$exports, "DN80", () => $a7f8c6b391092279$export$91fd9994c5be9757);
$parcel$export($a7f8c6b391092279$exports, "DN70", () => $a7f8c6b391092279$export$d281fbfe3cff2df6);
$parcel$export($a7f8c6b391092279$exports, "DN60", () => $a7f8c6b391092279$export$3902c91d8b98a753);
$parcel$export($a7f8c6b391092279$exports, "DN50", () => $a7f8c6b391092279$export$8e8133c1ba5845b5);
$parcel$export($a7f8c6b391092279$exports, "DN40", () => $a7f8c6b391092279$export$33ff357f6620b39);
$parcel$export($a7f8c6b391092279$exports, "DN30", () => $a7f8c6b391092279$export$633847cf062b69e0);
$parcel$export($a7f8c6b391092279$exports, "DN20", () => $a7f8c6b391092279$export$9776a6e503bdbf76);
$parcel$export($a7f8c6b391092279$exports, "DN10", () => $a7f8c6b391092279$export$6c813d5160dff5db);
$parcel$export($a7f8c6b391092279$exports, "DN0", () => $a7f8c6b391092279$export$3d4f271a500072a);
$parcel$export($a7f8c6b391092279$exports, "DN800A", () => $a7f8c6b391092279$export$fe151285c22759ec);
$parcel$export($a7f8c6b391092279$exports, "DN700A", () => $a7f8c6b391092279$export$a101c6190d0da34);
$parcel$export($a7f8c6b391092279$exports, "DN600A", () => $a7f8c6b391092279$export$4b16f52932fda51);
$parcel$export($a7f8c6b391092279$exports, "DN500A", () => $a7f8c6b391092279$export$a74bcd7b9845b0d8);
$parcel$export($a7f8c6b391092279$exports, "DN400A", () => $a7f8c6b391092279$export$9209c179316d1751);
$parcel$export($a7f8c6b391092279$exports, "DN300A", () => $a7f8c6b391092279$export$88f55133f636c8dd);
$parcel$export($a7f8c6b391092279$exports, "DN200A", () => $a7f8c6b391092279$export$51126f85d1009512);
$parcel$export($a7f8c6b391092279$exports, "DN100A", () => $a7f8c6b391092279$export$a069b547bd23af78);
$parcel$export($a7f8c6b391092279$exports, "DN90A", () => $a7f8c6b391092279$export$40cce05af3b2600a);
$parcel$export($a7f8c6b391092279$exports, "DN80A", () => $a7f8c6b391092279$export$b78942185925a0d);
$parcel$export($a7f8c6b391092279$exports, "DN70A", () => $a7f8c6b391092279$export$e058fb44b8eaafca);
$parcel$export($a7f8c6b391092279$exports, "DN60A", () => $a7f8c6b391092279$export$92b0b8de26920c18);
$parcel$export($a7f8c6b391092279$exports, "DN50A", () => $a7f8c6b391092279$export$67564f7459d3fc9e);
$parcel$export($a7f8c6b391092279$exports, "DN40A", () => $a7f8c6b391092279$export$77868e1ca884ffa3);
$parcel$export($a7f8c6b391092279$exports, "DN30A", () => $a7f8c6b391092279$export$2afd71d7d3ea2cd5);
$parcel$export($a7f8c6b391092279$exports, "DN20A", () => $a7f8c6b391092279$export$f2a0acaab9972c70);
$parcel$export($a7f8c6b391092279$exports, "DN10A", () => $a7f8c6b391092279$export$9ab70e67d6475361);
$parcel$export($a7f8c6b391092279$exports, "T30", () => $a7f8c6b391092279$export$d2adc5dedf09fced);
$parcel$export($a7f8c6b391092279$exports, "L50", () => $a7f8c6b391092279$export$f51762073d2bb381);
$parcel$export($a7f8c6b391092279$exports, "L75", () => $a7f8c6b391092279$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $a7f8c6b391092279$export$4b84fd0e2c617bd = '#FFEBE6';
const $a7f8c6b391092279$export$b34b069eff244586 = '#FFBDAD';
const $a7f8c6b391092279$export$be802dd0d8b57f35 = '#FF8F73';
const $a7f8c6b391092279$export$60847d42f9da92a6 = '#FF7452';
const $a7f8c6b391092279$export$4a7404f376229999 = '#FF5630';
const $a7f8c6b391092279$export$2010d0fb4295b346 = '#DE350B';
const $a7f8c6b391092279$export$2837b5a1a71d5c02 = '#BF2600';
const $a7f8c6b391092279$export$8d9596b529bbb9cf = '#FFFAE6';
const $a7f8c6b391092279$export$41060a744ab0b7ae = '#FFF0B3';
const $a7f8c6b391092279$export$1cc05bbbf340e559 = '#FFE380';
const $a7f8c6b391092279$export$5aae31392d72caaa = '#FFC400';
const $a7f8c6b391092279$export$c6930421db9fa514 = '#FFAB00';
const $a7f8c6b391092279$export$59619663aa6500fb = '#FF991F';
const $a7f8c6b391092279$export$874739ea9e379ab6 = '#FF8B00';
const $a7f8c6b391092279$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $a7f8c6b391092279$export$69a3bf21b9686c2b = '#ABF5D1';
const $a7f8c6b391092279$export$afbce1382ec95f73 = '#79F2C0';
const $a7f8c6b391092279$export$747d86715d4175de = '#57D9A3';
const $a7f8c6b391092279$export$940e1f69e873f202 = '#36B37E';
const $a7f8c6b391092279$export$a49394138f7b8e85 = '#00875A';
const $a7f8c6b391092279$export$6fa04827ac68a4fb = '#006644';
const $a7f8c6b391092279$export$226de0355ed012f8 = '#DEEBFF';
const $a7f8c6b391092279$export$8c13c2ee36917869 = '#B3D4FF';
const $a7f8c6b391092279$export$ecfc1dff386a3e7a = '#4C9AFF';
const $a7f8c6b391092279$export$215b7063051591f1 = '#2684FF';
const $a7f8c6b391092279$export$e62e8919cca44969 = '#0065FF';
const $a7f8c6b391092279$export$b3de0ae08da2ce64 = '#0052CC';
const $a7f8c6b391092279$export$a6ee3d71bc067634 = '#0747A6';
const $a7f8c6b391092279$export$67f15409e87642a1 = '#669DF1';
const $a7f8c6b391092279$export$f0539dbc42dbb067 = '#8FB8F6';
const $a7f8c6b391092279$export$363e4475840015bb = '#EAE6FF';
const $a7f8c6b391092279$export$4b0a4417ed59760f = '#C0B6F2';
const $a7f8c6b391092279$export$6011520a64d9a187 = '#998DD9';
const $a7f8c6b391092279$export$a7175d4e9206bc80 = '#8777D9';
const $a7f8c6b391092279$export$b48405b95304b5a1 = '#6554C0';
const $a7f8c6b391092279$export$c71e4279dd54a18d = '#5243AA';
const $a7f8c6b391092279$export$147899de772240ec = '#403294';
const $a7f8c6b391092279$export$2cf711fe14c66f06 = '#E6FCFF';
const $a7f8c6b391092279$export$7a8f4d33f6f9772c = '#B3F5FF';
const $a7f8c6b391092279$export$776c9c497ef08533 = '#79E2F2';
const $a7f8c6b391092279$export$69cb3ca10c1e330e = '#00C7E6';
const $a7f8c6b391092279$export$9dc1ef0f3f48059b = '#00B8D9';
const $a7f8c6b391092279$export$7c835c78b6fcdef8 = '#00A3BF';
const $a7f8c6b391092279$export$6036577f95c3877e = '#008DA6';
const $a7f8c6b391092279$export$29a4f05edc054374 = '#FFFFFF';
const $a7f8c6b391092279$export$e655ef011c4aa1a2 = '#FAFBFC';
const $a7f8c6b391092279$export$9fdfb749e33cdf97 = '#F4F5F7';
const $a7f8c6b391092279$export$3e51e8f1440314ba = '#EBECF0';
const $a7f8c6b391092279$export$1ce2d1575d444ceb = '#DFE1E6';
const $a7f8c6b391092279$export$8754fc7e6d8b3000 = '#C1C7D0';
const $a7f8c6b391092279$export$c2e91cbeada39b8b = '#B3BAC5';
const $a7f8c6b391092279$export$5f71e19f3a7ad9de = '#A5ADBA';
const $a7f8c6b391092279$export$eaa8c8a70ac22806 = '#97A0AF';
const $a7f8c6b391092279$export$7c87d337fb91a97d = '#8993A4';
const $a7f8c6b391092279$export$d6447c357493214f = '#7A869A';
const $a7f8c6b391092279$export$f563ee71e9ee74cd = '#6B778C';
const $a7f8c6b391092279$export$e2ef2124cf4024b1 = '#5E6C84';
const $a7f8c6b391092279$export$eece5f492e429f08 = '#505F79';
const $a7f8c6b391092279$export$c39c0fe0f26207ae = '#42526E';
const $a7f8c6b391092279$export$7090862dc3038a9f = '#344563';
const $a7f8c6b391092279$export$ad0bacf983b7ddaa = '#253858';
const $a7f8c6b391092279$export$7d61b15e0da132af = '#172B4D';
const $a7f8c6b391092279$export$fbda843f0a27fe96 = '#091E42';
const $a7f8c6b391092279$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $a7f8c6b391092279$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $a7f8c6b391092279$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $a7f8c6b391092279$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $a7f8c6b391092279$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $a7f8c6b391092279$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $a7f8c6b391092279$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $a7f8c6b391092279$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $a7f8c6b391092279$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $a7f8c6b391092279$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $a7f8c6b391092279$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $a7f8c6b391092279$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $a7f8c6b391092279$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $a7f8c6b391092279$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $a7f8c6b391092279$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $a7f8c6b391092279$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $a7f8c6b391092279$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $a7f8c6b391092279$export$2f6319cf7d736c2a = '#E6EDFA';
const $a7f8c6b391092279$export$95126bc8884d6634 = '#DCE5F5';
const $a7f8c6b391092279$export$8338d8c35d44ff1 = '#CED9EB';
const $a7f8c6b391092279$export$5368d76ae4fbbda7 = '#B8C7E0';
const $a7f8c6b391092279$export$9f0a771d16ec8d36 = '#ABBBD6';
const $a7f8c6b391092279$export$abcf8c38338b4aa5 = '#9FB0CC';
const $a7f8c6b391092279$export$97e81faa16a182c7 = '#8C9CB8';
const $a7f8c6b391092279$export$bfe21c59123ecf33 = '#7988A3';
const $a7f8c6b391092279$export$ee82aa2ea6a1558 = '#67758F';
const $a7f8c6b391092279$export$682927c6ed76be02 = '#56637A';
const $a7f8c6b391092279$export$91fd9994c5be9757 = '#455166';
const $a7f8c6b391092279$export$d281fbfe3cff2df6 = '#3B475C';
const $a7f8c6b391092279$export$3902c91d8b98a753 = '#313D52';
const $a7f8c6b391092279$export$8e8133c1ba5845b5 = '#283447';
const $a7f8c6b391092279$export$33ff357f6620b39 = '#202B3D';
const $a7f8c6b391092279$export$633847cf062b69e0 = '#1B2638';
const $a7f8c6b391092279$export$9776a6e503bdbf76 = '#121A29';
const $a7f8c6b391092279$export$6c813d5160dff5db = '#0E1624';
const $a7f8c6b391092279$export$3d4f271a500072a = '#0D1424';
const $a7f8c6b391092279$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $a7f8c6b391092279$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $a7f8c6b391092279$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $a7f8c6b391092279$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $a7f8c6b391092279$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $a7f8c6b391092279$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $a7f8c6b391092279$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $a7f8c6b391092279$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $a7f8c6b391092279$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $a7f8c6b391092279$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $a7f8c6b391092279$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $a7f8c6b391092279$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $a7f8c6b391092279$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $a7f8c6b391092279$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $a7f8c6b391092279$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $a7f8c6b391092279$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $a7f8c6b391092279$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $a7f8c6b391092279$export$d2adc5dedf09fced = '#292A2E';
const $a7f8c6b391092279$export$f51762073d2bb381 = '#94C748';
const $a7f8c6b391092279$export$95e26d54def96891 = '#B3DF72';



parcelRegister("bEVVW", function(module, exports) {

$parcel$export(module.exports, "normalizeLanguage", () => $4fed610104ef97c9$export$f38728011c178796);

var $8QpSo = parcelRequire("8QpSo");

var $fTglf = parcelRequire("fTglf");
const $4fed610104ef97c9$export$f38728011c178796 = (0, $8QpSo.default)((language)=>{
    if (!language) return '';
    const match = (0, $fTglf.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

});
parcelRegister("fTglf", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $c6e245aeba898e2e$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $c6e245aeba898e2e$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    }
];

});


parcelRegister("gCl68", function(module, exports) {

$parcel$export(module.exports, "default", () => $868e310e7b464206$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $6HXiV = parcelRequire("6HXiV");
var $868e310e7b464206$export$2e2bcd8739ae039 = (0, $6HXiV.default);

});
parcelRegister("6HXiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $23f9107b8996345e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $25Oq3 = parcelRequire("25Oq3");
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $23f9107b8996345e$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.astGenerator = null;
        }
        static{
            this.highlightInstance = (0, $25Oq3.default);
        }
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $2OMIu.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    return AsyncHighlighter;
};

const $23f9107b8996345e$var$asyncGenerator = $23f9107b8996345e$var$generator({
    loader: ()=>(parcelRequire("7t3wc")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $23f9107b8996345e$export$2e2bcd8739ae039 = $23f9107b8996345e$var$asyncGenerator;

});
parcelRegister("25Oq3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a3f60eeac7eb983$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jPgP9 = parcelRequire("jPgP9");

var $39BkO = parcelRequire("39BkO");
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $3a3f60eeac7eb983$var$Highlight = /*#__PURE__*/ (0, $5uXOq.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $jPgP9.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $39BkO.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $3a3f60eeac7eb983$export$2e2bcd8739ae039 = $3a3f60eeac7eb983$var$Highlight;

});
parcelRegister("jPgP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $83f127a4a907a87e$export$2e2bcd8739ae039);

var $3MiM2 = parcelRequire("3MiM2");

var $1BFv0 = parcelRequire("1BFv0");

var $fQLWH = parcelRequire("fQLWH");

var $gmwnr = parcelRequire("gmwnr");
const $83f127a4a907a87e$var$newLineRegex = /\n/g;
function $83f127a4a907a87e$var$getNewLines(str) {
    return str.match($83f127a4a907a87e$var$newLineRegex);
}
function $83f127a4a907a87e$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $gmwnr.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $3MiM2.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $fQLWH.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $83f127a4a907a87e$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $1BFv0.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $1BFv0.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});
parcelRegister("3MiM2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c5ea60b42d5d4bb$export$2e2bcd8739ae039);

var $1BFv0 = parcelRequire("1BFv0");

var $54p18 = parcelRequire("54p18");
function $5c5ea60b42d5d4bb$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $1BFv0.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $54p18.default)(lineNumber));
            return children;
        }
    };
}
var $5c5ea60b42d5d4bb$export$2e2bcd8739ae039 = $5c5ea60b42d5d4bb$var$createLineGenerator;

});
parcelRegister("1BFv0", function(module, exports) {

$parcel$export(module.exports, "default", () => $172b8b54beacc18d$export$2e2bcd8739ae039);

var $54p18 = parcelRequire("54p18");
function $172b8b54beacc18d$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && showLineNumbers) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $54p18.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $54p18.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});
parcelRegister("54p18", function(module, exports) {

$parcel$export(module.exports, "default", () => $3834caf662eda994$export$2e2bcd8739ae039);
function $3834caf662eda994$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});



parcelRegister("fQLWH", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c252c59a03fc27$export$2e2bcd8739ae039);

var $1BFv0 = parcelRequire("1BFv0");
function $59c252c59a03fc27$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $1BFv0.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $59c252c59a03fc27$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("gmwnr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0e0821c048da7b0$export$2e2bcd8739ae039);
function $e0e0821c048da7b0$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch (e) {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});


parcelRegister("39BkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b50830aca1ec5f8b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dMYCB = parcelRequire("dMYCB");
function $b50830aca1ec5f8b$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $dMYCB.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
}

});
parcelRegister("dMYCB", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde6b95e25c7a358$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $UXrz9 = parcelRequire("UXrz9");

var $lmODa = parcelRequire("lmODa");

var $gBK9d = parcelRequire("gBK9d");
function $dde6b95e25c7a358$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $dde6b95e25c7a358$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $lmODa.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $UXrz9.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $gBK9d.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $dde6b95e25c7a358$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});
parcelRegister("UXrz9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6fb86ced30fc4f0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5KCCi = parcelRequire("5KCCi");

var $eMkc6 = parcelRequire("eMkc6");
function $f6fb86ced30fc4f0$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: label,
        tag: $f6fb86ced30fc4f0$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eMkc6.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: skipChildren ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eMkc6.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: skipChildren ? null : bidiCharacter
    });
}
const $f6fb86ced30fc4f0$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("eMkc6", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $6a3ad388ce84f83d$export$a592b67c93d52467);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $cBCgC = parcelRequire("cBCgC");
const $6a3ad388ce84f83d$var$decoration = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Required as otherwise the following bidi characters cause the span
    // to not receive hover events.
    //
    // U+2066 LEFT-TO-RIGHT ISOLATE (when using pseudo element before)
    // U+202E RIGHT-TO-LEFT OVERRIDE' (when using pseudo element after)
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':before': {
        display: 'inline-flex',
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        background: `var(--ds-background-warning, ${(0, $a7f8c6b391092279$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #7F5F01)",
        content: '"<"attr(data-bidi-character-code)">"',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontStyle: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '18px',
        /**
     * Ensures the decoration receives pointer events when it occurs with
     * an ancestor that disables them.
     */ pointerEvents: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover:before': {
        background: `var(--ds-background-warning-hovered, ${(0, $a7f8c6b391092279$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #533F04)"
    }
});
function $6a3ad388ce84f83d$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $6a3ad388ce84f83d$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $6a3ad388ce84f83d$var$decoration,
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        // This is set to true so that the content is not read out by
        // screen readers as the content includes angle brackets for
        // visual decoration purposes.
        // We use a visually hidden `mark` element below for screen readers
        "aria-hidden": "true"
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cBCgC.default), {
        testId: testId && `${testId}--visually-hidden`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("mark", null, bidiCharacterCode)));
}
function $6a3ad388ce84f83d$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("lmODa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dfe4bd40045326b$export$2e2bcd8739ae039);
const $8dfe4bd40045326b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $8dfe4bd40045326b$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($8dfe4bd40045326b$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("gBK9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $b17e0d9de8ef9bb6$export$2e2bcd8739ae039);

var $dMYCB = parcelRequire("dMYCB");
function $b17e0d9de8ef9bb6$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $dMYCB.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});




parcelRegister("7t3wc", function(module, exports) {

let $56fdf880767119f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56fdf880767119f7$var$load("as9qs").then(()=>parcelRequire('5zvIl'));

});




parcelRegister("irzxp", function(module, exports) {

$parcel$export(module.exports, "CopyAction", () => $64e12044af483692$export$958df07cbf9735fc);
$parcel$export(module.exports, "ActionContainer", () => $64e12044af483692$export$37ab3bdebc286ca);

var $5uXOq = parcelRequire("5uXOq");

var $jHTSg = parcelRequire("jHTSg");

var $86vzA = parcelRequire("86vzA");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $8zOmE = parcelRequire("8zOmE");

var $fEogx = parcelRequire("fEogx");
const $64e12044af483692$export$2ce9877c9c1aa16 = {
    PROMPT: 'Copy',
    SUCCESS: 'Copied!',
    FAILURE: 'Copy to clipboard failed'
};
const $64e12044af483692$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)($64e12044af483692$export$2ce9877c9c1aa16.PROMPT);
    const handleSuccess = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.SUCCESS);
    }, [
        setTooltipMessage
    ]);
    const handleError = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.FAILURE);
    }, [
        setTooltipMessage
    ]);
    const writeToClipboard = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        actionSubjectId && (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(source).then(handleSuccess, handleError);
    }, [
        source,
        handleSuccess,
        handleError,
        actionSubjectId
    ]);
    const resetMessage = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.PROMPT);
    }, [
        setTooltipMessage
    ]);
    function shouldRender() {
        if (typeof document !== 'undefined') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return Boolean(navigator?.clipboard?.writeText);
    }
    return shouldRender() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fEogx.Action), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($86vzA))),
        label: tooltipMessage,
        onClick: writeToClipboard,
        onMouseOver: resetMessage,
        onFocus: resetMessage,
        "aria-live": "assertive",
        "aria-atomic": "true",
        name: "Copy"
    }) : null;
};
const $64e12044af483692$var$stopPropagation = (event)=>event.stopPropagation();
const $64e12044af483692$export$37ab3bdebc286ca = ({ children: children })=>/**
	 * This element uses an `onMouseDown` to block event propagation
	 * to its parent but is not itself interactive.
	 */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $64e12044af483692$var$absolutePositionWrapperStyles,
        onMouseDown: $64e12044af483692$var$stopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHTSg.default), {
        label: "actions"
    }, children));
const $64e12044af483692$var$absolutePositionWrapperStyles = (0, $2s57o.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    padding: 'space.050',
    zIndex: 'flag'
});

});
parcelRegister("fEogx", function(module, exports) {

$parcel$export(module.exports, "Action", () => $e6da05ade6347218$export$e19cd5f9376f8cee);

var $5uXOq = parcelRequire("5uXOq");

var $1Seuh = parcelRequire("1Seuh");

var $5KCCi = parcelRequire("5KCCi");
const $e6da05ade6347218$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
    const updateTooltip = (0, $5uXOq.useRef)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        tooltipLabel,
        label
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltipLabel || label;
        },
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
        isLoading: isLoading,
        appearance: "subtle",
        icon: icon,
        label: label,
        spacing: "compact",
        ...buttonProps
    }));
};

});




parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("bTyOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5073396748f92b4e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $5073396748f92b4e$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("5I4tL")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("h8kvT")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $dCLgq = parcelRequire("dCLgq");

var $h8kvT = parcelRequire("h8kvT");

var $5I4tL = parcelRequire("5I4tL");
const $5073396748f92b4e$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5I4tL)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($h8kvT))
});
var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
// for advanced use only
const $5073396748f92b4e$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("h8kvT", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("5I4tL", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("fC09Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb376757c4acc5ab$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3pGSh")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3pGSh")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $dCLgq = parcelRequire("dCLgq");

var $3pGSh = parcelRequire("3pGSh");
const $bb376757c4acc5ab$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3pGSh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3pGSh))
});
var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
// for advanced use only
const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("3pGSh", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("4AdE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $135a9e70a6f11b3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $135a9e70a6f11b3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    },
    serviceHubNotFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-document-title-jsm",
        "defaultMessage": "Service hub not found - Service project"
    },
    serviceHubNotFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-title",
        "defaultMessage": "This service hub isn't available"
    },
    serviceHubNotFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    serviceHubNotFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-action",
        "defaultMessage": "View a list of all service hubs"
    },
    customerHubNotFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-document-title-jsm",
        "defaultMessage": "Customer hub not found - Service project"
    },
    customerHubNotFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-title",
        "defaultMessage": "This customer hub isn't available"
    },
    customerHubNotFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-action",
        "defaultMessage": "View a list of all customer hubs"
    }
});

});



parcelRegister("6Gu2f", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf917cd0ff8fda53$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $3Ypxa = parcelRequire("3Ypxa");

var $dZw8H = parcelRequire("dZw8H");

var $9OXo1 = parcelRequire("9OXo1");

var $iib8U = parcelRequire("iib8U");

var $5N8Mf = parcelRequire("5N8Mf");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cf917cd0ff8fda53$export$2e2bcd8739ae039 = ({ useCommonPageContext: useCommonPageContext = (0, $3Ypxa.useCommonPageContext) })=>{
    const { baseUrl: baseUrl, projectKey: projectKey } = useCommonPageContext();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "viewCustomers",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            viewCustomersScreenVersion: 2,
            edition: tenantContext.appEditions.serviceDesk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iib8U.AppStoreContainer), {
        // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        baseUrl: baseUrl,
        // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        projectKey: projectKey,
        scope: `CUSTOMERS_SPA_APP_${projectKey}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5N8Mf.CustomersApp), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null));
};

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("3Ypxa", function(module, exports) {

$parcel$export(module.exports, "useCommonPageContext", () => $5d709667e47fb9c6$export$682ebac4d54e1a69);

var $gq0sA = parcelRequire("gq0sA");

var $g5X3G = parcelRequire("g5X3G");

var $4R6GH = parcelRequire("4R6GH");
const $5d709667e47fb9c6$export$682ebac4d54e1a69 = (usePageContext = (0, $gq0sA.usePageContext))=>{
    const [{ data: pageContextData, error: error }] = usePageContext();
    const { tenantContext: tenantContext, projectContext: projectContext } = pageContextData || {};
    const { projectKey: projectKey, projectName: projectName, projectId: projectId, projectType: projectType, isProjectSimplified: isProjectSimplified } = projectContext || {};
    const { baseUrl: baseUrl, locale: locale } = tenantContext || {};
    return {
        baseUrl: baseUrl !== undefined ? (0, $g5X3G.toBaseUrl)(baseUrl) : baseUrl,
        error: error,
        locale: locale,
        projectKey: projectKey !== undefined ? (0, $g5X3G.toProjectKey)(projectKey) : projectKey,
        projectName: projectName,
        projectId: projectId != null ? (0, $g5X3G.toProjectId)(projectId.toString()) : projectId,
        projectType: (0, $4R6GH.fg)('jcs_project_type_m3') ? projectType : undefined,
        isProjectSimplified: isProjectSimplified
    };
};

});
parcelRegister("gq0sA", function(module, exports) {

$parcel$export(module.exports, "usePageContext", () => $2299d7a4f1092420$export$9c25024bdfe755f7);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");

var $9OXo1 = parcelRequire("9OXo1");

var $dFOAR = parcelRequire("dFOAR");
const $2299d7a4f1092420$var$getProjectContextResource = ()=>(0, $dxCvy.projectContextResourceWithCache);
const $2299d7a4f1092420$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $324W5.useResourceWithCustomRouterContext)($2299d7a4f1092420$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $dFOAR.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $5uXOq.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    baseUrl: tenantContext.baseUrl,
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});
parcelRegister("dFOAR", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $6c09349e97fba749$export$712ead87353ac687);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $cAofY = parcelRequire("cAofY");
const $6c09349e97fba749$var$getServiceDeskContextResource = ()=>(0, $cAofY.serviceDeskContextResource);
const $6c09349e97fba749$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $324W5.useResourceWithCustomRouterContext)($6c09349e97fba749$var$getServiceDeskContextResource(), customContext);
    (0, $5uXOq.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});



parcelRegister("iib8U", function(module, exports) {

$parcel$export(module.exports, "useAppStore", () => $a75a35961a2ccb73$export$35cd30506bcba883);
$parcel$export(module.exports, "AppStoreContainer", () => $a75a35961a2ccb73$export$b78f26a8c37a0820);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $hg3Cj = parcelRequire("hg3Cj");
const $a75a35961a2ccb73$export$d4c72bab9d6cc13a = {
    userPermissions: undefined,
    searchString: '',
    page: 1,
    pageData: undefined,
    loading: false,
    error: null
};
const $a75a35961a2ccb73$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'CustomerAndOrganizationStore',
    initialState: $a75a35961a2ccb73$export$d4c72bab9d6cc13a,
    actions: $hg3Cj.actions
});
const $a75a35961a2ccb73$export$35cd30506bcba883 = (0, $3sQ5x.createHook)($a75a35961a2ccb73$export$6f57813fe9f31bf9);
const $a75a35961a2ccb73$export$b78f26a8c37a0820 = (0, $gg7kZ.createContainer)($a75a35961a2ccb73$export$6f57813fe9f31bf9, {
    displayName: 'CustomerAndOrganizationContainer',
    onInit: $hg3Cj.onInit
});

});
parcelRegister("hg3Cj", function(module, exports) {

$parcel$export(module.exports, "actions", () => $9738ff86b985ee3d$export$e324594224ef24da);
$parcel$export(module.exports, "onInit", () => $9738ff86b985ee3d$export$13f23e293cec2ec3);

var $apHDx = parcelRequire("apHDx");

var $7Lk9h = parcelRequire("7Lk9h");

var $51hTk = parcelRequire("51hTk");

var $hagIU = parcelRequire("hagIU");
const $9738ff86b985ee3d$export$e324594224ef24da = {
    fetchAndUpdatePageData: $hagIU.fetchAndUpdatePageData,
    updateOptimisticCustomers: $7Lk9h.updateOptimisticCustomers,
    updateSearchString: $51hTk.updateSearchString,
    updatePageNumber: $51hTk.updatePageNumber,
    onResetSearchState: $apHDx.onResetSearchState
};
const $9738ff86b985ee3d$export$13f23e293cec2ec3 = ()=>({ dispatch: dispatch })=>{
        dispatch($9738ff86b985ee3d$export$e324594224ef24da.fetchAndUpdatePageData());
    };

});
parcelRegister("apHDx", function(module, exports) {

$parcel$export(module.exports, "onResetSearchState", () => $3798e4bb5e7a98e5$export$216c684cd7d2babe);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $3798e4bb5e7a98e5$export$216c684cd7d2babe = ()=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            searchString: '',
            page: 1
        });
    };

});

parcelRegister("7Lk9h", function(module, exports) {

$parcel$export(module.exports, "updateOptimisticCustomers", () => $9d353222f12529a9$export$9c21b8152ba49b03);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $9d353222f12529a9$export$9c21b8152ba49b03 = (optimisticCustomerList = [])=>async ({ getState: getState, setState: setState })=>{
        const { loading: loading, pageData: pageData, ...rest } = getState();
        if (!pageData) return;
        setState({
            ...rest,
            pageData: pageData,
            loading: true,
            error: null
        });
        const { customers: customers, total: total, rowsPerPage: rowsPerPage } = pageData;
        // The backend doesn't care if the user tries to add a customer that already
        // exists - it just returns the existing data as if it was just created.
        // This means that we can show the same customer twice, once from `optimisticCustomerList`
        // and the other from the existing entry in `customers`. Use a Map to deduplicate
        // the resulting list while maintaining insertion order
        const customerMap = new Map();
        optimisticCustomerList.forEach((c)=>customerMap.set(c.identifier, c));
        customers.forEach((c)=>customerMap.set(c.identifier, c));
        const deduplicatedCustomersArray = Array.from(customerMap.values());
        const prependUsers = deduplicatedCustomersArray.slice(0, rowsPerPage);
        const updatedPageData = {
            ...pageData,
            customers: prependUsers,
            total: total + prependUsers.length - customers.length
        };
        setState({
            ...getState(),
            pageData: updatedPageData,
            loading: false
        });
    };

});

parcelRegister("51hTk", function(module, exports) {

$parcel$export(module.exports, "updateSearchString", () => $c735ec6e42e57b20$export$762bdf38e87c280d);
$parcel$export(module.exports, "updatePageNumber", () => $c735ec6e42e57b20$export$80051aaa1c551d75);
$parcel$export(module.exports, "updateNoOrgOnly", () => $c735ec6e42e57b20$export$10ac9637ea180c71);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $c735ec6e42e57b20$export$762bdf38e87c280d = (searchString)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            searchString: searchString || '',
            page: 1
        });
    };
const $c735ec6e42e57b20$export$80051aaa1c551d75 = (page)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            page: page || 1
        });
    };
const $c735ec6e42e57b20$export$10ac9637ea180c71 = (noOrgOnly)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            noOrgOnly: noOrgOnly
        });
    };

});

parcelRegister("hagIU", function(module, exports) {

$parcel$export(module.exports, "fetchAndUpdatePageData", () => $ef6c232c2ee4de56$export$fbc9fdbc42b86571);

var $lFKmC = parcelRequire("lFKmC");

var $hGgHi = parcelRequire("hGgHi");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $ijXMg = parcelRequire("ijXMg");

var $ggB2r = parcelRequire("ggB2r");
const $ef6c232c2ee4de56$var$defaultOptions = Object.freeze({});
const $ef6c232c2ee4de56$var$fireSearchSuccessEvent = (analyticsEvent, { isSearchStringEmpty: isSearchStringEmpty })=>{
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'jsmCustomersPageSearch succeeded', {
        isSearchStringEmpty: isSearchStringEmpty
    });
};
// we debounce the success event firing, to more accurately represent a complete search
// as opposed to a search which is triggered mid-way through a user's search term
const $ef6c232c2ee4de56$var$searchSuccessDebounceTime = 2000;
const $ef6c232c2ee4de56$var$debouncedFireSearchSuccessEvent = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))($ef6c232c2ee4de56$var$fireSearchSuccessEvent, $ef6c232c2ee4de56$var$searchSuccessDebounceTime, {
    leading: true,
    trailing: false
});
const $ef6c232c2ee4de56$export$fbc9fdbc42b86571 = ({ createAnalyticsEvent: createAnalyticsEvent } = $ef6c232c2ee4de56$var$defaultOptions)=>async ({ getState: getState, setState: setState }, { baseUrl: baseUrl, projectKey: projectKey })=>{
        const { loading: loading, ...rest } = getState();
        setState({
            ...rest,
            loading: true,
            error: null
        });
        try {
            const signal = (0, $ijXMg.abortControllerUtils).getAbortSignal();
            const shouldFetchUserPermissions = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(rest.userPermissions);
            const { userPermissions: userPermissions, pageData: pageData } = await (0, $ggB2r.fetchCustomers)(baseUrl, projectKey, shouldFetchUserPermissions, rest.searchString, rest.page, signal);
            if (userPermissions) setState({
                ...getState(),
                userPermissions: userPermissions,
                pageData: pageData,
                loading: false
            });
            else setState({
                ...getState(),
                pageData: pageData,
                loading: false
            });
            if (createAnalyticsEvent) {
                const analyticsEvent = createAnalyticsEvent({});
                $ef6c232c2ee4de56$var$debouncedFireSearchSuccessEvent(analyticsEvent, {
                    isSearchStringEmpty: rest.searchString === ''
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            if (err && err.name === 'AbortError') return;
            // Only fire analytics for unexpected errors. In this case the backend really
            // only returns a 403 if the current user doesn't have a valid service desk
            // license or is not an agent in the current project. Such a user shouldn't
            // have access to the customers/orgs page anyway to trigger this fetch action.
            // As such any errors we get here can be considered unexpected, so we log them
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchAndUpdatePageData',
                    packageName: 'jiraServicedeskCustomers',
                    teamName: 'boysenberry'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                ...getState(),
                error: err,
                loading: false
            });
        }
    };

});
parcelRegister("ijXMg", function(module, exports) {

$parcel$export(module.exports, "splitInputTextBySeparator", () => $e79f77fb56bd5260$export$39feb0d4e17bb1a0);
$parcel$export(module.exports, "abortControllerUtils", () => $e79f77fb56bd5260$export$aa8a3296fc0fcc0d);
$parcel$export(module.exports, "isHttpClientErrorResponse", () => $e79f77fb56bd5260$export$2b62e563f0fadcee);

var $jcw0u = parcelRequire("jcw0u");
const $e79f77fb56bd5260$export$1a5a4674dd906e7e = (statusCode)=>statusCode === 0;
const $e79f77fb56bd5260$export$d31fd506ce75fa65 = (statusCode)=>statusCode >= 400 && statusCode < 500;
const $e79f77fb56bd5260$export$53ee51427129200c = (statusCode)=>$e79f77fb56bd5260$export$1a5a4674dd906e7e(statusCode) || $e79f77fb56bd5260$export$d31fd506ce75fa65(statusCode);
const $e79f77fb56bd5260$export$58da9968c3170cb1 = (err)=>{
    if ($e79f77fb56bd5260$export$53ee51427129200c(Number(err.statusCode))) return;
    (0, $jcw0u.default)({
        meta: {
            id: 'helpCenterFetchService',
            packageName: 'jiraServicedeskCustomersOrganizationCommon',
            teamName: 'boysenberry'
        },
        error: err,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $e79f77fb56bd5260$export$39feb0d4e17bb1a0 = (input = '')=>{
    const substrings = input.split(/[\s,;]+/g);
    return substrings.filter((value)=>value.trim());
};
const $e79f77fb56bd5260$export$aa8a3296fc0fcc0d = (()=>{
    let abortController;
    const getAbortSignal = ()=>{
        if (abortController) abortController.abort();
        // AbortController is only supported from Node.js 15
        // and throws error when run in SSR (Node.js 12)
        try {
            abortController = new AbortController();
            return abortController.signal;
        } catch  {
            return null;
        }
    };
    return {
        getAbortSignal: getAbortSignal
    };
})();
const $e79f77fb56bd5260$export$2b62e563f0fadcee = (statusCode)=>statusCode === 0 || statusCode >= 400 && statusCode < 500;

});

parcelRegister("ggB2r", function(module, exports) {

$parcel$export(module.exports, "fetchCustomers", () => $6366ed774adccfed$export$9b3e065657c7cd2e);

var $eusud = parcelRequire("eusud");

var $1DCTm = parcelRequire("1DCTm");
const $6366ed774adccfed$export$9b3e065657c7cd2e = async (baseUrl, projectKey, shouldFetchUserPermissions, query, page, signal)=>{
    const response = await (0, $eusud.performGetRequest)((0, $1DCTm.getUrl)(baseUrl, projectKey, shouldFetchUserPermissions, query, page), {
        method: 'GET',
        signal: signal
    });
    const result = (0, $1DCTm.transformSearchResults)(response);
    return result;
};

});
parcelRegister("1DCTm", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $e0dc568155e89622$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "transformSearchResults", () => $e0dc568155e89622$export$8262399879b151f0);

var $ebyGx = parcelRequire("ebyGx");

var $7MSYo = parcelRequire("7MSYo");
const $e0dc568155e89622$var$stringifyOptions = {
    skipNull: true,
    skipEmptyString: true,
    sort: false
};
const $e0dc568155e89622$export$94df0e59ebebf4a7 = (baseUrl, projectKey, shouldFetchUserPermissions, query = '', page)=>{
    const defaultUrl = `${baseUrl}/rest/servicedesk/1/pages/people/customers/pagination/${projectKey}`;
    if (shouldFetchUserPermissions) return defaultUrl;
    // @ts-expect-error - TS2559 - Type '{ readonly skipNull: true; readonly skipEmptyString: true; readonly sort: false; }' has no properties in common with type 'StringifyOptions'.
    return `${defaultUrl}/search?${(0, $ebyGx.stringify)({
        query: query,
        page: page
    }, $e0dc568155e89622$var$stringifyOptions)}`;
};
const $e0dc568155e89622$export$8262399879b151f0 = (results)=>{
    // @ts-expect-error - TS2339 - Property 'customerResults' does not exist on type 'SearchResult'.
    if (results.customerResults) {
        const { customerResults: // @ts-expect-error - TS2339 - Property 'customerResults' does not exist on type 'SearchResult'.
        customerResults, // @ts-expect-error - TS2339 - Property 'customerInviteDialogueModel' does not exist on type 'SearchResult'.
        customerInviteDialogueModel: { isInviteEmailEnabled: isInviteEmailEnabled }, ...rest } = results;
        return {
            // @ts-expect-error - TS2322 - Type '{ isInviteEmailEnabled: any; results: Customers; query: string; total: number; pageNumber: number; lastDeterminedPaged: number; totalHasBeenDetermined: boolean; resultsPerPage: number; pageRange: number; } | { ...; }' is not assignable to type 'UserPermissions | null'.
            userPermissions: {
                ...rest,
                isInviteEmailEnabled: isInviteEmailEnabled
            },
            pageData: (0, $7MSYo.transformCustomerSearchResults)(customerResults)
        };
    }
    return {
        userPermissions: null,
        // @ts-expect-error - TS2345 - Argument of type 'SearchResult' is not assignable to parameter of type 'PagedSearchResults'.
        pageData: (0, $7MSYo.transformCustomerSearchResults)(results)
    };
};

});
parcelRegister("7MSYo", function(module, exports) {

$parcel$export(module.exports, "isOrganization", () => $01f20dce07925a8e$export$8226e76296c78f74);
$parcel$export(module.exports, "normalizeToOrgProfile", () => $01f20dce07925a8e$export$ae8b88aa7f3c74ec);
$parcel$export(module.exports, "normalizeToUserProfile", () => $01f20dce07925a8e$export$f8cdd0399a1a6e);
$parcel$export(module.exports, "transformCustomerSearchResults", () => $01f20dce07925a8e$export$d727facaab9dd2d9);

var $4jnIy = parcelRequire("4jnIy");
const $01f20dce07925a8e$export$2e44165f1da65304 = ({ type: type })=>type === (0, $4jnIy.PROFILE_TYPES).user;
const $01f20dce07925a8e$export$8226e76296c78f74 = ({ type: type })=>type === (0, $4jnIy.PROFILE_TYPES).organization;
const $01f20dce07925a8e$export$ae8b88aa7f3c74ec = (profile)=>{
    if (profile.type === (0, $4jnIy.PROFILE_TYPES).organization) return profile;
    return undefined;
};
const $01f20dce07925a8e$export$f8cdd0399a1a6e = (profile)=>{
    if (profile.type === (0, $4jnIy.PROFILE_TYPES).user) return profile;
    return undefined;
};
const $01f20dce07925a8e$export$d727facaab9dd2d9 = (searchResults)=>{
    const { results: results, pageNumber: pageNumber, resultsPerPage: resultsPerPage, ...rest } = searchResults;
    return {
        customers: results,
        page: pageNumber,
        rowsPerPage: resultsPerPage,
        ...rest
    };
};

});
parcelRegister("4jnIy", function(module, exports) {

$parcel$export(module.exports, "HAS_LOGGED_IN", () => $2b0f2368324f161c$export$e524939ea46db45f);
$parcel$export(module.exports, "PENDING_LOGIN", () => $2b0f2368324f161c$export$c3a105a524843459);
$parcel$export(module.exports, "NOT_AVAILABLE", () => $2b0f2368324f161c$export$d5f291b4be36f605);
$parcel$export(module.exports, "PROFILE_TYPES", () => $2b0f2368324f161c$export$419b0fc33fbd6ae7);
const $2b0f2368324f161c$export$e524939ea46db45f = 'HAS_LOGGED_IN';
const $2b0f2368324f161c$export$c3a105a524843459 = 'PENDING_LOGIN';
const $2b0f2368324f161c$export$d5f291b4be36f605 = 'NOT_AVAILABLE';
const $2b0f2368324f161c$export$419b0fc33fbd6ae7 = {
    user: 'User',
    organization: 'Organisation'
};

});







parcelRegister("5N8Mf", function(module, exports) {

$parcel$export(module.exports, "CustomersApp", () => $15fbda536a513399$export$8119386408e137b9);

var $5uXOq = parcelRequire("5uXOq");

var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");

var $8RXs9 = parcelRequire("8RXs9");

var $3HwlS = parcelRequire("3HwlS");

var $iqLcb = parcelRequire("iqLcb");

var $3Ypxa = parcelRequire("3Ypxa");

var $3TpKp = parcelRequire("3TpKp");

var $f9F9q = parcelRequire("f9F9q");

var $4R6GH = parcelRequire("4R6GH");

var $iib8U = parcelRequire("iib8U");

var $al3vX = parcelRequire("al3vX");

var $aJvev = parcelRequire("aJvev");

var $dlyOv = parcelRequire("dlyOv");

var $5YiMX = parcelRequire("5YiMX");
const $15fbda536a513399$var$Customers = ({ useCommonPageContext: useCommonPageContext = (0, $3Ypxa.useCommonPageContext), intl: { formatMessage: formatMessage } })=>{
    const { baseUrl: baseUrl, projectKey: projectKey, isProjectSimplified: isProjectSimplified } = useCommonPageContext();
    const [{ userPermissions: userPermissions }, { onResetSearchState: onResetSearchState }] = (0, $iib8U.useAppStore)();
    (0, $5uXOq.useEffect)(()=>()=>{
            onResetSearchState();
        }, [
        onResetSearchState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        xcss: (0, $4R6GH.fg)('jsm-customers-page-floating-search') ? undefined : $15fbda536a513399$var$PageStyle
    }, !(0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f9F9q.Header), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aJvev.HeaderActions), null)
    }, formatMessage((0, $5YiMX.default).customersBreadcrumbTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $al3vX.AccessMessage), {
        // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        baseUrl: baseUrl,
        // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        projectKey: projectKey,
        userPermissions: userPermissions,
        // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        isProjectSimplified: isProjectSimplified
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dlyOv.SearchWithResults), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3TpKp.JsmPageInteractiveEvent), null));
};
const $15fbda536a513399$export$8119386408e137b9 = (0, $8RXs9.default)($15fbda536a513399$var$Customers);
const $15fbda536a513399$var$PageStyle = (0, $2s57o.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100vh - ${(0, $iqLcb.UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT)} - ${(0, $iqLcb.UNSAFE_DO_NOT_USE_BANNER_HEIGHT)})`
});

});
parcelRegister("3TpKp", function(module, exports) {

$parcel$export(module.exports, "JsmPageInteractiveEvent", () => $bbb7386cf97044f2$export$c4ba40c380ee9a11);

var $5uXOq = parcelRequire("5uXOq");

var $5rqex = parcelRequire("5rqex");
const $bbb7386cf97044f2$export$c4ba40c380ee9a11 = (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), args);
$bbb7386cf97044f2$export$c4ba40c380ee9a11.defaultProps = {
    isExpectedToHaveSsr: false,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    withMarks: [],
    extra: {}
};
$bbb7386cf97044f2$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';

});
parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $eyWK5 = parcelRequire("eyWK5");

var $307qF = parcelRequire("307qF");

var $32M8E = parcelRequire("32M8E");

var $iLrcb = parcelRequire("iLrcb");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $iLrcb.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyWK5.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $307qF.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $32M8E.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("307qF", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $60b371e0a217cca9$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $60b371e0a217cca9$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $60b371e0a217cca9$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $aatTc = parcelRequire("aatTc");

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");
function $60b371e0a217cca9$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $60b371e0a217cca9$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $aatTc.default));
    const interactionId = (0, $32M8E.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $lAOer.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $60b371e0a217cca9$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $60b371e0a217cca9$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $32M8E.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $lAOer.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $60b371e0a217cca9$export$f02972da195a43bb(marks, timingsConfig);
        (0, $lAOer.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $aatTc = parcelRequire("aatTc");

var $bl6ih = parcelRequire("bl6ih");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $bl6ih.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $aatTc.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $aatTc = parcelRequire("aatTc");

var $iLrcb = parcelRequire("iLrcb");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $iLrcb.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $iLrcb.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $aatTc.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $32M8E.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $lAOer.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");

var $iLrcb = parcelRequire("iLrcb");
var $kYARE = parcelRequire("kYARE");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $32M8E.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $iLrcb.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $kYARE.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $lAOer.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $32M8E = parcelRequire("32M8E");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $32M8E.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("f9F9q", function(module, exports) {

$parcel$export(module.exports, "Header", () => $bee51de189558169$export$8b251419efc915eb);

var $5uXOq = parcelRequire("5uXOq");

var $cS37j = parcelRequire("cS37j");

var $3Ypxa = parcelRequire("3Ypxa");

var $c9Ngb = parcelRequire("c9Ngb");
const $bee51de189558169$export$8b251419efc915eb = ({ actions: actions, children: children, crumbText: crumbText })=>{
    const { baseUrl: baseUrl, projectKey: projectKey, projectName: projectName } = (0, $3Ypxa.useCommonPageContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        actions: actions,
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c9Ngb.CustomBreadcrumbs), {
            /* @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string' */ baseUrl: baseUrl,
            projectKey: projectKey ?? '',
            projectName: projectName ?? '',
            crumbText: crumbText || ''
        }),
        truncateTitle: true
    }, children);
};
$bee51de189558169$export$8b251419efc915eb.displayName = 'HeaderWithBreadcrumb';

});
parcelRegister("c9Ngb", function(module, exports) {

$parcel$export(module.exports, "CustomBreadcrumbs", () => $3f3eb42f64d872ef$export$686f1edf1ae6303e);

var $5uXOq = parcelRequire("5uXOq");

var $e0Brz = parcelRequire("e0Brz");

var $jS4lj = parcelRequire("jS4lj");

var $c2D8L = parcelRequire("c2D8L");

var $gEFwt = parcelRequire("gEFwt");

var $4R6GH = parcelRequire("4R6GH");
const $3f3eb42f64d872ef$export$686f1edf1ae6303e = ({ baseUrl: baseUrl, projectKey: projectKey, projectName: projectName, crumbText: crumbText })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0Brz.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectName: projectName
    }, crumbText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: crumbText,
            href: (0, $4R6GH.fg)('jsm_customers_directory_page_for_all') ? `${baseUrl}/jira/servicedesk/projects/${projectKey}/organizations` : `${baseUrl}/jira/servicedesk/projects/${projectKey}/customers`,
            type: (0, $4R6GH.fg)('jsm_customers_directory_page_for_all') ? 'servicedeskOrganizationssBreadcrumb' : 'servicedeskCustomersBreadcrumb'
        }
    }) : null));

});


parcelRegister("al3vX", function(module, exports) {

$parcel$export(module.exports, "AccessMessage", () => $8b9ba051d573a4e4$export$8ee72bd493afce87);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $2Eqc8 = parcelRequire("2Eqc8");

var $koVbs = parcelRequire("koVbs");

var $i6z3a = parcelRequire("i6z3a");

var $lFa7T = parcelRequire("lFa7T");
const $8b9ba051d573a4e4$export$8ee72bd493afce87 = ({ baseUrl: baseUrl, projectKey: projectKey, userPermissions: // @ts-expect-error - TS2740 - Type '{}' is missing the following properties from type 'UserPermissions': customerRoleMisconfigured, canAdminister, canAdministerJIRA, outgoingMailConfigured, and 7 more.
userPermissions = {} })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = (0, $i6z3a.useRouterPush)();
    const { canAdminister: canAdminister } = userPermissions;
    if (!canAdminister) return null;
    const customerPermissionUrl = `${baseUrl}/jira/servicedesk/projects/${projectKey}/settings/customer-permissions`;
    const message = (0, $lFa7T.getMessageBasedOnUserPermissionsNew)(userPermissions);
    const onClick = (event)=>{
        push(event, customerPermissionUrl);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        space: "space.025"
    }, formatMessage(message, {
        a: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
                appearance: "link",
                href: customerPermissionUrl,
                spacing: "none",
                onClick: onClick
            }, children)
    }));
};

});
parcelRegister("i6z3a", function(module, exports) {

$parcel$export(module.exports, "useRouterPush", () => $bea86fb27f5b4b9c$export$315039e9daf924e5);

var $5uXOq = parcelRequire("5uXOq");

var $lVJAU = parcelRequire("lVJAU");
const $bea86fb27f5b4b9c$export$315039e9daf924e5 = ()=>{
    const { push: routerPush } = (0, $lVJAU.useRouterActions)();
    const push = (0, $5uXOq.useCallback)((event, ...pushArgs)=>{
        if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
        event.preventDefault();
        routerPush(...pushArgs);
    }, [
        routerPush
    ]);
    return {
        push: push
    };
};

});

parcelRegister("lFa7T", function(module, exports) {

$parcel$export(module.exports, "getMessageBasedOnUserPermissionsNew", () => $b5037b9844d385ab$export$e578f2f6d15240f8);

var $wrCdj = parcelRequire("wrCdj");
const $b5037b9844d385ab$export$e578f2f6d15240f8 = (userPermissions)=>{
    const { serviceDeskPublicSignUp: serviceDeskPublicSignUp, serviceDeskOpenAccess: serviceDeskOpenAccess } = userPermissions;
    // Open: Anyone can raise a request in this service desk. Link to customer permissions page.
    if (serviceDeskPublicSignUp) return (0, $wrCdj.default).publicSignUpAccessMessageJsmNew;
    // Any Existing User: Everyone with an account on this Jira instance is a customer. Link to customer permissions page.
    if (serviceDeskOpenAccess) return (0, $wrCdj.default).openAccessMessageNew;
    // Closed: This service desk is open to customers who are added to the project. Link to customer permissions page.
    return (0, $wrCdj.default).adminAccessMessageJsmNew;
};

});
parcelRegister("wrCdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e2f01454f7a0d57$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2e2f01454f7a0d57$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    publicSignUpAccessMessageJsmNew: {
        "id": "servicedesk-customers.access-message.public-sign-up-access-message-jsm-new",
        "defaultMessage": "Anyone can raise a request in this service project. <a>Change permissions.</a>"
    },
    openAccessMessageNew: {
        "id": "servicedesk-customers.access-message.open-access-message-new",
        "defaultMessage": "Everyone with an account on this Jira instance is a customer. <a>Change permissions.</a>"
    },
    adminAccessMessageJsmNew: {
        "id": "servicedesk-customers.access-message.admin-access-message-jsm-new",
        "defaultMessage": "This service project is open to customers who are added to the project. <a>Change permissions.</a>"
    }
});

});



parcelRegister("aJvev", function(module, exports) {

$parcel$export(module.exports, "HeaderActions", () => $f0c395d8afcca8ed$export$223875819fd7cf93);

var $5uXOq = parcelRequire("5uXOq");

var $jHTSg = parcelRequire("jHTSg");

var $0yZbT = parcelRequire("0yZbT");

var $3Ypxa = parcelRequire("3Ypxa");

var $2ixdL = parcelRequire("2ixdL");

var $hL3xy = parcelRequire("hL3xy");

var $aTrHb = parcelRequire("aTrHb");

var $88YCl = parcelRequire("88YCl");

var $iib8U = parcelRequire("iib8U");

var $8q4uj = parcelRequire("8q4uj");
const $f0c395d8afcca8ed$export$223875819fd7cf93 = ()=>{
    const { baseUrl: baseUrl, projectKey: projectKey } = (0, $3Ypxa.useCommonPageContext)();
    const [{ userPermissions: userPermissions }, { fetchAndUpdatePageData: fetchAndUpdatePageData, updateOptimisticCustomers: updateOptimisticCustomers }] = (0, $iib8U.useAppStore)();
    const { canAdminister: canAdminister, canManageOrganizations: canManageOrganizations, canInvite: canInvite } = userPermissions || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHTSg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hL3xy.CanManageOrganization), {
        canAdminister: canAdminister,
        canManageOrganizations: canManageOrganizations
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8q4uj.AddOrganizationsInlineDialogButton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ixdL.CanInviteCustomers), {
        canInvite: canInvite
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aTrHb.AddCustomersDialogContextProvider), {
        // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        baseUrl: baseUrl,
        // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        projectKey: projectKey,
        userPermissions: userPermissions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $88YCl.AddCustomersInlineDialogButton), {
        onUpdateAppState: fetchAndUpdatePageData,
        onPrependOptimisticCustomers: updateOptimisticCustomers
    })))));
};

});
parcelRegister("2ixdL", function(module, exports) {

$parcel$export(module.exports, "CanInviteCustomers", () => $0c64fce147d41886$export$1b5263a66e3e70c0);

var $5uXOq = parcelRequire("5uXOq");
const $0c64fce147d41886$export$1b5263a66e3e70c0 = ({ children: children, canInvite: canInvite })=>{
    if (canInvite === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return null;
};

});

parcelRegister("hL3xy", function(module, exports) {

$parcel$export(module.exports, "CanManageOrganization", () => $5e263068e499a073$export$ee7e83ff27686f81);

var $5uXOq = parcelRequire("5uXOq");
const $5e263068e499a073$export$ee7e83ff27686f81 = ({ canAdminister: canAdminister, canManageOrganizations: canManageOrganizations, children: children })=>{
    if (canAdminister === true || canManageOrganizations === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return null;
};

});

parcelRegister("aTrHb", function(module, exports) {

$parcel$export(module.exports, "AddCustomersDialogContext", () => $921898aa5c343c71$export$9ed8929522ab3e7d);
$parcel$export(module.exports, "AddCustomersDialogContextProvider", () => $921898aa5c343c71$export$4cba165b9c3121cb);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8L2oS = parcelRequire("8L2oS");

var $88sJn = parcelRequire("88sJn");

var $lKdel = parcelRequire("lKdel");
const $921898aa5c343c71$export$9ed8929522ab3e7d = /*#__PURE__*/ (0, $5uXOq.createContext)([
    {
        isOpen: false,
        customers: [],
        isValidating: false,
        organization: undefined,
        helpCenter: undefined,
        defaultOrganization: undefined,
        customerEmailsInputFieldValue: '',
        userPermissions: undefined,
        emailValidationErrors: null,
        serviceErrors: null,
        emailPresetValue: ''
    },
    {
        togglePopup: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        setCustomers: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        setOrganization: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        setHelpCenter: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        setCustomerEmailsInputFieldValue: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        // @ts-expect-error - TS2322 - Type '(...args: any[]) => void' is not assignable to type '(emails: string[]) => Promise<undefined> | undefined'.
        onValidateCustomerEmails: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        resetForm: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        resetAndCloseForm: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        setEmailPresetValue: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }
]);
const $921898aa5c343c71$export$4cba165b9c3121cb = ({ children: children, baseUrl: baseUrl, projectKey: projectKey, userPermissions: userPermissions, useValidateCustomerEmailsService: useValidateCustomerEmailsService, defaultOrganization: defaultOrganization })=>{
    const [customerEmailsInputFieldValue, setCustomerEmailsInputFieldValue] = (0, $5uXOq.useState)('');
    const [customers, setCustomers] = (0, $5uXOq.useState)([]);
    const [organization, setOrganization] = (0, $5uXOq.useState)();
    const [helpCenter, setHelpCenter] = (0, $5uXOq.useState)();
    const [isOpen, togglePopup, closePopup] = (0, $8L2oS.usePopupController)();
    const [emailPresetValue, setEmailPresetValue] = (0, $5uXOq.useState)('');
    const { loading: isValidating, data: validatedEmails, fetch: onValidateCustomerEmailsAsync, emailValidationErrors: emailValidationErrors, resetEmailValidation: resetEmailValidation, error: serviceErrors, resetError: resetError } = useValidateCustomerEmailsService({
        baseUrl: baseUrl,
        projectKey: projectKey
    });
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen) resetEmailValidation();
    }, [
        isOpen,
        resetEmailValidation
    ]);
    const onValidateCustomerEmails = (0, $5uXOq.useCallback)((emails)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7031 - Binding element 'emailAddress' implicitly has an 'any' type.
        const existingValidatedEmails = customers.map(({ emailAddress: emailAddress })=>emailAddress);
        onValidateCustomerEmailsAsync([
            ...emails,
            ...existingValidatedEmails
        ]);
    }, [
        customers,
        onValidateCustomerEmailsAsync
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen) resetError();
    }, [
        isOpen,
        resetError
    ]);
    const resetForm = (0, $5uXOq.useCallback)(()=>{
        setCustomerEmailsInputFieldValue('');
        setEmailPresetValue('');
        setCustomers([]);
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        setOrganization();
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        setHelpCenter();
    }, []);
    const resetAndCloseForm = (0, $5uXOq.useCallback)(()=>{
        resetForm();
        closePopup();
    }, [
        closePopup,
        resetForm
    ]);
    const state = {
        isOpen: isOpen,
        isValidating: isValidating,
        customers: customers,
        organization: organization,
        helpCenter: helpCenter,
        defaultOrganization: defaultOrganization,
        userPermissions: userPermissions,
        customerEmailsInputFieldValue: customerEmailsInputFieldValue,
        emailValidationErrors: emailValidationErrors,
        serviceErrors: serviceErrors,
        emailPresetValue: emailPresetValue
    };
    const actions = {
        togglePopup: togglePopup,
        setCustomers: setCustomers,
        setOrganization: setOrganization,
        setHelpCenter: setHelpCenter,
        setCustomerEmailsInputFieldValue: setCustomerEmailsInputFieldValue,
        onValidateCustomerEmails: onValidateCustomerEmails,
        resetForm: resetForm,
        resetAndCloseForm: resetAndCloseForm,
        setEmailPresetValue: setEmailPresetValue
    };
    (0, $5uXOq.useEffect)(()=>{
        if (validatedEmails) {
            // We only want validated emails to be prefilled as a list.
            // If we have one invalid email in the valid email list, we will
            // show this in a text area, controlled by emailPreset value
            const invalidCustomers = validatedEmails.filter((customer)=>customer.type === (0, $88sJn.CustomerTypes).invalidCustomer);
            if (invalidCustomers.length === 0) setCustomers(validatedEmails.filter((customer)=>customer.type === (0, $88sJn.CustomerTypes).validCustomer));
            // clear email-text-field value upon validation
            setCustomerEmailsInputFieldValue('');
        }
    }, [
        validatedEmails
    ]);
    return(// @ts-expect-error - TS2322 - Type '{ isOpen: boolean; isValidating: boolean; customers: unknown; organization: unknown; defaultOrganization: Organization | undefined; userPermissions: UserPermissions | undefined; customerEmailsInputFieldValue: string; emailValidationErrors: EmailValidationErrorType; serviceErrors: ServiceError; emailPresetValue: stri...' is not assignable to type 'AddCustomersDialogState'. | TS2322 - Type '{ togglePopup: () => void; setCustomers: React.Dispatch<unknown>; setOrganization: React.Dispatch<unknown>; setCustomerEmailsInputFieldValue: React.Dispatch<React.SetStateAction<string>>; onValidateCustomerEmails: (emails: string[]) => void; resetForm: () => void; resetAndCloseForm: () => void; setEmailPresetValue: ...' is not assignable to type 'AddCustomersDialogActions'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($921898aa5c343c71$export$9ed8929522ab3e7d.Provider, {
        value: [
            state,
            actions
        ]
    }, children));
};
$921898aa5c343c71$export$4cba165b9c3121cb.defaultProps = {
    useValidateCustomerEmailsService: (0, $lKdel.useValidateCustomerEmailsService)
};
$921898aa5c343c71$export$4cba165b9c3121cb.displayName = 'AddCustomersDialogContext';

});
parcelRegister("8L2oS", function(module, exports) {

$parcel$export(module.exports, "usePopupController", () => $2f9ec79b1227b61c$export$55fb67b4e2c495d8);

var $5uXOq = parcelRequire("5uXOq");
const $2f9ec79b1227b61c$export$55fb67b4e2c495d8 = (defaultState = false)=>{
    // TODO one day useBoolean https://hello.atlassian.net/wiki/spaces/JFP/blog/2024/09/01/4131392637/PSA+Write+less+code+-+useBoolean+hook
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultState);
    const togglePopup = (0, $5uXOq.useCallback)(()=>{
        setIsOpen((pendingIsOpen)=>!pendingIsOpen);
    }, [
        setIsOpen
    ]);
    const closePopup = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    return [
        isOpen,
        togglePopup,
        closePopup
    ];
};

});

parcelRegister("88sJn", function(module, exports) {

$parcel$export(module.exports, "CustomerTypes", () => $9a99fc3f795c12ee$export$21437b03a44b5609);
const $9a99fc3f795c12ee$export$21437b03a44b5609 = {
    invalidCustomer: 'invalid-customer',
    validCustomer: 'valid-customer'
};

});

parcelRegister("lKdel", function(module, exports) {

$parcel$export(module.exports, "useValidateCustomerEmailsService", () => $3a74eb536e3e482d$export$3c8f9b12e7ccf671);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $a7EYT = parcelRequire("a7EYT");

var $l1IOq = parcelRequire("l1IOq");
const $3a74eb536e3e482d$export$3c8f9b12e7ccf671 = ({ baseUrl: baseUrl, projectKey: projectKey })=>{
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [data, setData] = (0, $5uXOq.useState)(null);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [emailValidationErrors, setEmailValidationErrors] = (0, $5uXOq.useState)(null);
    const abortController = (0, $5uXOq.useRef)(new AbortController());
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const resetEmailValidation = ()=>{
        setEmailValidationErrors(null);
    };
    const resetError = ()=>{
        setError(null);
    };
    const fetch = (0, $5uXOq.useCallback)(async (emails)=>{
        setLoading(true);
        setError(null);
        resetEmailValidation();
        if (abortController.current && abortController.current.abort) abortController.current.abort();
        try {
            abortController.current = new AbortController();
            const { signal: signal } = abortController.current;
            const response = await (0, $a7EYT.performPostRequest)((0, $l1IOq.getUrl)(baseUrl, projectKey), {
                body: JSON.stringify({
                    emails: emails
                }),
                signal: signal
            });
            const transformedResponse = (0, $l1IOq.transformData)(response);
            setData(transformedResponse);
            setEmailValidationErrors((0, $l1IOq.transformForView)(response));
            setLoading(false);
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `customer ${response.failed.length ? 'addValidationFailed' : 'addValidationSucceeded'}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const { reasonKey: reasonKey, response: response, statusCode: statusCode } = err;
            // Only fire analytics for unexpected errors. ValidationErrors are used when
            // the backend returns a 400. Expected 400 errors from the backend include:
            // - the email address is invalid (eg `bad@email@example.com`)
            // A 403 is also returned if the user doesn't have permission to invite, but
            // we only show the invite button after a permission check -
            // it's an unexpected error if we see it here
            const shouldFireErrorAnalytics = err.statusCode !== 400;
            if (shouldFireErrorAnalytics) (0, $jcw0u.default)({
                error: err,
                meta: {
                    id: 'useValidateCustomerEmailsService',
                    packageName: 'jiraServicedeskCustomersOrganizationCommon',
                    teamName: 'boysenberry'
                },
                sendToPrivacyUnsafeSplunk: true,
                attributes: {
                    reasonKey: reasonKey
                }
            });
            if (response?.failed) setEmailValidationErrors((0, $l1IOq.transformForView)(response));
            if (response?.failed) setData((0, $l1IOq.transformData)(response));
            else setError((0, $l1IOq.transformError)(statusCode) ?? err);
            setLoading(false);
        }
    }, [
        baseUrl,
        createAnalyticsEvent,
        projectKey
    ]);
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceError'.
        error,
        data: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceData<Data>'.
        data,
        fetch: // @ts-expect-error - TS2322 - Type '(emails: string[]) => Promise<void>' is not assignable to type '(() => Promise<void>) & ((ValidateCustomerEmailsRequest: string[]) => Promise<void>)'.
        fetch,
        emailValidationErrors: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'EmailValidationErrorType'.
        emailValidationErrors,
        resetEmailValidation: resetEmailValidation,
        resetError: resetError
    };
};

});
parcelRegister("a7EYT", function(module, exports) {

$parcel$export(module.exports, "JsdFetchError", () => $99def0fa5fc488a1$export$fee0012ae6cb3438);
$parcel$export(module.exports, "performGetRequest", () => $99def0fa5fc488a1$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $99def0fa5fc488a1$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $99def0fa5fc488a1$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $99def0fa5fc488a1$export$8ef51cba9d28f819);

var $gccSB = parcelRequire("gccSB");

var $cjFoH = parcelRequire("cjFoH");

var $5HnTq = parcelRequire("5HnTq");


var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $99def0fa5fc488a1$var$VALIDATION_ERROR_KEY = 'validation.error';
class $99def0fa5fc488a1$export$fee0012ae6cb3438 extends (0, $jJZqs.default) {
    constructor(statusCode, message, reasonKey, response){
        super(statusCode, (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(message) ? `Fetch call failed with status code: ${statusCode}` : message);
        this.name = 'JsdFetchError';
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cjFoH)))(reasonKey)) this.reasonKey = reasonKey;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cjFoH)))(response)) this.response = response;
    }
}
const $99def0fa5fc488a1$var$transformMessageErrorsFromServer = (errors = [])=>errors.reduce((messages, { errorMessage: errorMessage })=>{
        messages.push(errorMessage);
        return messages;
    }, []).join(' ');
const $99def0fa5fc488a1$var$putOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'PUT'
};
const $99def0fa5fc488a1$var$postOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'POST'
};
const $99def0fa5fc488a1$var$deleteOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'DELETE'
};
const $99def0fa5fc488a1$var$patchOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'PATCH'
};
const $99def0fa5fc488a1$var$processResponse = async (response)=>{
    if ((0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977) === response.status) {
        const jsonResponse = await response.json();
        const { errors: errors, reasonKey: reasonKey } = jsonResponse;
        if (reasonKey === $99def0fa5fc488a1$var$VALIDATION_ERROR_KEY) throw (0, $eusud.transformValidationErrorFromServer)(jsonResponse);
        const message = $99def0fa5fc488a1$var$transformMessageErrorsFromServer(errors);
        throw new $99def0fa5fc488a1$export$fee0012ae6cb3438(response.status, message, reasonKey, jsonResponse);
    }
    if (!response.ok) {
        const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
        if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`, traceId);
        else throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`);
    }
    if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $99def0fa5fc488a1$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch(url, {
        ...(0, $5HnTq.defaultOptions),
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$9ead1f9103e6de6b = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$putOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$692a4d9808143175 = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$postOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$8ef51cba9d28f819 = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$deleteOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$52be6ab13d7e758d = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$patchOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;


parcelRegister("l1IOq", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $84a90df7a6e94093$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "transformData", () => $84a90df7a6e94093$export$3ceb62baab058c6b);
$parcel$export(module.exports, "transformForView", () => $84a90df7a6e94093$export$1b944b7015956dad);
$parcel$export(module.exports, "transformError", () => $84a90df7a6e94093$export$78c6267359db7e73);

var $88sJn = parcelRequire("88sJn");
const $84a90df7a6e94093$export$94df0e59ebebf4a7 = (baseUrl, projectKey)=>`${baseUrl}/rest/servicedesk/1/pages/people/customers/pagination/${projectKey}/invite/validate`;
const $84a90df7a6e94093$export$3ceb62baab058c6b = ({ failed: failedCustomerEmails = [], success: successCustomerEmails = [] })=>[
        ...failedCustomerEmails.map((failedCustomerEmail)=>({
                ...failedCustomerEmail,
                type: (0, $88sJn.CustomerTypes).invalidCustomer
            })),
        ...successCustomerEmails.map((successCustomerEmail)=>({
                ...successCustomerEmail,
                type: (0, $88sJn.CustomerTypes).validCustomer
            }))
    ];
const $84a90df7a6e94093$export$1b944b7015956dad = (props)=>{
    const { failed: failed, success: success } = props;
    return {
        failed: failed.map((f)=>f && f.emailAddress),
        passed: success.map((f)=>f && f.emailAddress),
        added: [],
        sent: [],
        failedWithErrors: failed.map((f)=>f && {
                email: f.emailAddress,
                error: f.error
            })
    };
};
const $84a90df7a6e94093$export$78c6267359db7e73 = (statusCode)=>{
    switch(statusCode){
        case 401:
            return {
                reasonKey: 'Unauthorised.',
                reasonCode: '401',
                errors: []
            };
        case 500:
            return {
                reasonKey: 'Internal server error.',
                reasonCode: '500',
                errors: []
            };
        default:
            return null;
    }
};

});



parcelRegister("88YCl", function(module, exports) {

$parcel$export(module.exports, "AddCustomersInlineDialogButton", () => $0e3489529d5abf90$export$4777b350d0f3ed6);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

var $dTCMh = parcelRequire("dTCMh");
const $0e3489529d5abf90$export$4777b350d0f3ed6 = (props)=>{
    const sourceName = props.isOrganizationDefaulted === true ? 'addCustomersToOrganization' : 'addCustomers';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: sourceName,
        sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926),
        attributes: {
            isSpa: true,
            version: 2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTCMh.AddCustomersInlineDialogButton), props));
};

});
parcelRegister("dTCMh", function(module, exports) {

$parcel$export(module.exports, "AddCustomersInlineDialogButton", () => $25194769f769cea5$export$4777b350d0f3ed6);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $cNW3X = parcelRequire("cNW3X");

var $0yZbT = parcelRequire("0yZbT");

var $8dYib = parcelRequire("8dYib");

var $f2BYd = parcelRequire("f2BYd");

var $eHJxW = parcelRequire("eHJxW");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $5oFIy = parcelRequire("5oFIy");

var $l1AX8 = parcelRequire("l1AX8");

var $8L2oS = parcelRequire("8L2oS");

var $jEJ7g = parcelRequire("jEJ7g");

var $3Ypxa = parcelRequire("3Ypxa");

var $ho62W = parcelRequire("ho62W");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");


var $30wAD = parcelRequire("30wAD");

var $7k4W3 = parcelRequire("7k4W3");

var $ane1U = parcelRequire("ane1U");

var $iF6px = parcelRequire("iF6px");

var $evcfb = parcelRequire("evcfb");

var $5lL3K = parcelRequire("5lL3K");
const $25194769f769cea5$export$836d27ce4dd57d44 = ({ isOrganizationDefaulted: isOrganizationDefaulted, onPrependOptimisticCustomers: onPrependOptimisticCustomers, onUpdateAppState: onUpdateAppState })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [showSuccess, setShowSuccess] = (0, $5uXOq.useState)(false);
    const [showError, setShowError] = (0, $5uXOq.useState)(false);
    const [failedEmails, setFailedEmails] = (0, $5uXOq.useState)([]);
    const [successCount, setSuccessCount] = (0, $5uXOq.useState)(0);
    const { projectType: projectType } = (0, $3Ypxa.useCommonPageContext)();
    const isJCS = (0, $jEJ7g.useIsJCSProjectType)(projectType);
    const isInviteRoutingEnabled = !isJCS;
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const workSpaceARI = String((0, $8dYib.JiraWorkspaceAri).create({
        siteId: cloudId,
        activationId: activationId
    }));
    const [queryReference, loadQuery, disposeQuery] = (0, $8Uumt.useQueryLoader)((0, $l1AX8.default));
    const [// @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    { isOpen: isOpen, userPermissions: { isInviteEmailEnabled: isInviteEmailEnabled } = {} }, { resetAndCloseForm: resetAndCloseForm, togglePopup: togglePopup }] = (0, $ane1U.useAddCustomersDialogContext)();
    const [isConfirmationModalOpen, toggleConfirmationModal, closeConfirmationModal] = (0, $8L2oS.usePopupController)();
    const { invitedCustomers: invitedCustomers, error: error, formSubmissionStatus: formSubmissionStatus, isSubmitting: isSubmitting, onFormSubmit: onFormSubmit } = (0, $5lL3K.useFormSubmissionUtils)();
    const setSuccessFlag = (0, $5uXOq.useCallback)(()=>{
        setShowSuccess(true);
        if (invitedCustomers) {
            const success = invitedCustomers?.success || [];
            setSuccessCount(success.length);
        }
    }, [
        invitedCustomers
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isInviteRoutingEnabled) loadQuery({
            cloudId: cloudId,
            workSpaceARI: workSpaceARI
        }, {
            fetchPolicy: 'store-or-network'
        });
        return disposeQuery; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cloudId,
        workSpaceARI
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (formSubmissionStatus === (0, $2422a353ae27ab4c$export$523ddafd4d035371)) {
            resetAndCloseForm();
            setSuccessFlag();
        }
    }, [
        formSubmissionStatus,
        resetAndCloseForm,
        setSuccessFlag
    ]);
    const setErrorFlag = (0, $5uXOq.useCallback)(()=>{
        setShowError(true);
        if (invitedCustomers) {
            const failed = invitedCustomers?.failed || [];
            setFailedEmails(failed.map((failedResponse)=>({
                    email: failedResponse.emailAddress,
                    errorMessage: failedResponse.error
                })));
        }
    }, [
        invitedCustomers
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (formSubmissionStatus === (0, $2422a353ae27ab4c$export$8a5cac0f50542e41)) setErrorFlag();
    }, [
        formSubmissionStatus,
        setErrorFlag
    ]);
    const closePopups = ()=>{
        setShowSuccess(false);
        setShowError(false);
    };
    const renderDialog = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
            messageId: "servicedesk-customers-organization-common.ui.add-customers-dialog.inline-dialog",
            messageType: "transactional",
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iF6px.AddCustomersForm), {
                isConfirmationModalOpen: isConfirmationModalOpen,
                onCloseConfirmationModal: closeConfirmationModal,
                onToggleConfirmationModal: toggleConfirmationModal,
                onUpdateAppState: onUpdateAppState,
                onPrependOptimisticCustomers: onPrependOptimisticCustomers,
                isOrganizationDefaulted: isOrganizationDefaulted,
                invitedCustomers: invitedCustomers,
                error: error,
                isSubmitting: isSubmitting,
                onFormSubmit: onFormSubmit,
                formSubmissionStatus: formSubmissionStatus,
                queryRef: queryReference,
                isCustomerInvitationSupported: !isJCS
            }),
            isOpen: isOpen,
            onClose: ({ event: event })=>{
                // don't allow in-line dialog to close if close event is triggered from AkSelect.
                // don't allow in-line dialog to close if confirmation modal is opened on top of dialog
                // @ts-expect-error - TS2345 - Argument of type 'Event' is not assignable to parameter of type 'MouseEvent'.
                if ((0, $30wAD.isEventFromOrganizationSelectDropList)(event) || isConfirmationModalOpen) return;
                togglePopup();
            },
            placement: isOrganizationDefaulted === true ? 'bottom-start' : 'bottom-end'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
            testId: "servicedesk-customers-organization-common.ui.add-customers-dialog.button",
            onClick: togglePopup,
            appearance: "primary"
        }, formatMessage((0, $evcfb.default).addCustomers)));
    const Trigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
            ...triggerProps,
            testId: "servicedesk-customers-organization-common.ui.add-customers-dialog.button",
            onClick: togglePopup,
            appearance: "primary"
        }, formatMessage((0, $evcfb.default).addCustomers)), [
        formatMessage,
        togglePopup
    ]);
    const renderPopup = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
            messageId: "servicedesk-customers-organization-common.ui.add-customers-dialog.popup",
            messageType: "transactional",
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25194769f769cea5$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iF6px.AddCustomersForm), {
                    isConfirmationModalOpen: isConfirmationModalOpen,
                    onCloseConfirmationModal: closeConfirmationModal,
                    onToggleConfirmationModal: toggleConfirmationModal,
                    onUpdateAppState: onUpdateAppState,
                    onPrependOptimisticCustomers: onPrependOptimisticCustomers,
                    isOrganizationDefaulted: isOrganizationDefaulted,
                    invitedCustomers: invitedCustomers,
                    error: error,
                    isSubmitting: isSubmitting,
                    onFormSubmit: onFormSubmit,
                    formSubmissionStatus: formSubmissionStatus,
                    queryRef: queryReference,
                    isCustomerInvitationSupported: !isJCS
                })),
            isOpen: isOpen,
            onClose: togglePopup,
            placement: isOrganizationDefaulted === true ? 'bottom-start' : 'bottom-end',
            trigger: Trigger
        });
    const generalSuccessDescription = formatMessage((0, $evcfb.default).addedCustomersDescriptionNew);
    const inviteDisabled = formatMessage((0, $evcfb.default).addedCustomersWhenEmailDisabled);
    const successDescription = isInviteEmailEnabled ? generalSuccessDescription : inviteDisabled;
    const flagTitle = isInviteRoutingEnabled ? formatMessage((0, $evcfb.default).addedCustomersNewMultipleHelpCenters, {
        count: successCount
    }) : formatMessage((0, $evcfb.default).addedCustomersNew, {
        count: successCount
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, isInviteRoutingEnabled ? renderPopup() : renderDialog(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f2BYd.default), {
        onDismissed: closePopups
    }, showSuccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7k4W3.SuccessFlag), {
        title: flagTitle,
        description: successDescription,
        onDismissed: closePopups,
        key: successCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        actionSubject: "customer",
        action: "inviteSuccess"
    }))), showError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ho62W.AsyncInviteFailed), {
        failedEmails: failedEmails,
        onClosed: closePopups
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        actionSubject: "customer",
        action: "inviteFailed"
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $25194769f769cea5$var$ContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qpxbi _u5f31ejb _n3tdpxbi _19bv1ejb _c71ldgin",
            __cmplp.className
        ])
    });
});
const $25194769f769cea5$export$4777b350d0f3ed6 = $25194769f769cea5$export$836d27ce4dd57d44;

});
parcelRegister("f2BYd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3780c7e328dbb70e$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$3780c7e328dbb70e$export$2e2bcd8739ae039 = (0, $3KRpp.FlagGroup);

});

parcelRegister("eHJxW", function(module, exports) {

$parcel$export(module.exports, "JiraInlineDialog", () => $51c10262cffee11f$export$7ab52478615504b3);

var $5uXOq = parcelRequire("5uXOq");

var $55tuP = parcelRequire("55tuP");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $5uVz7 = parcelRequire("5uVz7");
const $51c10262cffee11f$export$7ab52478615504b3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uVz7.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $55tuP.default), rest);
};

});
parcelRegister("5uVz7", function(module, exports) {

$parcel$export(module.exports, "ChoreographerInlineDialog", () => $aa901de21f3fc2ba$export$44a404f218b0e66e);

var $55tuP = parcelRequire("55tuP");

var $fG5AJ = parcelRequire("fG5AJ");
const $aa901de21f3fc2ba$export$44a404f218b0e66e = (0, $fG5AJ.withChoreographedToggle)((0, $55tuP.default), 'isOpen', 'content');

});


parcelRegister("l1AX8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e978b7d3f923362f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ba2e3b5ca8459f4d7f7dc8bb79612586>>
 * @relayHash d17b7d02c56efacfe603b2d440c2fd0a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c26ce19a32f11e4aa97daae63596d4acca03a0b1e74f76dbaa843ef1ba26c337
const $e978b7d3f923362f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "workSpaceARI"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "workspaceAri",
            "variableName": "workSpaceARI"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEnabled"
            }
        ],
        "type": "HelpCentersConfig"
    }, v5 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v6 = {
        "kind": "ScalarField",
        "name": "message"
    }, v7 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "extendedFormContentMultiHcEntitlementQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCentersConfig",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "extendedFormContentMultiHcEntitlementQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCentersConfig",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c26ce19a32f11e4aa97daae63596d4acca03a0b1e74f76dbaa843ef1ba26c337",
            "metadata": {},
            "name": "extendedFormContentMultiHcEntitlementQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e978b7d3f923362f$var$node.hash = "8f923ba417e51d30e9f4d5e3995b1ad1";
var $e978b7d3f923362f$export$2e2bcd8739ae039 = $e978b7d3f923362f$var$node;

});

parcelRegister("ho62W", function(module, exports) {

$parcel$export(module.exports, "AsyncInviteFailed", () => $ece250163b680dee$export$792469666d9a4f5e);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $hL7JE = parcelRequire("hL7JE");

var $9noxX = parcelRequire("9noxX");

var $il7f6 = parcelRequire("il7f6");
const $ece250163b680dee$export$792469666d9a4f5e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hL7JE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jsm-customers-common-invite-failed",
        packageName: "jira-servicedesk-customers-common-invite-failed",
        fallback: "unmount",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9noxX.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $il7f6.AsyncLazyInviteFailed), props))));

});
parcelRegister("il7f6", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyInviteFailed", () => $0ee6341c627f0f30$export$f7f954a76e72fe86);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $0ee6341c627f0f30$var$AsyncInviteFailed = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("6FHHO")), {
    moduleId: "./src/packages/servicedesk/customers-common-invite-failed/src/ui/invite-failed/main.tsx"
});
const $0ee6341c627f0f30$export$f7f954a76e72fe86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "customers-invite-failed-dialog",
        packageName: "jira-servicedesk-customers-organization-common"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "servicedesk-customers-invite-failed",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ee6341c627f0f30$var$AsyncInviteFailed, props)));

});
parcelRegister("6FHHO", function(module, exports) {

let $4db87976d5ef4252$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4db87976d5ef4252$var$load("U2xlR").then(()=>parcelRequire('ja7Mg'));

});



const $2422a353ae27ab4c$export$f5940ec982f5760a = 'PendingSubmission';
const $2422a353ae27ab4c$export$523ddafd4d035371 = 'Successful';
const $2422a353ae27ab4c$export$8a5cac0f50542e41 = 'Unsuccessful';

parcelRegister("30wAD", function(module, exports) {

$parcel$export(module.exports, "mapOrganizationsToLabelOptions", () => $9c029ba4f0c6247b$export$f2e5b457ef82caef);
$parcel$export(module.exports, "isSelectedOptionValid", () => $9c029ba4f0c6247b$export$970d68ac829ec175);
$parcel$export(module.exports, "isEventFromOrganizationSelectDropList", () => $9c029ba4f0c6247b$export$8a1d1ca8a66dea73);

var $hGgHi = parcelRequire("hGgHi");

var $4R6GH = parcelRequire("4R6GH");

var $1SYUy = parcelRequire("1SYUy");

const $9c029ba4f0c6247b$export$f2e5b457ef82caef = (organizations, formatMessage, { shouldLockScimOrganization: shouldLockScimOrganization })=>{
    return organizations.map(({ id: id, name: name, numberOfOtherProjects: numberOfOtherProjects, scimManaged: scimManaged = false })=>shouldLockScimOrganization && (0, $4R6GH.fg)('jsm_lock_scim_managed_customer_and_org') ? {
            label: name,
            name: name,
            status: `${numberOfOtherProjects > 0 ? formatMessage((0, $1SYUy.default).inOtherProjects, {
                numberOfOtherProjects: numberOfOtherProjects
            }) : ''}`,
            value: id,
            numberOfOtherProjects: numberOfOtherProjects,
            scimManaged: scimManaged,
            isDisabled: scimManaged
        } : {
            label: name,
            name: name,
            status: `${numberOfOtherProjects > 0 ? formatMessage((0, $1SYUy.default).inOtherProjects, {
                numberOfOtherProjects: numberOfOtherProjects
            }) : ''}`,
            value: id,
            numberOfOtherProjects: numberOfOtherProjects
        }).sort((a, b)=>{
        if (Boolean(a.scimManaged) === Boolean(b.scimManaged)) return a.name.localeCompare(b.name);
        return a.scimManaged ? 1 : -1;
    });
};
const $9c029ba4f0c6247b$export$970d68ac829ec175 = (options, selectedOption)=>{
    if (!selectedOption) return true;
    const optionExistInList = options.some(({ name: name })=>name.toLowerCase() === selectedOption.name.toLowerCase());
    return !optionExistInList;
};
const $9c029ba4f0c6247b$export$8a1d1ca8a66dea73 = (event)=>{
    if (event && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(event.target)) {
        // @ts-expect-error - TS2339 - Property 'classList' does not exist on type 'EventTarget'.
        const { classList: classList } = event.target;
        return classList.contains(`${(0, $f5221490a3db223e$export$60fb28d4aee3606e)}__option`) || classList.contains(`${(0, $f5221490a3db223e$export$60fb28d4aee3606e)}__menu-notice`) && (0, $4R6GH.fg)('jcs_master_flag');
    }
    return false;
};

});
parcelRegister("1SYUy", function(module, exports) {

$parcel$export(module.exports, "default", () => $bec9e1e32503acd3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bec9e1e32503acd3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    inOtherProjects: {
        "id": "servicedesk-customers-organization-common.common.organizations-select-field.in-other-projects",
        "defaultMessage": "in {numberOfOtherProjects, plural, one {# project} other { # other projects}}"
    },
    somethingWentWrong: {
        "id": "servicedesk-customers-organization-common.common.organizations-select-field.something-went-wrong",
        "defaultMessage": "Something went wrong. Check your connection, then give it another try."
    }
});

});

const $f5221490a3db223e$export$60fb28d4aee3606e = 'serviceDeskOrganizationSelect';


parcelRegister("7k4W3", function(module, exports) {

$parcel$export(module.exports, "SuccessFlag", () => $e4cdcd693599f75e$export$93bd4963a1d00fd5);

var $5uXOq = parcelRequire("5uXOq");

var $bMdrA = parcelRequire("bMdrA");

var $3FbMI = parcelRequire("3FbMI");
const $e4cdcd693599f75e$export$93bd4963a1d00fd5 = ({ title: title, description: description, onDismissed: onDismissed })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3FbMI.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))), {
            spacing: "spacious",
            color: "var(--ds-icon-success, #22A06B)",
            label: "Success"
        }),
        title: title,
        description: description,
        id: Math.random(),
        onDismissed: onDismissed,
        testId: "servicedesk-customers-organization-common.common.ui.success-flag.success-flag",
        messageId: "servicedesk-customers-organization-common.common.ui.success-flag.flag",
        messageType: "transactional"
    });

});
parcelRegister("3FbMI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9654ec4b7b2f42c6$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$9654ec4b7b2f42c6$export$2e2bcd8739ae039 = (0, $3KRpp.SuccessAutoDismissFlag);

});


parcelRegister("ane1U", function(module, exports) {

$parcel$export(module.exports, "useAddCustomersDialogContext", () => $ab72369087e8b230$export$8303be3e6da4917b);

var $5uXOq = parcelRequire("5uXOq");

var $aTrHb = parcelRequire("aTrHb");
const $ab72369087e8b230$export$8303be3e6da4917b = ()=>(0, $5uXOq.useContext)((0, $aTrHb.AddCustomersDialogContext));

});

parcelRegister("iF6px", function(module, exports) {

$parcel$export(module.exports, "AddCustomersForm", () => $5d09abef73f9ff08$export$6cf1c0f31a72e7e3);

var $5uXOq = parcelRequire("5uXOq");

var $7folp = parcelRequire("7folp");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $clxo5 = parcelRequire("clxo5");

var $lfTZh = parcelRequire("lfTZh");

var $5oFIy = parcelRequire("5oFIy");

var $6Bva3 = parcelRequire("6Bva3");

var $ane1U = parcelRequire("ane1U");

var $aAhYy = parcelRequire("aAhYy");

var $5b6Q1 = parcelRequire("5b6Q1");

var $h6oAV = parcelRequire("h6oAV");
const $5d09abef73f9ff08$export$6cf1c0f31a72e7e3 = ({ isConfirmationModalOpen: isConfirmationModalOpen, isOrganizationDefaulted: isOrganizationDefaulted, onToggleConfirmationModal: onToggleConfirmationModal, onPrependOptimisticCustomers: onPrependOptimisticCustomers, onCloseConfirmationModal: onCloseConfirmationModal, onUpdateAppState: onUpdateAppState, formSubmissionStatus: formSubmissionStatus, invitedCustomers: invitedCustomers, error: error, isSubmitting: isSubmitting, onFormSubmit: onFormSubmit, queryRef: queryRef, isCustomerInvitationSupported: isCustomerInvitationSupported = true })=>{
    const [{ organization: organization, defaultOrganization: defaultOrganization }] = (0, $ane1U.useAddCustomersDialogContext)();
    const onSubmit = (0, $5uXOq.useCallback)(()=>{
        const selectedOrganization = organization || defaultOrganization;
        if (selectedOrganization && selectedOrganization.numberOfOtherProjects > 0) onToggleConfirmationModal();
        else onFormSubmit();
    }, [
        defaultOrganization,
        onFormSubmit,
        onToggleConfirmationModal,
        organization
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!invitedCustomers) return;
        const { optimisticCustomerListUpdateResults: optimisticCustomerListUpdateResults, failed: failed } = invitedCustomers;
        // prepend customers only if there is no selected organization
        // or if there are no failed invited customers
        const shouldPrependOptimisticCustomers = (isOrganizationDefaulted === true || !organization) && !failed.length;
        if (shouldPrependOptimisticCustomers) onPrependOptimisticCustomers(optimisticCustomerListUpdateResults);
        else onUpdateAppState();
    }, [
        invitedCustomers,
        isOrganizationDefaulted,
        onPrependOptimisticCustomers,
        onUpdateAppState,
        organization
    ]);
    const formContentProps = {
        error: error,
        invitedCustomers: invitedCustomers,
        formSubmissionStatus: formSubmissionStatus,
        isSubmitting: isSubmitting,
        isOrganizationDefaulted: isOrganizationDefaulted,
        isCustomerInvitationSupported: isCustomerInvitationSupported
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Bva3.DialogWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7folp.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
            ...formProps,
            name: "add-customers-form",
            "data-testId": "servicedesk-organization-details.common.ui.add-customers-dialog.form.form"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "add-customers-popup",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                xcss: $5d09abef73f9ff08$var$spinnerWrapStyle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
                size: "medium"
            }))
        }, queryRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5b6Q1.ExtendedFormContent), {
            queryRef: queryRef,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h6oAV.FormContent), {
                    ...formContentProps,
                    ...props
                })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h6oAV.FormContent), {
            ...formContentProps,
            hasMultiHcAndInviteRouting: false
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aAhYy.ConfirmationModal), {
            isOpen: isConfirmationModalOpen,
            onConfirm: onFormSubmit,
            onClose: onCloseConfirmationModal
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
$5d09abef73f9ff08$export$6cf1c0f31a72e7e3.displayName = 'AddCustomersDialogContent';
const $5d09abef73f9ff08$var$spinnerWrapStyle = (0, $2s57o.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '348px'
});

});
parcelRegister("6Bva3", function(module, exports) {

$parcel$export(module.exports, "DialogWrapper", () => $515ee9858c5a3486$export$2c5463a7353cb944);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $515ee9858c5a3486$export$2c5463a7353cb944 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _1bsbnklw _o5724jg8 _c71l1kw7 _p12f1kw7",
            __cmplp.className
        ])
    });
});

});

parcelRegister("aAhYy", function(module, exports) {

$parcel$export(module.exports, "ConfirmationModal", () => $314301ec5dee8808$export$1f33f980da756c46);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");
var $kW74I = parcelRequire("kW74I");

var $7NYq5 = parcelRequire("7NYq5");

var $9fuVs = parcelRequire("9fuVs");

var $koVbs = parcelRequire("koVbs");

var $ane1U = parcelRequire("ane1U");

var $743ZE = parcelRequire("743ZE");
const $314301ec5dee8808$export$1f33f980da756c46 = ({ useAddCustomersDialogContext: useAddCustomersDialogContext, isOpen: isOpen, onConfirm: onConfirm, onClose: onClose })=>{
    const [{ organization: organization, defaultOrganization: defaultOrganization }] = useAddCustomersDialogContext();
    const selectedOrganization = organization || defaultOrganization;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onConfirmAndClose = ()=>{
        onConfirm();
        onClose();
    };
    const actions = [
        {
            text: formatMessage((0, $743ZE.default).addCustomers),
            onClick: onConfirmAndClose,
            'data-test-id': 'servicedesk-customers-organization-common.ui.add-customers-dialog.form.confirmation-modal.confirm-add-customers-to-multiple-projects'
        },
        {
            text: formatMessage((0, $743ZE.default).cancel),
            onClick: onClose,
            'data-test-id': 'servicedesk-customers-organization-common.ui.add-customers-dialog.form.confirmation-modal.cancel-add-customers-to-multiple-projects'
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kW74I.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "servicedesk-customers-organization-common.ui.add-customers-dialog.form.confirmation-modal.modal-dialog",
        messageType: "transactional",
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUaFh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Sb4G.default), null, formatMessage((0, $743ZE.default).confirmationTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1QfP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($314301ec5dee8808$var$ModalContentWrapper, null, formatMessage((0, $743ZE.default).multipleProjectOrganization, selectedOrganization))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CjwE.default), null, actions.map((props, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
            key: index,
            ...props,
            autoFocus: index === 0,
            appearance: index === 0 ? 'primary' : 'subtle'
        }, props.text)).reverse()))));
};
$314301ec5dee8808$export$1f33f980da756c46.defaultProps = {
    useAddCustomersDialogContext: (0, $ane1U.useAddCustomersDialogContext)
}; // eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $314301ec5dee8808$var$ModalContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.className
        ])
    });
});

});
parcelRegister("743ZE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6ecf249cb793fe7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c6ecf249cb793fe7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    confirmationTitle: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.confirmation-modal.confirmation-title",
        "defaultMessage": "Add customer to multiple projects"
    },
    multipleProjectOrganization: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.confirmation-modal.multiple-project-organization",
        "defaultMessage": "The organization {name} is used in {numberOfOtherProjects, plural, one {# project} other {# projects}}. Customers you add to it can view requests shared with the organization and raise their own requests in those projects."
    },
    addCustomers: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.confirmation-modal.add-customers",
        "defaultMessage": "Add customers"
    },
    cancel: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.confirmation-modal.cancel",
        "defaultMessage": "Cancel"
    }
});

});


parcelRegister("5b6Q1", function(module, exports) {

$parcel$export(module.exports, "ExtendedFormContent", () => $b3194e8183928829$export$427282f4d8726cae);

var $l1AX8 = parcelRequire("l1AX8");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $ijXMg = parcelRequire("ijXMg");
const $b3194e8183928829$var$logError = (err)=>{
    (0, $jcw0u.default)({
        meta: {
            id: 'entitlementServiceFetch',
            packageName: 'jiraServicedeskCustomersOrganizationCommon',
            teamName: 'boysenberry'
        },
        error: err,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $b3194e8183928829$var$ExtendedFormContentContainer = (props)=>{
    const formContentMultihcViewQueryData = (0, $8Uumt.usePreloadedQuery)((0, $l1AX8.default), props.queryRef);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [hasMultiHcAndInviteRouting, setHasMultiHcAndInviteRouting] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasMultiHcAndInviteRouting && formContentMultihcViewQueryData) {
            let updatedMultiHcAndInviteRouting = false;
            const helpCenterConfig = formContentMultihcViewQueryData?.helpCenter?.helpCentersConfig;
            if (!helpCenterConfig) // This could occur when the request did not reach Kosh
            $b3194e8183928829$var$logError(new Error(`Missing required fields in entitlement response, possibly an AGG error. ${JSON.stringify(formContentMultihcViewQueryData)}`));
            else if (helpCenterConfig.__typename === 'HelpCentersConfig') {
                const { isEnabled: isEnabled } = helpCenterConfig;
                updatedMultiHcAndInviteRouting = isEnabled;
                const analyticsEvent = createAnalyticsEvent({});
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'entitlement APICallSuccess', {
                    source: 'entitlementServiceFetch',
                    hasMultiHcAndInviteRouting: isEnabled
                });
            } else if (helpCenterConfig.__typename === 'QueryError') {
                const { identifier: identifier, message: message, extensions: extensions } = helpCenterConfig;
                const { errorType: errorType, statusCode: statusCode } = extensions?.[0] || {};
                if (!(0, $ijXMg.isHttpClientErrorResponse)(Number(statusCode))) $b3194e8183928829$var$logError(new Error(`QueryError: ${JSON.stringify({
                    identifier: identifier,
                    message: message,
                    errorType: errorType,
                    statusCode: statusCode
                })}`));
            }
            if (updatedMultiHcAndInviteRouting !== hasMultiHcAndInviteRouting) setHasMultiHcAndInviteRouting(updatedMultiHcAndInviteRouting);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formContentMultihcViewQueryData,
        hasMultiHcAndInviteRouting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.render({
        hasMultiHcAndInviteRouting: hasMultiHcAndInviteRouting
    }));
};
const $b3194e8183928829$export$427282f4d8726cae = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "add-customer-entitlement-check",
        fallback: ()=>props.render({
                hasMultiHcAndInviteRouting: false
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3194e8183928829$var$ExtendedFormContentContainer, props));

});

parcelRegister("h6oAV", function(module, exports) {

$parcel$export(module.exports, "FormContent", () => $3ba74d4c8e54a9e2$export$6ed20265bd6496f6);

var $5uXOq = parcelRequire("5uXOq");

var $9rZBe = parcelRequire("9rZBe");
var $3AbYh = parcelRequire("3AbYh");
var $cUUCJ = parcelRequire("cUUCJ");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $jEJ7g = parcelRequire("jEJ7g");

var $3Ypxa = parcelRequire("3Ypxa");

var $7C6Nf = parcelRequire("7C6Nf");

var $hL3xy = parcelRequire("hL3xy");

var $38Kqf = parcelRequire("38Kqf");

var $ane1U = parcelRequire("ane1U");

var $gkrVw = parcelRequire("gkrVw");

var $dvTr0 = parcelRequire("dvTr0");

var $lJbR5 = parcelRequire("lJbR5");

var $hSL8E = parcelRequire("hSL8E");

var $7E0iL = parcelRequire("7E0iL");
const $3ba74d4c8e54a9e2$export$6ed20265bd6496f6 = ({ isSubmitting: isSubmitting, isOrganizationDefaulted: isOrganizationDefaulted, error: formErrors, hasMultiHcAndInviteRouting: hasMultiHcAndInviteRouting, isCustomerInvitationSupported: isCustomerInvitationSupported = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ userPermissions: { canAdminister: // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    canAdminister, canManageOrganizations: // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    canManageOrganizations, outgoingMailConfigured: // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    outgoingMailConfigured, isInviteEmailEnabled: // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    isInviteEmailEnabled } = {}, serviceErrors: serviceErrors, helpCenter: helpCenter }, { resetAndCloseForm: resetAndCloseForm, setHelpCenter: setHelpCenter }] = (0, $ane1U.useAddCustomersDialogContext)();
    const requiredField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $3ba74d4c8e54a9e2$var$requiredFieldStyles
    }, formatMessage((0, $7E0iL.default).requiredField), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cUUCJ.default), null));
    const { projectType: projectType } = (0, $3Ypxa.useCommonPageContext)();
    const isJcs = (0, $jEJ7g.useIsJCSProjectType)(projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9rZBe.default), {
        title: formatMessage((0, $7E0iL.default).addCustomers)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gkrVw.CustomerNotificationHelpText), {
        isAdmin: canAdminister,
        isOutgoingMailEnabled: outgoingMailConfigured,
        isInviteEmailEnabled: isInviteEmailEnabled,
        isMultiHcAndInviteRoutingEnabled: hasMultiHcAndInviteRouting,
        isCustomerInvitationSupported: isCustomerInvitationSupported,
        isJcs: isJcs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3AbYh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $3ba74d4c8e54a9e2$var$noOverflowX
    }, hasMultiHcAndInviteRouting && requiredField, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dvTr0.DynamicInputField), null), hasMultiHcAndInviteRouting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C6Nf.HelpCenterSelectField), {
        selectedHelpCenter: helpCenter,
        setSelectedHelpCenter: setHelpCenter
    }), isOrganizationDefaulted !== true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hL3xy.CanManageOrganization), {
        canAdminister: canAdminister,
        canManageOrganizations: canManageOrganizations
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJbR5.OrganizationsSelectField), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Kqf.FormErrors), {
        formErrors: formErrors,
        serviceError: serviceErrors
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hSL8E.Footer), {
        isLoading: isSubmitting,
        onCancel: resetAndCloseForm,
        hasMultiHcAndInviteRouting: hasMultiHcAndInviteRouting
    }))));
};
const $3ba74d4c8e54a9e2$var$requiredFieldStyles = (0, $2s57o.xcss)({
    marginBottom: 'space.200'
});
const $3ba74d4c8e54a9e2$var$noOverflowX = (0, $2s57o.xcss)({
    overflowX: 'hidden'
});

});
parcelRegister("9rZBe", function(module, exports) {

$parcel$export(module.exports, "default", () => $50f2e2cd53a22261$export$2e2bcd8739ae039);
/* form-header.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-primitives */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bWfiu = parcelRequire("bWfiu");
const $50f2e2cd53a22261$var$formHeaderContentStyles = null;
const $50f2e2cd53a22261$var$formHeaderDescriptionStyles = null;
/**
 * __Form header__.
 *
 * A form header contains the form component's heading and subheadings. This provides the correct padding
 * and styling for it.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $50f2e2cd53a22261$var$FormHeader = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        children: [
            title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                size: "large",
                children: title
            }),
            description && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_1pfhu2gc"
                ]),
                children: description
            }),
            children && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_1ul91osq _1pfhu2gc"
                ]),
                children: children
            })
        ]
    });
};
var $50f2e2cd53a22261$export$2e2bcd8739ae039 = $50f2e2cd53a22261$var$FormHeader;

});

parcelRegister("7C6Nf", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSelectField", () => $9a8dc6a328732aa2$export$53a0ffb611752140);

var $5uXOq = parcelRequire("5uXOq");

var $6ggyj = parcelRequire("6ggyj");

var $k5Wbc = parcelRequire("k5Wbc");
var $4EHpO = parcelRequire("4EHpO");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $lau8t = parcelRequire("lau8t");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");


var $amGzE = parcelRequire("amGzE");

var $hkhLC = parcelRequire("hkhLC");

var $iHVIl = parcelRequire("iHVIl");

var $dP9D8 = parcelRequire("dP9D8");
const $9a8dc6a328732aa2$var$HelpCenterSelectView = ({ selectedHelpCenter: selectedHelpCenter, setSelectedHelpCenter: setSelectedHelpCenter })=>{
    const { fetch: fetch, isLoading: isLoading, error: error, hasNext: hasNext } = (0, $iHVIl.useHelpCenterFetchService)((0, $4R6GH.fg)('enable_project_mapping_for_help_center'));
    const [options, setOptions] = (0, $5uXOq.useState)([]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { ref: ref, inView: inView } = (0, $6ggyj.useInView)({
        threshold: 0
    });
    const loadOptions = (0, $5uXOq.useCallback)(async (initial = false)=>{
        const helpCenters = await fetch();
        if (helpCenters?.length > 0 && !error) {
            const helpCenterOptions = helpCenters.map((hc, hcIndex)=>{
                const renderWithref = hcIndex === helpCenters.length - (0, $fd2e8f68ff0aa5c9$export$9b2c73c824a302e4);
                const hcNameWithDefaultLozenge = hc.slug ? hc.name : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $amGzE.HelpCenterOptionCustomLabel), {
                    value: hc.name
                });
                const hcLabel = renderWithref ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                    ref: ref
                }, hc.name) : hcNameWithDefaultLozenge;
                const option = {
                    label: hcLabel,
                    value: hc.helpCenterAri,
                    stringLabel: hc.name,
                    slug: hc.slug
                };
                if (!hc.slug && !selectedHelpCenter && initial) setSelectedHelpCenter(option);
                return option;
            });
            if (helpCenterOptions.length > 0) setOptions(helpCenterOptions);
        }
    }, [
        error,
        fetch,
        selectedHelpCenter,
        ref,
        setSelectedHelpCenter
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Load more options only when there is not an error and there are more options to load
        if (hasNext && inView && !isLoading && !error) loadOptions(false);
    }, [
        hasNext,
        inView,
        loadOptions,
        isLoading,
        error
    ]);
    (0, $5uXOq.useEffect)(()=>{
        loadOptions(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onSelect = (selected)=>{
        // When someone clears the field
        if (selected === null) setSelectedHelpCenter(undefined);
        else setSelectedHelpCenter(selected);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const menuPortal = (base)=>({
            ...base,
            zIndex: (0, $gwIPs.layers).modal
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $9a8dc6a328732aa2$var$helpCenterSelectWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EHpO.default), {
        name: "add-to-hc-field",
        label: formatMessage((0, $dP9D8.default).addToHelpCenterUpdated),
        isRequired: true,
        elementAfterLabel: (0, $4R6GH.fg)('jsm-jcs-visual-refresh-bug-fixes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkhLC.HelpMe), {
            helperText: formatMessage((0, $dP9D8.default).info)
        }) : undefined
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !(0, $4R6GH.fg)('jsm-jcs-visual-refresh-bug-fixes') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkhLC.HelpMeLegacy), {
            helperText: formatMessage((0, $dP9D8.default).info)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lau8t.default), {
            cacheOptions: true,
            options: options,
            value: selectedHelpCenter,
            onChange: onSelect,
            openMenuOnClick: true,
            isClearable: true,
            isLoading: isLoading,
            "aria-label": formatMessage((0, $dP9D8.default).addToHelpCenterUpdated),
            placeholder: formatMessage((0, $dP9D8.default).placeHolder),
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            menuPortalTarget: document.body,
            isSearchable: false,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            styles: {
                menuPortal: menuPortal
            }
        }), !isLoading && error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k5Wbc.ErrorMessage), null, formatMessage((0, $dP9D8.default).somethingWentWrong))))));
};
const $9a8dc6a328732aa2$var$helpCenterSelectWrapper = (0, $2s57o.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.200'
});
const $9a8dc6a328732aa2$export$53a0ffb611752140 = $9a8dc6a328732aa2$var$HelpCenterSelectView;

});
const $fd2e8f68ff0aa5c9$export$c0ae0768e117bb0e = 10;
const $fd2e8f68ff0aa5c9$export$9b2c73c824a302e4 = 5;

parcelRegister("amGzE", function(module, exports) {

$parcel$export(module.exports, "HelpCenterOptionCustomLabel", () => $6bac86a2cd678b19$export$317d9a2165584877);

var $5uXOq = parcelRequire("5uXOq");

var $eOat1 = parcelRequire("eOat1");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $iryG4 = parcelRequire("iryG4");
const $6bac86a2cd678b19$export$317d9a2165584877 = ({ value: value })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "span",
        xcss: $6bac86a2cd678b19$var$lozengeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: "default"
    }, formatMessage((0, $iryG4.default).default)))));
};
const $6bac86a2cd678b19$var$lozengeStyles = (0, $2s57o.xcss)({
    marginLeft: 'space.050'
});

});
parcelRegister("iryG4", function(module, exports) {

$parcel$export(module.exports, "default", () => $30dbb2ad8681a79a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $30dbb2ad8681a79a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    default: {
        "id": "servicedesk-help-center-select-field.common.help-center-option-custom-label.default",
        "defaultMessage": "Default"
    }
});

});


parcelRegister("hkhLC", function(module, exports) {

$parcel$export(module.exports, "HelpMe", () => $0e635ac1caf75192$export$eea793d1998993d6);
$parcel$export(module.exports, "HelpMeLegacy", () => $0e635ac1caf75192$export$afa6bf8aef3a4de6);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $c6Cwb = parcelRequire("c6Cwb");

var $1Seuh = parcelRequire("1Seuh");

var $vCqQa = parcelRequire("vCqQa");

var $0yZbT = parcelRequire("0yZbT");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $gwIPs = parcelRequire("gwIPs");

var $eHJxW = parcelRequire("eHJxW");

var $koVbs = parcelRequire("koVbs");

var $eVb5p = parcelRequire("eVb5p");
const $0e635ac1caf75192$export$eea793d1998993d6 = ({ helperText: helperText })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [showHelp, setShowHelp] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $vCqQa.default), {
        isOpen: showHelp,
        onClose: ()=>setShowHelp(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                padding: "space.200",
                xcss: $0e635ac1caf75192$var$popupStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
                as: "p"
            }, helperText)),
        shouldRenderToParent: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                xcss: $0e635ac1caf75192$var$styles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                label: formatMessage((0, $eVb5p.default).helpTooltip),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($c6Cwb))),
                onMouseOver: ()=>setShowHelp(!showHelp),
                onMouseLeave: ()=>setShowHelp(!showHelp)
            }))
    });
};
const $0e635ac1caf75192$export$afa6bf8aef3a4de6 = ({ helperText: helperText })=>{
    const [showHelp, setShowHelp] = (0, $5uXOq.useState)(false);
    const helpMeContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $0e635ac1caf75192$var$helpMeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        as: "p"
    }, helperText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
        onClose: ()=>{
            setShowHelp(false);
        },
        content: helpMeContent,
        isOpen: showHelp,
        placement: "top-start",
        messageId: "servicedesk-help-center-select-field.common.ui.help-me.inline-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "span",
        xcss: $0e635ac1caf75192$var$helpMeButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        "aria-label": "Help",
        appearance: "subtle-link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c6Cwb))), {
            label: "info",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        spacing: "none",
        onMouseOver: ()=>setShowHelp(!showHelp),
        onMouseLeave: ()=>setShowHelp(!showHelp)
    })));
};
const $0e635ac1caf75192$var$helpMeWrapperStyles = (0, $2s57o.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $gwIPs.gridSize) * 24}px`
});
const $0e635ac1caf75192$var$helpMeButtonStyles = (0, $2s57o.xcss)({
    verticalAlign: 'middle'
});
const $0e635ac1caf75192$var$popupStyles = (0, $2s57o.xcss)({
    width: '240px'
});
const $0e635ac1caf75192$var$styles = (0, $2s57o.xcss)({
    display: 'inline',
    paddingLeft: 'space.050'
});

});
parcelRegister("eVb5p", function(module, exports) {

$parcel$export(module.exports, "default", () => $52f28adb1ccec1f1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $52f28adb1ccec1f1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    helpTooltip: {
        "id": "servicedesk-help-center-select-field.help-me.help-tooltip",
        "defaultMessage": "Help"
    }
});

});


parcelRegister("iHVIl", function(module, exports) {

$parcel$export(module.exports, "useHelpCenterFetchService", () => $8972f0a9cf241380$export$8581cb4ff7245d45);

var $d7z0F = parcelRequire("d7z0F");

var $67SFi = parcelRequire("67SFi");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $8dYib = parcelRequire("8dYib");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $3Ypxa = parcelRequire("3Ypxa");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");


var $bpjnx = parcelRequire("bpjnx");

var $cZn1r = parcelRequire("cZn1r");
const $8972f0a9cf241380$export$8581cb4ff7245d45 = (isProjectMappingEnabled)=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [data, setData] = (0, $5uXOq.useState)([]);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [after, setAfter] = (0, $5uXOq.useState)(undefined);
    const [page, setPage] = (0, $5uXOq.useState)(0);
    const [hasNext, setHasMore] = (0, $5uXOq.useState)(false);
    const { projectId: projectId } = (0, $3Ypxa.useCommonPageContext)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const workSpaceAri = (0, $8dYib.JiraWorkspaceAri).create({
        siteId: cloudId,
        activationId: activationId
    });
    const helpCenterDataWithoutProjectMapping = (0, $eiowN.fetchQuery)(environment, (0, $67SFi.default), {
        first: (0, $fd2e8f68ff0aa5c9$export$c0ae0768e117bb0e),
        cloudId: cloudId,
        workspaceAri: workSpaceAri.toString(),
        SORT_ORDER: 'CREATED_DATE_ASCENDING',
        after: after
    }, {
        fetchPolicy: 'store-or-network'
    });
    const helpCenterDataWithProjectMapping = (0, $eiowN.fetchQuery)(environment, (0, $d7z0F.default), {
        first: (0, $fd2e8f68ff0aa5c9$export$c0ae0768e117bb0e),
        cloudId: cloudId,
        projectId: String(projectId),
        workspaceAri: workSpaceAri.toString(),
        SORT_ORDER: 'CREATED_DATE_ASCENDING',
        after: after
    }, {
        fetchPolicy: 'store-or-network'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fetch = (0, $5uXOq.useCallback)(async ()=>{
        (0, $cZn1r.helpCenterFetchExperience).start();
        let helpCenters = [];
        setIsLoading(true);
        setError(null);
        const helpCenterData = isProjectMappingEnabled ? helpCenterDataWithProjectMapping : helpCenterDataWithoutProjectMapping;
        await helpCenterData.toPromise().then((res)=>{
            if (!res?.helpCenter) // This could occur when the request did not reach Kosh and failed at AGG
            throw new Error(`Missing required fields in helpCenterFetchQuery response, possibly an AGG error. ${JSON.stringify(res)}`);
            const helpCentersList = 'helpCenters' in res?.helpCenter ? res?.helpCenter?.helpCenters : res?.helpCenter?.helpCentersByProjectId;
            const errorNodes = helpCentersList?.nodes;
            if (!helpCentersList) // This could occur when the request did not reach Kosh and failed at AGG
            throw new Error(`Missing required fields in helpCenterFetchQuery response, possibly an AGG error. ${JSON.stringify(res)}`);
            else if (helpCentersList?.__typename === 'HelpCenterQueryResultConnection') {
                helpCenters = helpCentersList.edges?.filter((hc)=>hc?.node?.name?.default && hc?.node?.id).map((hc)=>{
                    const name = hc?.node?.name?.default || '';
                    const slug = hc?.node?.slug || null;
                    const helpCenterAri = hc?.node?.id || '';
                    return {
                        name: name,
                        slug: slug,
                        helpCenterAri: helpCenterAri
                    };
                }) || [];
                setData(helpCenters);
                setAfter(helpCentersList.pageInfo?.endCursor || undefined);
                setHasMore(helpCentersList.pageInfo?.hasNextPage || false);
                setPage(page + 1);
                setIsLoading(false);
                (0, $cZn1r.helpCenterFetchExperience).success();
                const analyticsEvent = createAnalyticsEvent({});
                (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'jsmHelpCenterFetch succeeded', {
                    helpCentersCount: helpCenters.length,
                    page: page
                });
            } else if (Array.isArray(errorNodes) && errorNodes[0].__typename === 'QueryError') {
                const { message: message, identifier: identifier, extensions: extensions } = errorNodes[0];
                const { statusCode: statusCode, errorType: errorType } = extensions?.[0] || {};
                const err = new Error(`QueryError: ${JSON.stringify({
                    message: message,
                    identifier: identifier,
                    statusCode: statusCode,
                    errorType: errorType
                })}`);
                err.statusCode = statusCode ? Number(statusCode) : undefined;
                throw err;
            } else throw new Error(`Unknown error occurred ${JSON.stringify(res)}`);
        }).catch((err)=>{
            setError(err);
            setIsLoading(false);
            (0, $cZn1r.helpCenterFetchExperience).failure();
        });
        return helpCenters;
    }, [
        createAnalyticsEvent,
        helpCenterDataWithProjectMapping,
        helpCenterDataWithoutProjectMapping,
        isProjectMappingEnabled,
        page
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error) (0, $bpjnx.logError)(error);
    }, [
        error
    ]);
    return {
        isLoading: isLoading,
        error: error,
        data: data,
        after: after,
        hasNext: hasNext,
        fetch: fetch
    };
};

});
parcelRegister("d7z0F", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d0b5e937b7c970d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3fee14a78969bdde35da48f33213778e>>
 * @relayHash 2353edfd5e69ad073019c4bb8349a109
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a2ec984ea33495adcbba94336e1a3f16de40867829b547192a16447daa97ad61
const $8d0b5e937b7c970d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "SORT_ORDER"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectId"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v7 = {
        "kind": "Variable",
        "name": "projectId",
        "variableName": "projectId"
    }, v8 = {
        "kind": "Variable",
        "name": "sortOrder",
        "variableName": "SORT_ORDER"
    }, v9 = {
        "kind": "Variable",
        "name": "workspaceAri",
        "variableName": "workspaceAri"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v11 /*: any*/ ,
            {
                "concreteType": "HelpCenterName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "default"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "slug"
            }
        ],
        "type": "HelpCenter"
    }, v13 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v14 = {
        "kind": "ScalarField",
        "name": "message"
    }, v15 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v16 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v17 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v18 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v19 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v7 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ 
    ], v20 = {
        "kind": "InlineFragment",
        "selections": [
            v11 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "helpCenterFetchWithProjectMappingQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "helpCentersByProjectId",
                            "args": [
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ],
                            "concreteType": "HelpCenterQueryResultConnection",
                            "kind": "LinkedField",
                            "name": "__multiHcDropdownContentFragment_helpCentersByProjectId_connection",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "HelpCenterQueryResultEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        v13 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                v18 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "helpCenterFetchWithProjectMappingQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v19 /*: any*/ ,
                            "concreteType": "HelpCenterQueryResultConnection",
                            "kind": "LinkedField",
                            "name": "helpCentersByProjectId",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "HelpCenterQueryResultEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v20 /*: any*/ 
                                            ]
                                        },
                                        v13 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "QueryError"
                                        },
                                        v20 /*: any*/ 
                                    ]
                                },
                                v18 /*: any*/ 
                            ]
                        },
                        {
                            "args": v19 /*: any*/ ,
                            "filters": [
                                "projectId",
                                "workspaceAri",
                                "sortOrder"
                            ],
                            "handle": "connection",
                            "key": "multiHcDropdownContentFragment_helpCentersByProjectId",
                            "kind": "LinkedHandle",
                            "name": "helpCentersByProjectId"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a2ec984ea33495adcbba94336e1a3f16de40867829b547192a16447daa97ad61",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "helpCenter",
                            "helpCentersByProjectId"
                        ]
                    }
                ]
            },
            "name": "helpCenterFetchWithProjectMappingQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8d0b5e937b7c970d$var$node.hash = "807c8c0ebad75d6e8369741625a7c116";
var $8d0b5e937b7c970d$export$2e2bcd8739ae039 = $8d0b5e937b7c970d$var$node;

});

parcelRegister("67SFi", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f9a8393d48dd1ba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<600d7442f15f4a40d29f41a1084dacd6>>
 * @relayHash 4e079704002ecfaadcb864b248ac074d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9dd44a542e3ffa79060b2c2cde60374e5e945816ebbb26ec6f1f03c228492e44
const $6f9a8393d48dd1ba$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "SORT_ORDER"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v6 = {
        "kind": "Variable",
        "name": "sortOrder",
        "variableName": "SORT_ORDER"
    }, v7 = {
        "kind": "Variable",
        "name": "workspaceAri",
        "variableName": "workspaceAri"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ ,
            {
                "concreteType": "HelpCenterName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "default"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "slug"
            }
        ],
        "type": "HelpCenter"
    }, v11 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v12 = {
        "kind": "ScalarField",
        "name": "message"
    }, v13 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v14 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v15 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v16 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v17 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ], v18 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "helpCenterFetchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "helpCenters",
                            "args": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "concreteType": "HelpCenterQueryResultConnection",
                            "kind": "LinkedField",
                            "name": "__multiHcDropdownContentFragment_helpCenters_connection",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "concreteType": "HelpCenterQueryResultEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "helpCenterFetchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v17 /*: any*/ ,
                            "concreteType": "HelpCenterQueryResultConnection",
                            "kind": "LinkedField",
                            "name": "helpCenters",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "concreteType": "HelpCenterQueryResultEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v18 /*: any*/ 
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "QueryError"
                                        },
                                        v18 /*: any*/ 
                                    ]
                                },
                                v16 /*: any*/ 
                            ]
                        },
                        {
                            "args": v17 /*: any*/ ,
                            "filters": [
                                "workspaceAri",
                                "sortOrder"
                            ],
                            "handle": "connection",
                            "key": "multiHcDropdownContentFragment_helpCenters",
                            "kind": "LinkedHandle",
                            "name": "helpCenters"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9dd44a542e3ffa79060b2c2cde60374e5e945816ebbb26ec6f1f03c228492e44",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "helpCenter",
                            "helpCenters"
                        ]
                    }
                ]
            },
            "name": "helpCenterFetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6f9a8393d48dd1ba$var$node.hash = "0efd5ddafccbf9644af93c0d9a8ea221";
var $6f9a8393d48dd1ba$export$2e2bcd8739ae039 = $6f9a8393d48dd1ba$var$node;

});

parcelRegister("bpjnx", function(module, exports) {

$parcel$export(module.exports, "logError", () => $6d89261f3c94f45d$export$58da9968c3170cb1);

var $jcw0u = parcelRequire("jcw0u");
const $6d89261f3c94f45d$export$1a5a4674dd906e7e = (statusCode)=>statusCode === 0;
const $6d89261f3c94f45d$export$d31fd506ce75fa65 = (statusCode)=>statusCode >= 400 && statusCode < 500;
const $6d89261f3c94f45d$export$53ee51427129200c = (statusCode)=>$6d89261f3c94f45d$export$1a5a4674dd906e7e(statusCode) || $6d89261f3c94f45d$export$d31fd506ce75fa65(statusCode);
const $6d89261f3c94f45d$export$58da9968c3170cb1 = (err)=>{
    if ($6d89261f3c94f45d$export$53ee51427129200c(Number(err.statusCode))) return;
    (0, $jcw0u.default)({
        meta: {
            id: 'helpCenterFetchService',
            packageName: 'jiraServicedeskHelpCenterSelectField',
            teamName: 'jsm-megatron'
        },
        error: err,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $6d89261f3c94f45d$export$2b62e563f0fadcee = (statusCode)=>statusCode === 0 || statusCode >= 400 && statusCode < 500;

});

parcelRegister("cZn1r", function(module, exports) {

$parcel$export(module.exports, "helpCenterFetchExperience", () => $930a27d8730b0293$export$191cbf8bc5a77d43);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");
const $930a27d8730b0293$export$191cbf8bc5a77d43 = new (0, $kkzI0.UFOExperience)('jsm-help-center-data-fetch', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
});

});


parcelRegister("dP9D8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6507b880b561b534$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6507b880b561b534$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addToHelpCenterUpdated: {
        "id": "servicedesk-help-center-select-field.add-to-help-center-updated",
        "defaultMessage": "Choose help center"
    },
    info: {
        "id": "servicedesk-help-center-select-field.info",
        "defaultMessage": "Customers will receive a link to this help center in the invitation email. However, they\u2019ll still be able to access other help centers on your site."
    },
    placeHolder: {
        "id": "servicedesk-help-center-select-field.place-holder",
        "defaultMessage": "Choose a help center"
    },
    somethingWentWrong: {
        "id": "servicedesk-help-center-select-field.something-went-wrong",
        "defaultMessage": "Something went wrong. Check your connection, then give it another try."
    }
});

});


parcelRegister("38Kqf", function(module, exports) {

$parcel$export(module.exports, "FormErrors", () => $36d5a0e046fa0d86$export$db5ae436ef8b64fb);

var $5uXOq = parcelRequire("5uXOq");

var $8LQ84 = parcelRequire("8LQ84");

var $k5Wbc = parcelRequire("k5Wbc");

var $koVbs = parcelRequire("koVbs");

var $i20WJ = parcelRequire("i20WJ");
const $36d5a0e046fa0d86$export$db5ae436ef8b64fb = ({ isError: isError = false, formErrors: formErrors = null, serviceError: serviceError })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (formErrors || isError) {
        if (formErrors && formErrors.errors && (0, (/*@__PURE__*/$parcel$interopDefault($8LQ84)))(formErrors.errors)) {
            const { errors: errors } = formErrors;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, errors.map(({ error: { errorMessage: errorMessage } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k5Wbc.ErrorMessage), {
                    key: errorMessage
                }, errorMessage)));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k5Wbc.ErrorMessage), null, formatMessage((0, $i20WJ.default).genericErrorText));
    }
    if (serviceError) {
        // @ts-expect-error - TS2339 - Property 'reasonCode' does not exist on type 'Error | ValidationErrors | { statusCode: number; message?: string | undefined; }'.
        if (serviceError.reasonCode === '401') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k5Wbc.ErrorMessage), null, formatMessage((0, $i20WJ.default).loggedOut));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k5Wbc.ErrorMessage), null, formatMessage((0, $i20WJ.default).genericErrorText));
    }
    return null;
};

});
parcelRegister("i20WJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $58ce1d8834410c45$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $58ce1d8834410c45$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    genericErrorText: {
        "id": "servicedesk-customers-organization-common.common.inline-dialog.form-errors.generic-error-text",
        "defaultMessage": "We're having trouble. Check your connection and try again."
    },
    loggedOut: {
        "id": "servicedesk-customers-organization-common.common.inline-dialog.form-errors.logged-out",
        "defaultMessage": "You are not currently logged in. Please log in to perform this action."
    }
});

});


parcelRegister("gkrVw", function(module, exports) {

$parcel$export(module.exports, "CustomerNotificationHelpText", () => $2331685fa0309d09$export$d881b2d295b47b14);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $k01Ou = parcelRequire("k01Ou");

var $0yZbT = parcelRequire("0yZbT");
var $6eFvr = parcelRequire("6eFvr");

var $8RXs9 = parcelRequire("8RXs9");

var $gZVfw = parcelRequire("gZVfw");

var $8psPC = parcelRequire("8psPC");
const $2331685fa0309d09$export$23259d84ca627877 = ({ intl: { formatMessage: formatMessage }, isOutgoingMailEnabled: isOutgoingMailEnabled, isInviteEmailEnabled: isInviteEmailEnabled, isAdmin: isAdmin, isMultiHcAndInviteRoutingEnabled: isMultiHcAndInviteRoutingEnabled = false, isCustomerInvitationSupported: isCustomerInvitationSupported = true, isJcs: isJcs = false })=>{
    const inviteEmailDescription = isMultiHcAndInviteRoutingEnabled ? formatMessage((0, $gZVfw.default).updatedCustomersWillReceiveHelpCenterEmail) : formatMessage((0, $gZVfw.default).updatedCustomersWillReceiveEmail);
    if (isJcs) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        paddingBlockStart: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, formatMessage((0, $gZVfw.default).addCustomerDescription)));
    // For cases where sending email invites are not supported (can't be configured)
    // Note that customers are still added but no email is sent
    // TODO: Add copy when provided by design/content
    if (!isCustomerInvitationSupported) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        "data-testId": "servicedesk-customers-organization-common.ui.add-customers-dialog.form.fields.customer-notification-help-text.box"
    });
    if (isInviteEmailEnabled && isOutgoingMailEnabled && isAdmin) return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, inviteEmailDescription, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8psPC.CustomerNotificationHelpTextForAdminLink), null)));
    if (isInviteEmailEnabled && isOutgoingMailEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        paddingBlockStart: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        as: "p"
    }, inviteEmailDescription, " ", formatMessage((0, $gZVfw.default).notificationsForNonAdmin)));
    if (!isInviteEmailEnabled && isAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2331685fa0309d09$var$LabelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k01Ou))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-discovery, #8270DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2331685fa0309d09$var$Label, null, formatMessage((0, $gZVfw.default).invitationNotificationDisabled), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8psPC.ViewConfigurationLink), null))));
    if (!isInviteEmailEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2331685fa0309d09$var$LabelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k01Ou))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-discovery, #8270DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2331685fa0309d09$var$Label, null, formatMessage((0, $gZVfw.default).viewConfigurationForNonAdmin)));
    return null;
};
$2331685fa0309d09$export$23259d84ca627877.defaultProps = {
    isOutgoingMailEnabled: false,
    isInviteEmailEnabled: false,
    isAdmin: false
};
const $2331685fa0309d09$export$d881b2d295b47b14 = (0, $8RXs9.default)($2331685fa0309d09$export$23259d84ca627877); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2331685fa0309d09$var$LabelContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvrv2br",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2331685fa0309d09$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _4cvrv2br _18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gZVfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $406aef26b9cfa4b0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $406aef26b9cfa4b0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notificationsForNonAdmin: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.customer-notification-help-text.notifications-for-non-admin",
        "defaultMessage": "Project admins can disable or customize invitation emails."
    },
    invitationNotificationDisabled: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.customer-notification-help-text.invitation-notification-disabled",
        "defaultMessage": "You have disabled the invitation email to customers."
    },
    viewConfigurationForAdmin: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.customer-notification-help-text.view-configuration-for-admin",
        "defaultMessage": "View configuration"
    },
    viewConfigurationForNonAdmin: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.customer-notification-help-text.view-configuration-for-non-admin",
        "defaultMessage": "The project admin has disabled the invitation email to customers."
    },
    updatedCustomersWillReceiveEmail: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.customer-notification-help-text.updated-customers-will-receive-email",
        "defaultMessage": "Customers will receive an invitation email if they haven\u2019t already been added to a project on this site."
    },
    updatedCustomersWillReceiveHelpCenterEmail: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.customer-notification-help-text.updated-customers-will-receive-help-center-email",
        "defaultMessage": "Customers will receive an invitation email if they haven\u2019t been added to your site yet. Once signed up, they\u2019ll be directed to the chosen help center."
    },
    updatedNotificationsForAdminNew: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.customer-notification-help-text.updated-notifications-for-admin-new",
        "defaultMessage": "Customize your invitation email."
    },
    addCustomerDescription: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.add-customers-description",
        "defaultMessage": "Customers can only raise requests if they\u2019ve been added to a service hub by an admin."
    }
});

});

parcelRegister("8psPC", function(module, exports) {

$parcel$export(module.exports, "CustomerNotificationHelpTextForAdminLink", () => $da4e7f2535e5c533$export$cf6065b11ab148db);
$parcel$export(module.exports, "ViewConfigurationLink", () => $da4e7f2535e5c533$export$a106611cd7bc2989);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $koVbs = parcelRequire("koVbs");

var $3Ypxa = parcelRequire("3Ypxa");

var $i6z3a = parcelRequire("i6z3a");

var $gZVfw = parcelRequire("gZVfw");
const $da4e7f2535e5c533$export$cf6065b11ab148db = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = (0, $i6z3a.useRouterPush)();
    const { baseUrl: baseUrl, projectKey: projectKey } = (0, $3Ypxa.useCommonPageContext)();
    const customerNotificationLink = `${baseUrl}/jira/servicedesk/projects/${projectKey}/settings/customer-notifications/account-notification/invite-customer`;
    const onClick = (event)=>{
        push(event, customerNotificationLink);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "link",
        spacing: "none",
        target: "_blank",
        href: customerNotificationLink,
        onClick: onClick
    }, formatMessage((0, $gZVfw.default).updatedNotificationsForAdminNew));
};
const $da4e7f2535e5c533$export$a106611cd7bc2989 = ()=>{
    const { baseUrl: baseUrl, projectKey: projectKey } = (0, $3Ypxa.useCommonPageContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "link",
        spacing: "none",
        href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/settings/customer-notifications/account-notification/invite-customer`
    }, formatMessage((0, $gZVfw.default).viewConfigurationForAdmin));
};

});


parcelRegister("dvTr0", function(module, exports) {

$parcel$export(module.exports, "DynamicInputField", () => $0e8930d2b9e4d223$export$27f2f893e71eab06);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $1Seuh = parcelRequire("1Seuh");

var $4EHpO = parcelRequire("4EHpO");

var $jlx1P = parcelRequire("jlx1P");

var $c6Cwb = parcelRequire("c6Cwb");

var $0yZbT = parcelRequire("0yZbT");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $vCqQa = parcelRequire("vCqQa");

var $gwIPs = parcelRequire("gwIPs");

var $eHJxW = parcelRequire("eHJxW");

var $koVbs = parcelRequire("koVbs");

var $ho62W = parcelRequire("ho62W");

var $4R6GH = parcelRequire("4R6GH");

var $ln5XG = parcelRequire("ln5XG");

var $ane1U = parcelRequire("ane1U");

var $gEkKF = parcelRequire("gEkKF");

var $6CCUD = parcelRequire("6CCUD");

var $l7moB = parcelRequire("l7moB");

var $98OlA = parcelRequire("98OlA");
const $0e8930d2b9e4d223$var$CustomerEmailLabelTooltip = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [showHelp, setShowHelp] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $vCqQa.default), {
        isOpen: showHelp,
        onClose: ()=>setShowHelp(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                padding: "space.200",
                xcss: $0e8930d2b9e4d223$var$popupStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
                as: "p"
            }, formatMessage((0, $l7moB.default).info))),
        shouldRenderToParent: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                xcss: $0e8930d2b9e4d223$var$iconStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
                ...triggerProps,
                appearance: "subtle",
                label: formatMessage((0, $l7moB.default).helpTooltip),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($c6Cwb))),
                onMouseOver: ()=>setShowHelp(!showHelp),
                onMouseLeave: ()=>setShowHelp(!showHelp),
                spacing: "compact"
            }))
    });
};
const $0e8930d2b9e4d223$export$d1d17b110fe0be6e = ()=>{
    const { email: email, emails: emails, showInput: showInput, showHelp: showHelp, setShowHelp: setShowHelp, isValidating: isValidating, failed: failed, failedWithErrors: failedWithErrors, showErrorFlag: showErrorFlag, setEmailOnChange: // Methods
    setEmailOnChange, handleOnRemoved: handleOnRemoved, handleAddMore: handleAddMore, handleOnKeyDown: handleOnKeyDown, setShowErrorFlag: setShowErrorFlag } = (0, $gEkKF.useDynamicInputHook)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const helpMeContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $0e8930d2b9e4d223$var$helpMeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        as: "p"
    }, formatMessage((0, $l7moB.default).info)));
    const renderHelpMe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
            onClose: ()=>{
                setShowHelp(false);
            },
            content: helpMeContent,
            isOpen: showHelp,
            placement: "top-start",
            messageId: "servicedesk-customers-organization-common.ui.add-customers-dialog.form.fields.dynamic-input-field.inline-dialog",
            messageType: "transactional"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            as: "span",
            xcss: $0e8930d2b9e4d223$var$helpMeButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
            "aria-label": "Help",
            appearance: "subtle-link",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c6Cwb))), {
                label: "info",
                LEGACY_size: "medium",
                spacing: "spacious"
            }),
            spacing: "none",
            onMouseOver: ()=>setShowHelp(!showHelp),
            onMouseLeave: ()=>setShowHelp(!showHelp)
        })));
    const addMoreButtonProps = {
        'aria-label': 'Add More',
        appearance: 'subtle-link',
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jlx1P))), {
            label: "add",
            LEGACY_size: "small"
        }),
        spacing: 'none',
        isDisabled: isValidating,
        onClick: handleAddMore,
        testId: 'servicedesk-customers-organization-common.ui.add-customers-dialog.form.fields.dynamic-input-field.add-more-button'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EHpO.default), {
        name: "customer-emails-field",
        label: formatMessage((0, $l7moB.default).customerEmails),
        elementAfterLabel: (0, $4R6GH.fg)('jsm-jcs-visual-refresh-bug-fixes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0e8930d2b9e4d223$var$CustomerEmailLabelTooltip, null) : undefined,
        isRequired: true
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !(0, $4R6GH.fg)('jsm-jcs-visual-refresh-bug-fixes') && renderHelpMe(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6CCUD.InputListView), {
            inputs: emails,
            onRemoved: handleOnRemoved
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ln5XG.MultiLineText), {
            isInvalid: failed.length > 0,
            isMultiline: !showInput,
            isValidating: isValidating,
            value: email,
            onKeyDown: handleOnKeyDown,
            setEmailOnChange: setEmailOnChange
        }))), showErrorFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ho62W.AsyncInviteFailed), {
        failedEmails: (0, $98OlA.transformToInviteFailedEmails)(failedWithErrors),
        onClosed: ()=>setShowErrorFlag(false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $0e8930d2b9e4d223$var$addMoreStyles
    }, isValidating ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        ...addMoreButtonProps,
        className: (0, $bwpsq.default)([
            "_80omggyl"
        ])
    }, "\xa0Add") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), addMoreButtonProps, "\xa0Add")));
};
$0e8930d2b9e4d223$export$d1d17b110fe0be6e.defaultProps = {
    useAddCustomersDialogContext: (0, $ane1U.useAddCustomersDialogContext)
};
const $0e8930d2b9e4d223$export$27f2f893e71eab06 = $0e8930d2b9e4d223$export$d1d17b110fe0be6e;
const $0e8930d2b9e4d223$var$addMoreStyles = (0, $2s57o.xcss)({
    display: 'flex',
    justifyContent: 'right',
    marginTop: 'space.050',
    marginBottom: 'space.050'
});
const $0e8930d2b9e4d223$var$helpMeWrapperStyles = (0, $2s57o.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $gwIPs.gridSize) * 24}px`
});
const $0e8930d2b9e4d223$var$helpMeButtonStyles = (0, $2s57o.xcss)({
    verticalAlign: 'middle'
});
const $0e8930d2b9e4d223$var$popupStyles = (0, $2s57o.xcss)({
    width: '240px'
});
const $0e8930d2b9e4d223$var$iconStyles = (0, $2s57o.xcss)({
    display: 'inline',
    paddingLeft: 'space.050'
});

});
parcelRegister("ln5XG", function(module, exports) {

$parcel$export(module.exports, "MultiLineText", () => $0eccb6adf92cbbd5$export$759041031fe19470);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bjTxt = parcelRequire("bjTxt");

var $koVbs = parcelRequire("koVbs");

var $5wa9O = parcelRequire("5wa9O");
const $0eccb6adf92cbbd5$export$759041031fe19470 = ({ isInvalid: isInvalid, isMultiline: isMultiline = false, isValidating: isValidating, value: value, onKeyDown: onKeyDown, setEmailOnChange: setEmailOnChange })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0eccb6adf92cbbd5$export$3cf7de0b39bab18b, {
        isMultiline: isMultiline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bjTxt.default), {
        "aria-label": formatMessage((0, $5wa9O.default).placeHolder),
        resize: "vertical",
        name: "customer-emails-multiple",
        value: value,
        onChange: (event)=>setEmailOnChange(event.target.value),
        placeholder: formatMessage((0, $5wa9O.default).placeHolder),
        isCompact: true // @ts-expect-error - TS2322 - Type '(event: KeyboardEvent) => void' is not assignable to type 'KeyboardEventHandler<HTMLTextAreaElement>'.
        ,
        onKeyDown: onKeyDown,
        isReadOnly: isValidating,
        isInvalid: isInvalid,
        testId: "servicedesk-customers-organization-common.common.ui.multiline-text.dynamic-input"
    }));
};
const $0eccb6adf92cbbd5$export$3cf7de0b39bab18b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMultiline: isMultiline, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isMultiline ? "_74a41pg8" : "_12ew1a66 _17ocglyw _1aqv9w6u",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bjTxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdb5fb9ca46f29ed$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $fHpHg = parcelRequire("fHpHg");
const $fdb5fb9ca46f29ed$var$packageName = "platform-pkg";
const $fdb5fb9ca46f29ed$var$packageVersion = "0.0.0-use.local";
const $fdb5fb9ca46f29ed$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $fdb5fb9ca46f29ed$var$packageName,
    packageVersion: $fdb5fb9ca46f29ed$var$packageVersion
};
const $fdb5fb9ca46f29ed$var$lineHeightBase = 20;
const $fdb5fb9ca46f29ed$var$lineHeightCompact = 16;
const $fdb5fb9ca46f29ed$var$compactVerticalPadding = 2;
const $fdb5fb9ca46f29ed$var$verticalPadding = 6;
const $fdb5fb9ca46f29ed$var$transitionDuration = '0.2s';
const $fdb5fb9ca46f29ed$var$borderWidth = 2;
const $fdb5fb9ca46f29ed$var$baseStyles = null;
const $fdb5fb9ca46f29ed$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $fdb5fb9ca46f29ed$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $fdb5fb9ca46f29ed$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $fdb5fb9ca46f29ed$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $fdb5fb9ca46f29ed$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $fdb5fb9ca46f29ed$var$InnerTextArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const ourRef = (0, $5uXOq.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $5uXOq.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $fdb5fb9ca46f29ed$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$fdb5fb9ca46f29ed$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$fdb5fb9ca46f29ed$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $fdb5fb9ca46f29ed$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazj3m3 _slp31hna _153g78r2 _usy4mag2 _1a2sr6rt _vbqb9jg2 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra78r2 _ibjd10ko _6zpvr6rt _19k01y1w _1idr1wmz _1lep9jg2 _nmhq1fiz _1n388sxn _1luh194a _ndzbr01l _1vj01cu8",
            $fdb5fb9ca46f29ed$var$appearanceStyles[appearance],
            (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') && $fdb5fb9ca46f29ed$var$fontStyles['large'],
            $fdb5fb9ca46f29ed$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $fdb5fb9ca46f29ed$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $lD23V.default)($fdb5fb9ca46f29ed$var$lineHeightCompact * minimumRows + $fdb5fb9ca46f29ed$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $lD23V.default)($fdb5fb9ca46f29ed$var$lineHeightBase * minimumRows + $fdb5fb9ca46f29ed$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $fdb5fb9ca46f29ed$var$TextArea = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($fdb5fb9ca46f29ed$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$fdb5fb9ca46f29ed$var$TextArea.displayName = 'TextArea';
var $fdb5fb9ca46f29ed$export$2e2bcd8739ae039 = $fdb5fb9ca46f29ed$var$TextArea;

});

parcelRegister("5wa9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a85fbfbdc451ef0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1a85fbfbdc451ef0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeHolder: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.dynamic-input-field.place-holder",
        "defaultMessage": "Enter email address(es)"
    }
});

});


parcelRegister("gEkKF", function(module, exports) {

$parcel$export(module.exports, "useDynamicInputHook", () => $a296df9949ef14bb$export$afc2933ac433b06a);

var $5uXOq = parcelRequire("5uXOq");

var $fW62l = parcelRequire("fW62l");

var $ane1U = parcelRequire("ane1U");

var $i8iHP = parcelRequire("i8iHP");
const $a296df9949ef14bb$export$afc2933ac433b06a = ()=>{
    const [showInput, setShowInput] = (0, $5uXOq.useState)(true);
    const [showHelp, setShowHelp] = (0, $5uXOq.useState)(false);
    const [showErrorFlag, setShowErrorFlag] = (0, $5uXOq.useState)(false);
    const [{ isValidating: isValidating, emailValidationErrors: emailValidationErrors, customers: customers, emailPresetValue: emailPresetValue }, { setCustomerEmailsInputFieldValue: setCustomerEmailsInputFieldValue, onValidateCustomerEmails: onValidateCustomerEmails, setCustomers: setCustomers, setEmailPresetValue: setEmailPresetValue }] = (0, $ane1U.useAddCustomersDialogContext)();
    const failed = emailValidationErrors?.failed || [];
    const failedWithErrors = emailValidationErrors?.failedWithErrors || [];
    // User input
    const [email, setEmail] = (0, $5uXOq.useState)(emailPresetValue);
    // Validated email list yet to be submitted
    const [emails, setEmails] = (0, $5uXOq.useState)(()=>customers.map((customer)=>customer.emailAddress));
    // also Toggles input view to text area if input contains comma seperated values
    const setEmailOnChange = (input)=>{
        let toSet = input;
        // split the input into one-email-per-line before setting the email value
        // only when input length is > 3. SPLIT BY [',' , ';' , '\n']
        if ((0, $i8iHP.hasMultipleEmails)(toSet)) {
            toSet = (0, $i8iHP.newLineForText)(toSet);
            setShowInput(false);
        }
        setEmail(toSet);
        setEmailPresetValue(toSet);
        const allTrimmed = (0, $i8iHP.trimAll)(toSet);
        if (allTrimmed.length > 0) {
            const toParent = [
                ...new Set(emails.concat(allTrimmed))
            ];
            setCustomerEmailsInputFieldValue(toParent.join(','));
        }
    };
    const handleOnRemoved = (removedEmail)=>{
        const newEmails = emails.filter((eachEmail)=>eachEmail !== removedEmail);
        setEmails(newEmails);
        setCustomers(customers.filter((customer)=>customer.emailAddress !== removedEmail));
    };
    // Whenever `emails` changes update the parent's email and customer state
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $i8iHP.hasMultipleEmails)(email)) // Show textarea expanded when prefill has multiple emails
        setShowInput(false);
        if (emails.length === 0) setCustomerEmailsInputFieldValue(email);
        else {
            const toParent = [
                ...new Set(emails.concat(email))
            ];
            setCustomerEmailsInputFieldValue(toParent.join(','));
        }
    }, [
        email,
        emails,
        setCustomerEmailsInputFieldValue,
        setCustomers
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Set validated email lists on validation
        const passedList = emailValidationErrors ? emailValidationErrors.passed : [];
        const failedList = emailValidationErrors ? emailValidationErrors.failed : [];
        if (passedList.length > 0 && failedList.length === 0) {
            setEmails((prev)=>[
                    ...new Set([
                        ...prev,
                        ...passedList
                    ])
                ]);
            setEmail('');
            setEmailPresetValue('');
            setShowInput(true);
        }
        if (failedWithErrors.length > 0) setShowErrorFlag(true);
    }, [
        emailValidationErrors,
        failedWithErrors.length,
        setEmailPresetValue
    ]);
    const validateEmails = (emailArr)=>{
        const toValidate = [
            ...new Set(emailArr)
        ];
        onValidateCustomerEmails(toValidate);
    };
    const handleAddMore = ()=>{
        const emailArr = (0, $i8iHP.trimAll)(email);
        if (emailArr.length > 0) validateEmails(emailArr);
    };
    const handleBackspace = (event)=>{
        if (event.target instanceof HTMLTextAreaElement && event.target.selectionEnd >= 2 && event.target.selectionEnd === event.target.selectionStart && email.substring(event.target.selectionEnd - 2, event.target.selectionEnd) === ',\n') {
            event.preventDefault();
            setEmail(email.substring(0, event.target.selectionEnd - 2) + email.substring(event.target.selectionEnd));
            // this will adjust a cursor position in case deletion was in the middle of a text, as it places the cursor at the end by default
            // setting selection must happen after email is set and textarea rerendered
            setTimeout((target, selectionStart, selectionEnd)=>{
                target.setSelectionRange(selectionStart, selectionEnd);
            }, 0, event.target, event.target.selectionEnd - 2, event.target.selectionEnd - 2);
        }
    };
    // mimic + Add on enter or space
    const handleOnKeyDown = (event)=>{
        if (([
            (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter'),
            (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('space')
        ].includes(event.keyCode) || [
            'Enter',
            ' ',
            'Spacebar'
        ].includes(event.key)) && email.trim()) {
            event.preventDefault();
            handleAddMore();
        } else if (((0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('backspace') === event.keyCode || event.key === 'Backspace') && email.trim()) handleBackspace(event);
    };
    return {
        email: email,
        setEmail: setEmail,
        emails: emails,
        setEmails: setEmails,
        showInput: showInput,
        setShowInput: setShowInput,
        showHelp: showHelp,
        setShowHelp: setShowHelp,
        isValidating: isValidating,
        emailValidationErrors: emailValidationErrors,
        setCustomerEmailsInputFieldValue: setCustomerEmailsInputFieldValue,
        onValidateCustomerEmails: onValidateCustomerEmails,
        failed: failed,
        failedWithErrors: failedWithErrors,
        showErrorFlag: showErrorFlag,
        setEmailOnChange: // Methods
        setEmailOnChange,
        handleOnRemoved: handleOnRemoved,
        validateEmails: validateEmails,
        handleAddMore: handleAddMore,
        handleOnKeyDown: handleOnKeyDown,
        setShowErrorFlag: setShowErrorFlag
    };
};

});
parcelRegister("i8iHP", function(module, exports) {

$parcel$export(module.exports, "trimAll", () => $a66157d8f091acb7$export$75c3f1d2ea877262);
$parcel$export(module.exports, "newLineForText", () => $a66157d8f091acb7$export$dcd449be4da8e0b5);
$parcel$export(module.exports, "hasMultipleEmails", () => $a66157d8f091acb7$export$73603e62fe14f07b);
// Trim empty space and new lines
const $a66157d8f091acb7$export$75c3f1d2ea877262 = (str)=>str.replace('\n', '').split(',').map((e)=>e.trim()).filter(Boolean);
// Inserts new lines to the input in between comma-separated values for display in a text area
const $a66157d8f091acb7$export$dcd449be4da8e0b5 = (str)=>str.split(/[;,\n]+/).map((e)=>e.trim()).join(',\n');
// check if email input value length is > 3 and is seperated BY [',' , ';' , '\n']
const $a66157d8f091acb7$export$73603e62fe14f07b = (email)=>{
    const moreDelineators = new RegExp(/[;,\n]+/);
    const hasDelineators = email.match(moreDelineators) !== null;
    return email.length > 3 && hasDelineators;
};

});


parcelRegister("6CCUD", function(module, exports) {

$parcel$export(module.exports, "InputListView", () => $4d219774fe6fcb61$export$70ece18bfb20ea18);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $kweMg = parcelRequire("kweMg");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $9r7BT = parcelRequire("9r7BT");
const $4d219774fe6fcb61$var$InputLists = ({ input: input, onRemoved: onRemoved })=>{
    const key = `${input}_${Math.random()}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $4d219774fe6fcb61$var$inputStyles,
        key: key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9r7BT.default), {
        "aria-label": "default text field",
        value: input,
        isReadOnly: true,
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
            "aria-label": "Remove",
            title: "Remove",
            appearance: "subtle-link",
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kweMg))), {
                label: "remove",
                LEGACY_size: "small"
            }),
            spacing: "compact",
            onClick: ()=>onRemoved(input)
        })
    }));
};
const $4d219774fe6fcb61$export$70ece18bfb20ea18 = (props)=>{
    const lists = props.inputs;
    const allLists = [];
    lists.forEach((input)=>{
        allLists.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d219774fe6fcb61$var$InputLists, {
            input: input,
            key: Math.random(),
            onRemoved: props.onRemoved
        }));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "servicedesk-customers-organization-common.ui.add-customers-dialog.form.fields.dynamic-input-field.input-lists.valid-input-list"
    }, allLists);
};
const $4d219774fe6fcb61$export$f8e84d94e9def29c = $4d219774fe6fcb61$export$70ece18bfb20ea18;
const $4d219774fe6fcb61$var$inputStyles = (0, $2s57o.xcss)({
    display: 'flex',
    position: 'relative',
    marginBottom: 'space.050',
    alignItems: 'center'
});

});

parcelRegister("l7moB", function(module, exports) {

$parcel$export(module.exports, "default", () => $58899026d7d6d9ff$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $58899026d7d6d9ff$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    customerEmails: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.dynamic-input-field.customer-emails",
        "defaultMessage": "Customer email"
    },
    placeHolder: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.dynamic-input-field.place-holder",
        "defaultMessage": "Enter email address(es)"
    },
    info: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.dynamic-input-field.info",
        "defaultMessage": "Add email addresses one by one, or enter multiple email addresses separated by commas."
    },
    invalidEmail: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.dynamic-input-field.invalid-email",
        "defaultMessage": "Enter a valid email address."
    },
    signupUnAvailable: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.dynamic-input-field.signup-un-available",
        "defaultMessage": "Sign-up is currently unavailable."
    },
    helpTooltip: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.dynamic-input-field.help-tooltip",
        "defaultMessage": "Help"
    }
});

});

parcelRegister("98OlA", function(module, exports) {

$parcel$export(module.exports, "transformToInviteFailedEmails", () => $133dcd6221b8d760$export$cd75681d7c6a14d3);
const $133dcd6221b8d760$export$cd75681d7c6a14d3 = (emails)=>{
    const failedEmails = emails.map((email)=>({
            email: email.email,
            errorMessage: email.error
        }));
    return failedEmails;
};

});


parcelRegister("lJbR5", function(module, exports) {

$parcel$export(module.exports, "OrganizationsSelectField", () => $2b8035291cd64945$export$bcd3b277f4e72180);

var $5uXOq = parcelRequire("5uXOq");

var $4EHpO = parcelRequire("4EHpO");

var $koVbs = parcelRequire("koVbs");

var $3Ypxa = parcelRequire("3Ypxa");

var $2xVho = parcelRequire("2xVho");

var $ane1U = parcelRequire("ane1U");

var $bvqwR = parcelRequire("bvqwR");
const $2b8035291cd64945$export$bcd3b277f4e72180 = ({ useCommonPageContext: useCommonPageContext })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { baseUrl: baseUrl, projectId: projectId, projectKey: projectKey } = useCommonPageContext();
    const [{ organization: organization }, { setOrganization: setOrganization }] = (0, $ane1U.useAddCustomersDialogContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EHpO.default), {
        name: "add-to-organizations-field",
        label: formatMessage((0, $bvqwR.default).addToOrganizationsUpdated)
    }, ({ fieldProps: { id: id } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xVho.OrganizationsSelectField), {
            hidePlaceholder: false,
            inputId: id,
            /* @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string' */ baseUrl: baseUrl,
            /* @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string' */ projectId: projectId,
            /* @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string' */ projectKey: projectKey,
            value: organization,
            // @ts-expect-error - TS2322 - Type '([selectedOption]: [any]) => void' is not assignable to type '(arg1: Organizations) => void'.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onModify: ([selectedOption])=>{
                setOrganization(selectedOption);
            },
            shouldLockScimOrganization: true
        }));
};
$2b8035291cd64945$export$bcd3b277f4e72180.defaultProps = {
    useCommonPageContext: (0, $3Ypxa.useCommonPageContext)
};

});
parcelRegister("2xVho", function(module, exports) {

$parcel$export(module.exports, "OrganizationsSelectField", () => $f66ee1981efde54d$export$bcd3b277f4e72180);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $k5Wbc = parcelRequire("k5Wbc");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $kOrgQ = parcelRequire("kOrgQ");

var $1SYUy = parcelRequire("1SYUy");

var $3PUJp = parcelRequire("3PUJp");

var $6zjVp = parcelRequire("6zjVp");

var $30wAD = parcelRequire("30wAD");
const $f66ee1981efde54d$export$bcd3b277f4e72180 = ({ baseUrl: baseUrl, projectKey: projectKey, projectId: projectId, isMulti: isMulti, useOrganizationSearchService: useOrganizationSearchService, onModify: onModify, selectedOrganizations: selectedOrganizations, shouldLockScimOrganization: shouldLockScimOrganization = false, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { error: error, loading: loading, fetch: fetch, hasOrganizations: hasOrganizations } = useOrganizationSearchService({
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectId: projectId
    });
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fetchWithDebounce = (0, $5uXOq.useCallback)((0, $kOrgQ.debounce)(async ({ query: query, resolve: resolve })=>{
        const organizations = await fetch(query);
        const formattedOptions = (0, $30wAD.mapOrganizationsToLabelOptions)(organizations, formatMessage, {
            shouldLockScimOrganization: shouldLockScimOrganization
        });
        resolve(formattedOptions);
    }), []);
    const handleOnInputChange = (args)=>{
        fetchWithDebounce(args);
    };
    const onSelect = (selected)=>{
        if (!(0, $30wAD.isSelectedOptionValid)(selectedOrganizations, selected)) return undefined;
        return onModify([
            ...selectedOrganizations,
            selected
        ]);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $f66ee1981efde54d$var$spacedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6zjVp.OrganizationsSingleSelect), {
        ...props,
        isMulti: isMulti,
        onFetchOptions: handleOnInputChange,
        onSelect: onSelect,
        hasOrganizations: hasOrganizations
    }), !loading && error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k5Wbc.ErrorMessage), null, formatMessage((0, $1SYUy.default).somethingWentWrong)));
};
$f66ee1981efde54d$export$bcd3b277f4e72180.defaultProps = {
    isMulti: false,
    useOrganizationSearchService: (0, $3PUJp.useOrganizationSearchService),
    selectedOrganizations: [],
    onModify: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $f66ee1981efde54d$var$spacedStyles = (0, $2s57o.xcss)({
    marginTop: 'space.050'
});

});
parcelRegister("kOrgQ", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $1a61c6be259d7def$export$61fc7d43ac8f84b0);

var $lFKmC = parcelRequire("lFKmC");
const $1a61c6be259d7def$export$e39301eefbc90236 = 300;
const $1a61c6be259d7def$export$61fc7d43ac8f84b0 = (callBack, timeout = $1a61c6be259d7def$export$e39301eefbc90236)=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(callBack, timeout);

});

parcelRegister("3PUJp", function(module, exports) {

$parcel$export(module.exports, "useOrganizationSearchService", () => $c33f4a98973a4f97$export$68d41c9eaa29b2a3);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $kIZrg = parcelRequire("kIZrg");
// we debounce the success event firing, to more accurately represent a complete search
// as opposed to a search which is triggered mid-way through a user's search term
const $c33f4a98973a4f97$var$searchSuccessDebounceTime = 2000;
const $c33f4a98973a4f97$export$68d41c9eaa29b2a3 = ({ baseUrl: baseUrl, projectId: projectId })=>{
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [data, setData] = (0, $5uXOq.useState)(null);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [hasOrganizations, setHasOrganizations] = (0, $5uXOq.useState)(true);
    const abortController = (0, $5uXOq.useRef)(null);
    const fireSearchSuccessEvent = (0, $5uXOq.useCallback)((// @ts-expect-error - TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
    analyticsEvent, { isSearchStringEmpty: isSearchStringEmpty })=>{
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'jsmOrganizationsSearch succeeded', {
            isSearchStringEmpty: isSearchStringEmpty
        });
    }, []);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedFireSearchSuccessEvent = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(fireSearchSuccessEvent, $c33f4a98973a4f97$var$searchSuccessDebounceTime, {
        leading: true,
        trailing: false
    }), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fetch = (0, $5uXOq.useCallback)(async (query)=>{
        let organizationsResponse = [];
        setLoading(true);
        setError(null);
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        if (abortController.current && abortController.current.abort) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        abortController.current.abort();
        try {
            abortController.current = new AbortController();
            // @ts-expect-error - TS2339 - Property 'signal' does not exist on type 'unknown'.
            const { signal: signal } = abortController.current;
            const response = await (0, $eusud.performGetRequest)((0, $kIZrg.getFetchUrl)(baseUrl, projectId, query), {
                signal: signal
            });
            const analyticsEvent = createAnalyticsEvent({});
            debouncedFireSearchSuccessEvent(analyticsEvent, {
                isSearchStringEmpty: query === ''
            });
            if (!response.length && query === '') setHasOrganizations(false);
            organizationsResponse = response;
            setData(response);
            setLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            if (err && err.name === 'AbortError') return organizationsResponse;
            (0, $jcw0u.default)({
                meta: {
                    id: 'organizationSearchServiceFetch',
                    packageName: 'jiraServicedeskCustomersOrganizationCommon',
                    teamName: 'boysenberry'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            setLoading(false);
            setError(err);
        }
        return organizationsResponse;
    }, [
        baseUrl,
        createAnalyticsEvent,
        debouncedFireSearchSuccessEvent,
        projectId
    ]);
    return {
        loading: loading,
        hasOrganizations: hasOrganizations,
        error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceError'.
        error,
        data: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceData<Organizations>'.
        data,
        fetch: // @ts-expect-error - TS2322 - Type '(query: string) => Promise<any>' is not assignable to type '(() => Promise<void>) & ((query: string) => Promise<Organizations>)'.
        fetch
    };
};

});
parcelRegister("kIZrg", function(module, exports) {

$parcel$export(module.exports, "getFetchUrl", () => $71c83b29014ccd62$export$e6bbfc5a530be3a5);

var $ebyGx = parcelRequire("ebyGx");
const $71c83b29014ccd62$export$e6bbfc5a530be3a5 = (baseUrl, projectId, query = '')=>`${baseUrl}/rest/servicedesk/1/organisations/project/${projectId}/invite/search?${(0, $ebyGx.stringify)({
        query: query
    })}`;

});


parcelRegister("6zjVp", function(module, exports) {

$parcel$export(module.exports, "OrganizationsSingleSelect", () => $ca51f83dd6f6263d$export$47e1db464d15fcd1);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $6eFvr = parcelRequire("6eFvr");

var $hWb15 = parcelRequire("hWb15");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");


var $grvcE = parcelRequire("grvcE");

var $d18et = parcelRequire("d18et");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ca51f83dd6f6263d$var$menuPortal = (base)=>({
        ...base,
        zIndex: (0, $gwIPs.layers).modal
    });
const $ca51f83dd6f6263d$export$47e1db464d15fcd1 = ({ onFetchOptions: onFetchOptions, onSelect: onSelect, hidePlaceholder: hidePlaceholder = true, inputId: inputId, value: value, allowCreate: allowCreate = true, showOrgStatus: showOrgStatus = true, hasOrganizations: hasOrganizations, isMulti: isMulti })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { onChange: onChange, loadOptions: loadOptions, isValidNewOption: isValidNewOption, formatOptionLabel: formatOptionLabel, getNewOptionData: getNewOptionData } = (0, $d18et.useSelectUtils)({
        onSelect: onSelect,
        onFetchOptions: onFetchOptions
    });
    const disableCreateNewOption = (0, $4R6GH.fg)('jcs_master_flag') && !allowCreate;
    const hideOrgStatus = (0, $4R6GH.fg)('jcs_master_flag') && !showOrgStatus;
    const getNoResultsMessage = ()=>{
        return hasOrganizations ? formatMessage((0, $grvcE.default).noResultsMessage) : formatMessage((0, $grvcE.default).noOrganizationsMessage, {
            strong: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
                    as: "strong"
                }, children),
            br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null))
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hWb15.default), {
        classNamePrefix: (0, $f5221490a3db223e$export$60fb28d4aee3606e),
        controlShouldRenderValue: !isMulti,
        defaultOptions: true,
        formatCreateLabel: (orgName)=>`${formatMessage((0, $grvcE.default).createNew, {
                orgName: orgName
            })}`,
        formatOptionLabel: hideOrgStatus ? undefined : formatOptionLabel,
        getNewOptionData: getNewOptionData,
        isClearable: !isMulti,
        isValidNewOption: disableCreateNewOption ? ()=>false : isValidNewOption,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        menuPortalTarget: document.body,
        noOptionsMessage: ()=>disableCreateNewOption ? getNoResultsMessage() : formatMessage((0, $grvcE.default).noOptionsMessage),
        // @ts-expect-error - TS2322 - Type '(selectedOption: Option) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
        onChange: onChange,
        styles: {
            menuPortal: $ca51f83dd6f6263d$var$menuPortal
        },
        value: value,
        placeholder: hidePlaceholder ? '' : formatMessage((0, $grvcE.default).placeHolder),
        loadOptions: loadOptions,
        id: "servicedesk-customers-organization-common.common.ui.organizations-select-field.organizations-single-select.ak-select",
        inputId: inputId
    });
};
$ca51f83dd6f6263d$export$47e1db464d15fcd1.defaultProps = {
    onFetchOptions: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    isMulti: false
};

});
parcelRegister("hWb15", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a381e401f5858fc$export$2e2bcd8739ae039);

var $a5fqi = parcelRequire("a5fqi");

var $7Qatx = parcelRequire("7Qatx");
const $8a381e401f5858fc$var$AsyncCreatableSelect = (0, $7Qatx.default)((0, $a5fqi.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8a381e401f5858fc$export$2e2bcd8739ae039 = $8a381e401f5858fc$var$AsyncCreatableSelect;

});
parcelRegister("a5fqi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c64bcd60e073ff9c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $djBXi = parcelRequire("djBXi");

var $2OKnX = parcelRequire("2OKnX");

var $jtdsb = parcelRequire("jtdsb");

var $63z2N = parcelRequire("63z2N");
const $c64bcd60e073ff9c$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, $2OKnX.default)(props);
    const creatableProps = (0, $63z2N.default)(stateManagerProps);
    const selectProps = (0, $jtdsb.default)(creatableProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $djBXi.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c64bcd60e073ff9c$export$2e2bcd8739ae039 = $c64bcd60e073ff9c$var$AsyncCreatableSelect;

});


parcelRegister("grvcE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eac0de11f94a2b1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7eac0de11f94a2b1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeHolder: {
        "id": "servicedesk-customers-organization-common.common.organizations-select-field.organizations-single-select.place-holder",
        "defaultMessage": "Choose or create an organization"
    },
    createNew: {
        "id": "servicedesk-customers-organization-common.common.organizations-select-field.organizations-single-select.create-new",
        "defaultMessage": "{orgName} (create new)"
    },
    noOptionsMessage: {
        "id": "servicedesk-customers-organization-common.common.organizations-select-field.organizations-single-select.no-options-message",
        "defaultMessage": "Start typing to create a new organization"
    },
    noResultsMessage: {
        "id": "servicedesk-customers-organization-common.common.organizations-select-field.organizations-single-select.no-results-message",
        "defaultMessage": "No results found"
    },
    noOrganizationsMessage: {
        "id": "servicedesk-customers-organization-common.common.organizations-select-field.organizations-single-select.no-organizations-message",
        "defaultMessage": "<strong>No results</strong> <br></br> Make sure the organization has been added to this site."
    }
});

});

parcelRegister("d18et", function(module, exports) {

$parcel$export(module.exports, "useSelectUtils", () => $3bb799b833395866$export$4c82a60b518ea238);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $d2P5H = parcelRequire("d2P5H");

var $eAbLl = parcelRequire("eAbLl");
const $3bb799b833395866$export$4c82a60b518ea238 = ({ onSelect: onSelect, onFetchOptions: onFetchOptions })=>{
    const onChange = (selectedOption)=>{
        onSelect(selectedOption);
    };
    const getNewOptionData = (name, label)=>({
            label: label,
            name: name,
            value: (0, $d2P5H.NEW),
            status: '',
            numberOfOtherProjects: 0
        });
    const loadOptions = (query, resolve)=>{
        onFetchOptions({
            query: query,
            resolve: resolve
        });
    };
    const isValidNewOption = (inputValue, inputAsOption, OptionList)=>{
        if (!inputValue || !inputValue.trim()) return false;
        return !OptionList.some(({ name: name })=>name.toLowerCase() === inputValue.trim().toLowerCase());
    };
    const formatOptionLabel = ({ label: label, name: name, status: status, value: value, scimManaged: scimManaged = false })=>{
        const labelValue = `${name}${status ? ` (${status})` : ''}`;
        if ((0, $d2P5H.isNew)(value)) return label;
        if ((0, $4R6GH.fg)('jsm_lock_scim_managed_customer_and_org')) return scimManaged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eAbLl.LockOption), null, labelValue) : labelValue;
        return labelValue;
    };
    return {
        onChange: onChange,
        loadOptions: loadOptions,
        getNewOptionData: getNewOptionData,
        isValidNewOption: isValidNewOption,
        formatOptionLabel: formatOptionLabel
    };
};

});
parcelRegister("d2P5H", function(module, exports) {

$parcel$export(module.exports, "NEW", () => $6f2162faf952bfcf$export$591d0ec9c2f920ab);
$parcel$export(module.exports, "isNew", () => $6f2162faf952bfcf$export$d113f15803554ffb);
const $6f2162faf952bfcf$export$591d0ec9c2f920ab = 'new';
const $6f2162faf952bfcf$export$d113f15803554ffb = (value)=>value === $6f2162faf952bfcf$export$591d0ec9c2f920ab;

});

parcelRegister("eAbLl", function(module, exports) {

$parcel$export(module.exports, "LockOption", () => $60e3c5b25d318b73$export$49a6d1b278445b2b);

var $5uXOq = parcelRequire("5uXOq");

var $HlKKM = parcelRequire("HlKKM");

var $2Eqc8 = parcelRequire("2Eqc8");

var $5KCCi = parcelRequire("5KCCi");

var $koVbs = parcelRequire("koVbs");

var $cLAT2 = parcelRequire("cLAT2");
const $60e3c5b25d318b73$export$49a6d1b278445b2b = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        space: "space.100"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: formatMessage((0, $cLAT2.default).scimManagedOrganizationTooltipNonFinal),
        position: "right-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($HlKKM))), {
        label: formatMessage((0, $cLAT2.default).scimManagedOrganizationLockIconLabelNonFinal),
        testId: "servicedesk-customers-organization-common.common.ui.organizations-select-field.organizations-single-select.lock-option.lock-filled-icon",
        color: "var(--ds-icon-disabled, #091E424F)",
        spacing: "none"
    })));
};

});
parcelRegister("HlKKM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68229889f75a07fa608250b88614c064>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0824e3fa19dc190f$var$_react = $0824e3fa19dc190f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0824e3fa19dc190f$var$_baseNew = $0824e3fa19dc190f$var$_interopRequireDefault((parcelRequire("enEmH")));
function $0824e3fa19dc190f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for indicating something is locked in the side navigation Menu Item.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0824e3fa19dc190f$var$LockLockedIcon = (props)=>/*#__PURE__*/ $0824e3fa19dc190f$var$_react.default.createElement($0824e3fa19dc190f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1.5A1.5 1.5 0 0 0 4.5 3v2.5h3V3A1.5 1.5 0 0 0 6 1.5m3 4.01V3a3 3 0 0 0-6 0v2.51c-.844.094-1.5.809-1.5 1.678v3.125c0 .931.756 1.687 1.688 1.687h5.624c.932 0 1.688-.755 1.688-1.687V7.187c0-.868-.656-1.583-1.5-1.677" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$0824e3fa19dc190f$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $0824e3fa19dc190f$var$_default = module.exports.default = $0824e3fa19dc190f$var$LockLockedIcon;

});

parcelRegister("cLAT2", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa58d33fc5f12149$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $aa58d33fc5f12149$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    scimManagedOrganizationTooltipNonFinal: {
        "id": "servicedesk-customers-organization-common.common.organizations-select-field.organizations-single-select.lock-option.scim-managed-organization-tooltip-nonfinal",
        "defaultMessage": "Customers can't be added to an organization synced from an external directory"
    },
    scimManagedOrganizationLockIconLabelNonFinal: {
        "id": "servicedesk-customers-organization-common.common.organizations-select-field.organizations-single-select.lock-option.scim-managed-organization-lock-icon-label-nonfinal",
        "defaultMessage": "SCIM managed organization"
    }
});

});





parcelRegister("bvqwR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6623fbd6a568e8e6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6623fbd6a568e8e6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addToOrganizationsUpdated: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.fields.organizations-select-field.add-to-organizations-updated",
        "defaultMessage": "Add customers to organization"
    }
});

});


parcelRegister("hSL8E", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $aa232022b0b87b5a$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8zOmE = parcelRequire("8zOmE");

var $58zs6 = parcelRequire("58zs6");

var $ane1U = parcelRequire("ane1U");
const $aa232022b0b87b5a$export$a06f1c675e846f6f = ({ useAddCustomersDialogContext: useAddCustomersDialogContext, isLoading: isLoading, onCancel: onCancel, hasMultiHcAndInviteRouting: hasMultiHcAndInviteRouting })=>{
    const [{ customerEmailsInputFieldValue: customerEmailsInputFieldValue, customers: customers, helpCenter: helpCenter }] = useAddCustomersDialogContext();
    const isCustomerFormValid = Boolean(customerEmailsInputFieldValue || customers.length);
    const isValidHelpCenterSelected = hasMultiHcAndInviteRouting ? Boolean(helpCenter) : true;
    const isFormValid = isCustomerFormValid && isValidHelpCenterSelected;
    // @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    const onSubmit = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'addCustomerButton');
    }, []);
    const handleOnCancel = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        onCancel();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'cancelAddCustomerButton');
    }, [
        onCancel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $58zs6.FooterControls), {
        isFormValid: isFormValid,
        isLoading: isLoading,
        onSubmit: onSubmit,
        onCancel: handleOnCancel
    });
};
$aa232022b0b87b5a$export$a06f1c675e846f6f.defaultProps = {
    useAddCustomersDialogContext: (0, $ane1U.useAddCustomersDialogContext),
    isLoading: false,
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};

});
parcelRegister("58zs6", function(module, exports) {

$parcel$export(module.exports, "FooterControls", () => $aa686df84c2b3821$export$377702b113c526d0);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jHTSg = parcelRequire("jHTSg");

var $i95f5 = parcelRequire("i95f5");

var $cNW3X = parcelRequire("cNW3X");

var $iu66X = parcelRequire("iu66X");

var $8RXs9 = parcelRequire("8RXs9");

var $TxgSe = parcelRequire("TxgSe");
const $aa686df84c2b3821$export$9b45ee8853d84503 = ({ intl: { formatMessage: formatMessage }, isFormValid: isFormValid = false, isLoading: isLoading = false, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCancel: onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iu66X.default), {
        align: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHTSg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "link",
        onClick: onCancel,
        testId: "servicedesk-customers-organization-common.common.ui.inline-dialog.footer-controls.cancel-button"
    }, formatMessage((0, $TxgSe.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i95f5.default), {
        appearance: "primary",
        type: "submit",
        isLoading: isLoading,
        isDisabled: !isFormValid,
        testId: "servicedesk-customers-organization-common.common.ui.inline-dialog.footer-controls.submit-button",
        onClick: onSubmit
    }, formatMessage((0, $TxgSe.default).save))));
const $aa686df84c2b3821$export$377702b113c526d0 = (0, $8RXs9.default)($aa686df84c2b3821$export$9b45ee8853d84503);

});
parcelRegister("TxgSe", function(module, exports) {

$parcel$export(module.exports, "default", () => $b834fee8f5b85d1e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b834fee8f5b85d1e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    save: {
        "id": "servicedesk-customers-organization-common.common.inline-dialog.footer-controls.save",
        "defaultMessage": "Ok"
    },
    cancel: {
        "id": "servicedesk-customers-organization-common.common.inline-dialog.footer-controls.cancel",
        "defaultMessage": "Cancel"
    }
});

});



parcelRegister("7E0iL", function(module, exports) {

$parcel$export(module.exports, "default", () => $51a1bab950f5f539$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $51a1bab950f5f539$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addCustomers: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.add-customers",
        "defaultMessage": "Add customers"
    },
    requiredField: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.form.required-field",
        "defaultMessage": "Required fields are marked with an asterisk"
    }
});

});



parcelRegister("evcfb", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e8384222b65ee05$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4e8384222b65ee05$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addCustomers: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.add-customers",
        "defaultMessage": "Add customers"
    },
    addedCustomersNew: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.added-customers-new",
        "defaultMessage": "{count, plural, one {One customer has} other {{count} customers have}} been added"
    },
    addedCustomersNewMultipleHelpCenters: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.added-customers-new-multiple-help-centers",
        "defaultMessage": "{count, plural, one {Customer} other {Customers}} added to project"
    },
    addedCustomersDescriptionNew: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.added-customers-description-new",
        "defaultMessage": "They\u2019ll receive an invitation email if they haven\u2019t already been added to a project on this site."
    },
    addedCustomersWhenEmailDisabled: {
        "id": "servicedesk-customers-organization-common.add-customers-dialog.added-customers-when-email-disabled",
        "defaultMessage": "Their details will be visible in the table soon."
    }
});

});

parcelRegister("5lL3K", function(module, exports) {

$parcel$export(module.exports, "useFormSubmissionUtils", () => $110973c28867e926$export$306794bcfd14cc20);

var $5uXOq = parcelRequire("5uXOq");

var $3Ypxa = parcelRequire("3Ypxa");


var $ijXMg = parcelRequire("ijXMg");

var $ane1U = parcelRequire("ane1U");

var $2N8KQ = parcelRequire("2N8KQ");
const $110973c28867e926$export$306794bcfd14cc20 = (useCommonPageContext = (0, $3Ypxa.useCommonPageContext), useAddCustomersDialogContext = (0, $ane1U.useAddCustomersDialogContext))=>{
    const { baseUrl: baseUrl, projectKey: projectKey } = useCommonPageContext();
    const { data: invitedCustomers, loading: isSubmitting, error: error, fetch: inviteCustomersFetch, resetAll: resetInviteCustomer } = (0, $2N8KQ.useInviteCustomerService)(baseUrl, projectKey);
    const [{ customerEmailsInputFieldValue: customerEmailsInputFieldValue, customers: customers, defaultOrganization: defaultOrganization, organization: organization, helpCenter: helpCenter }, { resetForm: resetForm }] = useAddCustomersDialogContext();
    // onSubmit get email's from validated list and
    // concat with email's from input text field and pass it down to api
    const onFormSubmit = (0, $5uXOq.useCallback)(()=>{
        inviteCustomersFetch([
            ...customers.map(({ emailAddress: emailAddress })=>emailAddress),
            ...(0, $ijXMg.splitInputTextBySeparator)(customerEmailsInputFieldValue)
        ], organization || defaultOrganization, helpCenter);
    }, [
        customerEmailsInputFieldValue,
        customers,
        defaultOrganization,
        inviteCustomersFetch,
        organization,
        helpCenter
    ]);
    // if there are any failed errors switch to Unsuccessful view.
    const formSubmissionStatus = (0, $5uXOq.useMemo)(()=>{
        if (invitedCustomers) {
            const { failed: failed } = invitedCustomers;
            return failed.length > 0 ? (0, $2422a353ae27ab4c$export$8a5cac0f50542e41) : (0, $2422a353ae27ab4c$export$523ddafd4d035371);
        }
        return 0, $2422a353ae27ab4c$export$f5940ec982f5760a;
    }, [
        invitedCustomers
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            if (formSubmissionStatus !== (0, $2422a353ae27ab4c$export$f5940ec982f5760a)) {
                resetForm();
                resetInviteCustomer();
            }
        }, [
        formSubmissionStatus,
        resetForm,
        resetInviteCustomer
    ]);
    return {
        invitedCustomers: invitedCustomers,
        isSubmitting: isSubmitting,
        formSubmissionStatus: formSubmissionStatus,
        error: error,
        onFormSubmit: onFormSubmit
    };
};

});
parcelRegister("2N8KQ", function(module, exports) {

$parcel$export(module.exports, "useInviteCustomerService", () => $6b66d0fe64c139cd$export$87fa0fb80753bd93);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $a7EYT = parcelRequire("a7EYT");

var $d2P5H = parcelRequire("d2P5H");

var $Hxan5 = parcelRequire("Hxan5");

var $aWe7l = parcelRequire("aWe7l");
const $6b66d0fe64c139cd$export$87fa0fb80753bd93 = (baseUrl, projectKey)=>{
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [data, setData] = (0, $5uXOq.useState)(null);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const resetAll = (0, $5uXOq.useCallback)(()=>{
        setLoading(false);
        setError(null);
        setData(null);
    }, []);
    const fetch = (0, $5uXOq.useCallback)(async (emails, selectedOrganization, helpCenter)=>{
        setLoading(true);
        setError(null);
        const name = selectedOrganization ? selectedOrganization.name : undefined;
        const value = selectedOrganization ? selectedOrganization.value : undefined;
        const isExistingOrganization = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) && !(0, $d2P5H.isNew)(value);
        const asyncRequest = isExistingOrganization ? (0, $a7EYT.performPutRequest) : (0, $a7EYT.performPostRequest);
        const requestParams = isExistingOrganization ? {
            id: value
        } : {
            name: name
        };
        const helpCenterAri = helpCenter ? helpCenter.value : undefined;
        (0, $Hxan5.addCustomersExperience).start();
        try {
            const response = await asyncRequest((0, $aWe7l.getUrl)(baseUrl, projectKey, requestParams), {
                body: JSON.stringify({
                    emails: emails,
                    helpCenterAri: helpCenterAri
                })
            });
            setData(response);
            setLoading(false);
            const event = createAnalyticsEvent({
                action: 'added',
                actionSubject: 'customer'
            });
            (0, $8zOmE.fireTrackAnalytics)(event, 'customer added', {
                helpCenterAri: helpCenterAri,
                organizationId: isExistingOrganization ? value : 'new',
                customerCount: response?.success.length
            });
            (0, $Hxan5.addCustomersExperience).success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const { reasonKey: reasonKey, errors: errors, response: response, message: message } = err;
            // Only fire analytics for unexpected errors. ValidationErrors are used when
            // the backend returns a 400. Expected 400 errors from the backend include:
            // - the email address is invalid (eg `bad@email@example.com`)
            // A 403 is also returned if the user doesn't have permission to invite, but
            // we only show the invite button after a permission check -
            // it's an unexpected error if we see it here
            const shouldFireErrorAnalytics = err.statusCode !== 400;
            if (shouldFireErrorAnalytics) (0, $jcw0u.default)({
                error: err,
                meta: {
                    id: 'useInviteCustomerService',
                    packageName: 'jiraServicedeskCustomersOrganizationCommon',
                    teamName: 'boysenberry'
                },
                sendToPrivacyUnsafeSplunk: true,
                attributes: {
                    reasonKey: reasonKey
                }
            });
            if (reasonKey || errors) {
                const errResponse = (0, $aWe7l.getNormalisedErrorResponse)(emails, message);
                setData(errResponse);
            } else setData(response);
            setLoading(false);
            (0, $Hxan5.addCustomersExperience).failure();
        }
    }, [
        baseUrl,
        createAnalyticsEvent,
        projectKey
    ]);
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type '((Error | ValidationErrors | { statusCode: number; message?: string | undefined; }) & ValidationErrors) | null'.
        error,
        data: data,
        fetch: // @ts-expect-error - TS2322 - Type '(emails: string[], selectedOrganization?: Organization | undefined) => Promise<void>' is not assignable to type '(() => Promise<void>) & ((emails: string[], organization?: Organization | undefined) => Promise<void>)'.
        fetch,
        resetAll: resetAll
    };
};

});
parcelRegister("Hxan5", function(module, exports) {

$parcel$export(module.exports, "customersSearchPageLoadExperience", () => $09294d771bf6d6ad$export$61e599b0d34da2ca);
$parcel$export(module.exports, "customersAddOrganizationsExperience", () => $09294d771bf6d6ad$export$84f192290bc89991);
$parcel$export(module.exports, "addCustomersExperience", () => $09294d771bf6d6ad$export$79bf9994161d022d);
$parcel$export(module.exports, "organizationsSearchPageLoadExperience", () => $09294d771bf6d6ad$export$279040ebcab27f66);
$parcel$export(module.exports, "organizationsEditOrganizationExperience", () => $09294d771bf6d6ad$export$5296ba6bbe54bab3);
$parcel$export(module.exports, "organizationsDeleteOrganizationExperience", () => $09294d771bf6d6ad$export$59d239ec2b4de868);
$parcel$export(module.exports, "organizationsRemoveFromProjectExperience", () => $09294d771bf6d6ad$export$72b1810a14185543);
$parcel$export(module.exports, "removeOrganizationExperience", () => $09294d771bf6d6ad$export$3963aeaf4a56bd80);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");
const $09294d771bf6d6ad$export$61e599b0d34da2ca = new (0, $kkzI0.UFOExperience)('jsm-customers-component-search-page-load', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
});
const $09294d771bf6d6ad$export$84f192290bc89991 = new (0, $kkzI0.UFOExperience)('jsm-customers-component-add-organizations', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
});
const $09294d771bf6d6ad$export$79bf9994161d022d = new (0, $kkzI0.UFOExperience)('jsm-customers-component-add-customers', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
});
const $09294d771bf6d6ad$export$279040ebcab27f66 = new (0, $kkzI0.UFOExperience)('jsm-organizations-component-search-page-load', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
});
const $09294d771bf6d6ad$export$5296ba6bbe54bab3 = new (0, $kkzI0.UFOExperience)('jsm-organizations-component-edit-organization', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
});
const $09294d771bf6d6ad$export$59d239ec2b4de868 = new (0, $kkzI0.UFOExperience)('jsm-organizations-component-delete-organization', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
});
const $09294d771bf6d6ad$export$72b1810a14185543 = new (0, $kkzI0.UFOExperience)('jsm-organizations-component-remove-from-project', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
});
const $09294d771bf6d6ad$export$3963aeaf4a56bd80 = new (0, $kkzI0.UFOExperience)('jsm-customers-component-remove-organization', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
});
const $09294d771bf6d6ad$export$191cbf8bc5a77d43 = new (0, $kkzI0.UFOExperience)('jsm-help-center-data-fetch', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("aWe7l", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $7a82dca886dfc203$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "getNormalisedErrorResponse", () => $7a82dca886dfc203$export$5728355a49dfa06c);

var $hGgHi = parcelRequire("hGgHi");

var $ebyGx = parcelRequire("ebyGx");
const $7a82dca886dfc203$var$stringifyOptions = {
    skipNull: true,
    skipEmptyString: true,
    sort: false
};
const $7a82dca886dfc203$export$94df0e59ebebf4a7 = (baseUrl, projectKey, { name: name, id: id } = {})=>{
    const defaultUrl = `${baseUrl}/rest/servicedesk/1/pages/people/customers/pagination/${projectKey}/invite`;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(name) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(id)) return defaultUrl;
    // @ts-expect-error - TS2559 - Type '{ readonly skipNull: true; readonly skipEmptyString: true; readonly sort: false; }' has no properties in common with type 'StringifyOptions'.
    return `${defaultUrl}/organisation?${(0, $ebyGx.stringify)({
        name: name,
        id: id
    }, $7a82dca886dfc203$var$stringifyOptions)}`;
};
const $7a82dca886dfc203$export$747d1d330d4149d2 = (emails, errMsg)=>{
    const errArr = errMsg.split(' ').map((str)=>str.replace(',', ''));
    // exactly match email to error message eg: test in test@email.com should not be matched
    // should only match example@email.com in example@email.com, not in example@email.com.au
    return emails.filter((email)=>errArr.indexOf(email) > -1);
};
const $7a82dca886dfc203$export$5728355a49dfa06c = (emails, reasonKey)=>{
    const invalidEmails = $7a82dca886dfc203$export$747d1d330d4149d2(emails, reasonKey);
    const failed = invalidEmails.map((email)=>({
            displayName: email,
            emailAddress: email,
            key: email,
            error: reasonKey
        }));
    return {
        failed: failed,
        success: [],
        optimisticCustomerListUpdateResults: []
    };
};

});





parcelRegister("8q4uj", function(module, exports) {

$parcel$export(module.exports, "AddOrganizationsInlineDialogButton", () => $139a17ada54fc4b8$export$9797a7be620e94b7);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $koVbs = parcelRequire("koVbs");

var $eHJxW = parcelRequire("eHJxW");

var $8L2oS = parcelRequire("8L2oS");

var $30wAD = parcelRequire("30wAD");

var $ewLXz = parcelRequire("ewLXz");

var $i5aET = parcelRequire("i5aET");
const $139a17ada54fc4b8$export$9797a7be620e94b7 = ()=>{
    const [organizations, setOrganizations] = (0, $5uXOq.useState)([]);
    const [isOpen, togglePopup, onCloseDialog] = (0, $8L2oS.usePopupController)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onReset = (0, $5uXOq.useCallback)(()=>{
        setOrganizations([]);
    }, []);
    const onResetAndCloseDialog = (0, $5uXOq.useCallback)(()=>{
        onReset();
        onCloseDialog();
    }, [
        onCloseDialog,
        onReset
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
        messageId: "servicedesk-customers.ui.header-actions.add-organizations-dialog.inline-dialog",
        messageType: "transactional",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ewLXz.AddOrganizationsForm), {
            // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'Organizations'.
            organizations: organizations,
            setOrganizations: setOrganizations,
            onReset: onReset,
            onCloseDialog: onCloseDialog,
            onResetAndCloseDialog: onResetAndCloseDialog
        }),
        isOpen: isOpen,
        onClose: ({ event: event })=>{
            // don't allow in-line dialog to close if close event is triggered from AkSelect.
            // @ts-expect-error - TS2345 - Argument of type 'Event' is not assignable to parameter of type 'MouseEvent'.
            if ((0, $30wAD.isEventFromOrganizationSelectDropList)(event)) return;
            togglePopup();
        },
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        testId: "servicedesk-customers.ui.header-actions.add-organizations-dialog.button",
        onClick: togglePopup
    }, formatMessage((0, $i5aET.default).addOrganizations)));
};

});
parcelRegister("ewLXz", function(module, exports) {

$parcel$export(module.exports, "AddOrganizationsForm", () => $d8cfec62b7f128a4$export$63d5eafb874a84e2);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $bngFq = parcelRequire("bngFq");

var $3Ypxa = parcelRequire("3Ypxa");

var $6Bva3 = parcelRequire("6Bva3");

var $7k4W3 = parcelRequire("7k4W3");

var $Hxan5 = parcelRequire("Hxan5");

var $iib8U = parcelRequire("iib8U");

var $1AKpq = parcelRequire("1AKpq");

var $erRzl = parcelRequire("erRzl");

var $9FH9E = parcelRequire("9FH9E");
const $d8cfec62b7f128a4$export$63d5eafb874a84e2 = ({ organizations: organizations, useInviteOrganizationService: useInviteOrganizationService = (0, $1AKpq.useInviteOrganizationService), setOrganizations: setOrganizations, onReset: onReset, onCloseDialog: onCloseDialog, onResetAndCloseDialog: onResetAndCloseDialog })=>{
    const { baseUrl: baseUrl, projectId: projectId } = (0, $3Ypxa.useCommonPageContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: invitedOrganizations, loading: isSubmitting, error: error, fetch: onInvite } = useInviteOrganizationService(baseUrl, projectId);
    const [, { fetchAndUpdatePageData: fetchAndUpdatePageData }] = (0, $iib8U.useAppStore)();
    const onSubmit = ()=>{
        (0, $Hxan5.customersAddOrganizationsExperience).start();
        onInvite(organizations);
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (invitedOrganizations) {
            fetchAndUpdatePageData({
                createAnalyticsEvent: createAnalyticsEvent
            });
            (0, $Hxan5.customersAddOrganizationsExperience).success();
            onReset();
        }
    }, [
        createAnalyticsEvent,
        fetchAndUpdatePageData,
        invitedOrganizations,
        onReset
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error) (0, $Hxan5.customersAddOrganizationsExperience).failure();
    }, [
        error
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Bva3.DialogWrapper), {
        "data-test-id": "servicedesk-customers.ui.header-actions.add-organizations-dialog.form.dialog-wrappper"
    }, invitedOrganizations ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7k4W3.SuccessFlag), {
        title: formatMessage((0, $9FH9E.default).addOrganizations),
        description: formatMessage((0, $9FH9E.default).successfullyAddedOrganizations, {
            organizationsCount: organizations.length
        }),
        onDismissed: onCloseDialog
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "addOrganizations",
        sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erRzl.Form), {
        isSubmitting: isSubmitting,
        error: error,
        onReset: onResetAndCloseDialog,
        onSubmit: onSubmit,
        organizations: organizations,
        setOrganizations: setOrganizations
    })));
};

});
parcelRegister("1AKpq", function(module, exports) {

$parcel$export(module.exports, "useInviteOrganizationService", () => $36eb83153651eabf$export$e33069e484b04dbd);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $dOREC = parcelRequire("dOREC");
const $36eb83153651eabf$export$e33069e484b04dbd = (baseUrl, projectId)=>{
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [data, setData] = (0, $5uXOq.useState)(null);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fetch = (0, $5uXOq.useCallback)(async (organizations)=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $eusud.performPutRequest)((0, $dOREC.getUrl)(baseUrl, projectId), {
                body: JSON.stringify((0, $dOREC.getRequestPayload)(organizations))
            });
            if (response.organizationsCreated.length > 0) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'organization created', {
                organizationCount: response.organizationsCreated.length
            });
            setData(response);
            setLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setLoading(false);
            setError(err);
            // Only fire analytics for unexpected errors. ValidationErrors are used when
            // the backend returns a 400. Expected 400 errors from the backend include:
            // - organization name is > 200 characters
            // A 403 is returned if the user doesn't have permission to manage organizations,
            // but I'm not sure how to replicate that situation so I'll leave it as unexpected
            const shouldFireErrorAnalytics = !(0, $jJZqs.isValidationError)(err);
            if (shouldFireErrorAnalytics) (0, $jcw0u.default)({
                error: err,
                meta: {
                    id: 'useInviteOrganizationService',
                    packageName: 'jiraServicedeskCustomers',
                    teamName: 'boysenberry'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        baseUrl,
        projectId,
        createAnalyticsEvent
    ]);
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type '((Error | ValidationErrors | { statusCode: number; message?: string | undefined; }) & ValidationErrors) | null'.
        error,
        data: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceData<Data>'.
        data,
        fetch: // @ts-expect-error - TS2322 - Type '(organizations: Organizations) => Promise<void>' is not assignable to type '(() => Promise<void>) & ((arg1: Organizations) => Promise<void>)'.
        fetch
    };
};

});
parcelRegister("dOREC", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $98ba9718bb6cc0b0$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "getRequestPayload", () => $98ba9718bb6cc0b0$export$6ef87b3284359833);

var $d2P5H = parcelRequire("d2P5H");
const $98ba9718bb6cc0b0$export$94df0e59ebebf4a7 = (baseUrl, projectId)=>`${baseUrl}/rest/servicedesk/1/servicedesk/${projectId}/organisation/invite`;
const $98ba9718bb6cc0b0$export$6ef87b3284359833 = (organizations = [])=>organizations.reduce((payload, { name: name, value: value })=>{
        if ((0, $d2P5H.isNew)(value)) // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        payload.newOrganisationNames.push(name);
        else // @ts-expect-error - TS2345 - Argument of type 'string | number | undefined' is not assignable to parameter of type 'never'.
        payload.existingOrganisationIds.push(value);
        return payload;
    }, {
        existingOrganisationIds: [],
        newOrganisationNames: []
    });

});


parcelRegister("erRzl", function(module, exports) {

$parcel$export(module.exports, "Form", () => $eecac31d4574e926$export$a7fed597f4b8afd8);

var $5uXOq = parcelRequire("5uXOq");

var $7folp = parcelRequire("7folp");
var $9rZBe = parcelRequire("9rZBe");
var $cGltd = parcelRequire("cGltd");

var $koVbs = parcelRequire("koVbs");

var $3Ypxa = parcelRequire("3Ypxa");

var $38Kqf = parcelRequire("38Kqf");

var $2xVho = parcelRequire("2xVho");

var $8buDf = parcelRequire("8buDf");

var $2lFLF = parcelRequire("2lFLF");

var $9FH9E = parcelRequire("9FH9E");
const $eecac31d4574e926$var$INPUT_ID = 'add-organizations-field';
const $eecac31d4574e926$export$a7fed597f4b8afd8 = ({ organizations: organizations, setOrganizations: setOrganizations, isSubmitting: isSubmitting, onReset: onReset, onSubmit: onSubmit, error: error })=>{
    const { baseUrl: baseUrl, projectId: projectId, projectKey: projectKey } = (0, $3Ypxa.useCommonPageContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7folp.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
            ...formProps,
            name: "add-organizations-form"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9rZBe.default), {
            title: formatMessage((0, $9FH9E.default).addOrganizations)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cGltd.Label), {
            htmlFor: $eecac31d4574e926$var$INPUT_ID
        }, formatMessage((0, $9FH9E.default).selectOrgLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xVho.OrganizationsSelectField), {
            inputId: $eecac31d4574e926$var$INPUT_ID,
            // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            baseUrl: baseUrl,
            // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            projectId: projectId,
            // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            projectKey: projectKey,
            selectedOrganizations: organizations,
            onModify: setOrganizations,
            isMulti: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2lFLF.OrganizationList), {
            organizations: organizations,
            onRemove: setOrganizations
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Kqf.FormErrors), {
            formErrors: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8buDf.Footer), {
            isLoading: isSubmitting,
            organizations: organizations,
            onCancel: onReset
        })));
};

});
parcelRegister("8buDf", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $467386966d8f8499$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $4ZXBI = parcelRequire("4ZXBI");
const $467386966d8f8499$export$a06f1c675e846f6f = ({ isLoading: isLoading, organizations: organizations, onCancel: onCancel })=>{
    const isFormValid = organizations && organizations.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ZXBI.Footer), {
        isFormValid: isFormValid,
        isLoading: isLoading,
        onCancel: onCancel
    });
};
$467386966d8f8499$export$a06f1c675e846f6f.defaultProps = {
    isLoading: false
};

});
parcelRegister("4ZXBI", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $d39c84f9d2d5877c$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jHTSg = parcelRequire("jHTSg");

var $i95f5 = parcelRequire("i95f5");

var $cNW3X = parcelRequire("cNW3X");

var $iu66X = parcelRequire("iu66X");

var $8RXs9 = parcelRequire("8RXs9");

var $8hwzs = parcelRequire("8hwzs");
const $d39c84f9d2d5877c$export$af41f29dfb7e37b8 = ({ intl: { formatMessage: formatMessage }, isFormValid: isFormValid = false, isLoading: isLoading = false, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCancel: onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iu66X.default), {
        align: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHTSg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i95f5.default), {
        appearance: "primary",
        type: "submit",
        isLoading: isLoading,
        isDisabled: !isFormValid,
        testId: "servicedesk-customers-organization-common.common.ui.inline-dialog.footer.submit-button",
        onClick: onSubmit
    }, formatMessage((0, $8hwzs.default).add)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "link",
        onClick: onCancel,
        testId: "servicedesk-customers-organization-common.common.ui.inline-dialog.footer.cancel-button"
    }, formatMessage((0, $8hwzs.default).cancel))));
const $d39c84f9d2d5877c$export$a06f1c675e846f6f = (0, $8RXs9.default)($d39c84f9d2d5877c$export$af41f29dfb7e37b8);

});
parcelRegister("8hwzs", function(module, exports) {

$parcel$export(module.exports, "default", () => $577811c8656ebcda$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $577811c8656ebcda$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    add: {
        "id": "servicedesk-customers-organization-common.common.inline-dialog.footer.add",
        "defaultMessage": "Add"
    },
    cancel: {
        "id": "servicedesk-customers-organization-common.common.inline-dialog.footer.cancel",
        "defaultMessage": "Cancel"
    }
});

});



parcelRegister("2lFLF", function(module, exports) {

$parcel$export(module.exports, "OrganizationList", () => $30a4c24665d8c300$export$cd4ccaec2b292eeb);

var $5uXOq = parcelRequire("5uXOq");

var $hzMjB = parcelRequire("hzMjB");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $4R6GH = parcelRequire("4R6GH");

var $5fRXP = parcelRequire("5fRXP");
const $30a4c24665d8c300$export$cd4ccaec2b292eeb = (props)=>{
    const rows = (0, $5fRXP.useRows)({
        ...props,
        showOrgStatus: !((0, $4R6GH.fg)('jcs_master_flag') && !props.showOrgStatus)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $30a4c24665d8c300$var$tableContainerStyles,
        "data-testId": "servicedesk-customers.ui.header-actions.add-organizations-dialog.form.fields.selected-list.table-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hzMjB.default), {
        rows: rows,
        // @ts-expect-error - TS2769 - No overload matches this call.
        paginationi18n: {
            prev: '',
            next: ''
        },
        isFixedSize: true
    }));
};
const $30a4c24665d8c300$var$tableContainerStyles = (0, $2s57o.xcss)({
    // @ts-expect-error - TS2322 - Object literal may only specify known properties
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    thead: {
        borderBottom: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    tbody: {
        borderBottom: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    tfoot: {
        borderBottom: 'none'
    },
    marginTop: 'space.250'
});

});
parcelRegister("hzMjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $544abce1911f4899$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bKnKN = parcelRequire("bKnKN");

var $ij3f3 = parcelRequire("ij3f3");

var $cTmPi = parcelRequire("cTmPi");
class $544abce1911f4899$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            defaultPage: 1,
            isLoading: false,
            isFixedSize: false,
            isRankable: false,
            onSetPage: (0, $bKnKN.default),
            onSort: (0, $bKnKN.default),
            rowsPerPage: Infinity
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cTmPi.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args), this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        }, this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        }, this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        }, this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        }, this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $ij3f3.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}

});
parcelRegister("ij3f3", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $998feb1dd684a5f5$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $998feb1dd684a5f5$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $998feb1dd684a5f5$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $998feb1dd684a5f5$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $998feb1dd684a5f5$export$c476bbe5da59992d);
const $998feb1dd684a5f5$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $998feb1dd684a5f5$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $998feb1dd684a5f5$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $998feb1dd684a5f5$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $998feb1dd684a5f5$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $998feb1dd684a5f5$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $998feb1dd684a5f5$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $998feb1dd684a5f5$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("cTmPi", function(module, exports) {

$parcel$export(module.exports, "default", () => $42488a711cb2a1a2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $bKnKN = parcelRequire("bKnKN");

var $fHpHg = parcelRequire("fHpHg");


var $ij3f3 = parcelRequire("ij3f3");

var $gSzpH = parcelRequire("gSzpH");

var $5Du8N = parcelRequire("5Du8N");

var $aeHUt = parcelRequire("aeHUt");

var $iNWZG = parcelRequire("iNWZG");

var $hp7Nj = parcelRequire("hp7Nj");

var $b2Las = parcelRequire("b2Las");

var $kwDS1 = parcelRequire("kwDS1");

var $2CS2C = parcelRequire("2CS2C");
function $42488a711cb2a1a2$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $dd4c19bf39ff9e0d$export$b6abcf7fa1d94f65:
            return 0, $dd4c19bf39ff9e0d$export$1dee026a19752d6b;
        case 0, $dd4c19bf39ff9e0d$export$1dee026a19752d6b:
            return 0, $dd4c19bf39ff9e0d$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $42488a711cb2a1a2$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $bKnKN.default), onSort: providedOnSort = (0, $bKnKN.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $bKnKN.default), onRankEnd: providedOnRankEnd = (0, $bKnKN.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: (0, $fHpHg.fg)('eax-1131_fix_a11y_issues_global_issues_settings') ? 'Previous Page' : 'Previous',
    next: (0, $fHpHg.fg)('eax-1131_fix_a11y_issues_global_issues_settings') ? 'Next Page' : 'Next',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
    const tableBodyRef = (0, $5uXOq.useRef)(null);
    const onSort = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $5uXOq.useEffect)(()=>{
        (0, $ij3f3.validateSortKey)(sortKey, head);
        (0, $ij3f3.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $dd4c19bf39ff9e0d$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $dd4c19bf39ff9e0d$export$1dee026a19752d6b) : $42488a711cb2a1a2$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $ij3f3.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $dd4c19bf39ff9e0d$export$7b93a10c0fefe3e3) : (0, $dd4c19bf39ff9e0d$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Du8N.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Du8N.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b2Las.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gSzpH.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gSzpH.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2CS2C.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $2OMIu.jsx)($42488a711cb2a1a2$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gSzpH.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kwDS1.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hp7Nj.default), {
                isLoading: isLoading,
                spinnerSize: (0, $dd4c19bf39ff9e0d$export$7b93a10c0fefe3e3),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $42488a711cb2a1a2$var$RankableTableBody = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("d6J9p")));
const $42488a711cb2a1a2$var$TableBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aeHUt.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iNWZG.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($42488a711cb2a1a2$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$42488a711cb2a1a2$export$2e2bcd8739ae039 = $42488a711cb2a1a2$var$DynamicTable;

});
const $dd4c19bf39ff9e0d$export$1dee026a19752d6b = 'ASC';
const $dd4c19bf39ff9e0d$export$b6abcf7fa1d94f65 = 'DESC';
const $dd4c19bf39ff9e0d$export$71dd4c8ecd45e95f = 'small';
const $dd4c19bf39ff9e0d$export$7b93a10c0fefe3e3 = 'large';
const $dd4c19bf39ff9e0d$export$3843c586a90b9cbf = 0.22;

parcelRegister("gSzpH", function(module, exports) {

$parcel$export(module.exports, "Table", () => $24d7481443a55849$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $24d7481443a55849$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $24d7481443a55849$export$3e5e12dc01f20a43);
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $24d7481443a55849$var$fixedSizeTableStyles = null;
const $24d7481443a55849$var$tableStyles = null;
const $24d7481443a55849$var$bodyBorder = null;
const $24d7481443a55849$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': `var(--ds-background-neutral-subtle-hovered, ${(0, $a7f8c6b391092279$export$e655ef011c4aa1a2)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': `var(--ds-background-selected, ${(0, $a7f8c6b391092279$export$226de0355ed012f8)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': `var(--ds-background-selected-hovered, ${(0, $a7f8c6b391092279$export$8c13c2ee36917869)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': `var(--ds-border-focused, ${(0, $a7f8c6b391092279$export$ecfc1dff386a3e7a)})`
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _yq5h18uv _btyzidpf",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1on0"
        ]),
        children: children
    });
});
const $24d7481443a55849$var$captionStyles = null;
const $24d7481443a55849$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("caption", {
        className: (0, $bwpsq.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });
const $24d7481443a55849$var$paginationWrapperStyles = null;
const $24d7481443a55849$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });

});

parcelRegister("5Du8N", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $20087acc75665f07$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $20087acc75665f07$export$381ea436de119582);
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $20087acc75665f07$var$fixedHeightStyles = null;
const $20087acc75665f07$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $bwpsq.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });
const $20087acc75665f07$var$emptyViewContainerStyles = null;
const $20087acc75665f07$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $bwpsq.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};

});

parcelRegister("aeHUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $50e36766e70be217$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7BCCl = parcelRequire("7BCCl");

var $cbo5N = parcelRequire("cbo5N");
class $50e36766e70be217$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cbo5N.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $50e36766e70be217$var$Body = (0, $7BCCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($50e36766e70be217$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$50e36766e70be217$export$2e2bcd8739ae039 = $50e36766e70be217$var$Body;

});
parcelRegister("7BCCl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3b182fe0cf2229d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $ij3f3 = parcelRequire("ij3f3");
const $b3b182fe0cf2229d$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $b3b182fe0cf2229d$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $dd4c19bf39ff9e0d$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $b3b182fe0cf2229d$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $b3b182fe0cf2229d$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $b3b182fe0cf2229d$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $ij3f3.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $b3b182fe0cf2229d$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $ij3f3.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("cbo5N", function(module, exports) {

$parcel$export(module.exports, "default", () => $216850390cb73ba7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gbw3g = parcelRequire("gbw3g");

var $2U6hb = parcelRequire("2U6hb");
const $216850390cb73ba7$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2U6hb.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $gbw3g.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$216850390cb73ba7$export$2e2bcd8739ae039 = $216850390cb73ba7$var$Row;

});
parcelRegister("gbw3g", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $52ed7867b18d7d2f$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aWmPD = parcelRequire("aWmPD");
const $52ed7867b18d7d2f$var$fixedSizeTruncateStyles = null;
const $52ed7867b18d7d2f$var$overflowTruncateStyles = null;
const $52ed7867b18d7d2f$var$truncationWidthStyles = null;
const $52ed7867b18d7d2f$var$cellStyles = null;
const $52ed7867b18d7d2f$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $aWmPD.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("aWmPD", function(module, exports) {

$parcel$export(module.exports, "getTruncationStyleVars", () => $9539443fa733857a$export$5e6497a652ae30b5);
const $9539443fa733857a$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $9539443fa733857a$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$9539443fa733857a$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("2U6hb", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $e1fb566ccb11044c$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $e1fb566ccb11044c$var$rowStyles = null;
const $e1fb566ccb11044c$var$rowBackgroundStyles = null;
const $e1fb566ccb11044c$var$rowHighlightedBackgroundStyles = null;
const $e1fb566ccb11044c$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_bfhk1w7a _1ygbi9un _1ah312gs",
            isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});

});



parcelRegister("iNWZG", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $b51c6f453b8bb8d8$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
class $b51c6f453b8bb8d8$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("hp7Nj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecf9d3bdd3bcf46f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $clxo5 = parcelRequire("clxo5");


var $9jhBP = parcelRequire("9jhBP");
class $ecf9d3bdd3bcf46f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $dd4c19bf39ff9e0d$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $dd4c19bf39ff9e0d$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9jhBP.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9jhBP.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9jhBP.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}

});
parcelRegister("9jhBP", function(module, exports) {

$parcel$export(module.exports, "Container", () => $1e66cab656bc739a$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $1e66cab656bc739a$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $1e66cab656bc739a$export$a5e06607a5ac6158);
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $1e66cab656bc739a$export$c335a80381ec61f5 = '--contents-opacity';
const $1e66cab656bc739a$var$containerStyles = null;
const $1e66cab656bc739a$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $bwpsq.default)([
            "_kqswh2mm"
        ]),
        children: children
    });
const $1e66cab656bc739a$var$contentsContainerStyles = null;
const $1e66cab656bc739a$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$1e66cab656bc739a$export$c335a80381ec61f5]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $bwpsq.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });
const $1e66cab656bc739a$var$spinnerContainerStyles = null;
const $1e66cab656bc739a$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $bwpsq.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });

});


parcelRegister("b2Las", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5bdf68b643c0b74$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $clxo5 = parcelRequire("clxo5");


var $iEr2L = parcelRequire("iEr2L");
class $d5bdf68b643c0b74$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $dd4c19bf39ff9e0d$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $dd4c19bf39ff9e0d$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $iEr2L.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iEr2L.SpinnerBackdrop), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iEr2L.SpinnerContainer), {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("iEr2L", function(module, exports) {

$parcel$export(module.exports, "Container", () => $c5257b659c462a01$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $c5257b659c462a01$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $c5257b659c462a01$export$a5e06607a5ac6158);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $c5257b659c462a01$var$containerStyles = null;
const $c5257b659c462a01$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $c5257b659c462a01$var$spinnerBackdropStyles = null;
const $c5257b659c462a01$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $bwpsq.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $c5257b659c462a01$var$spinnerContainerStyles = null;
const $c5257b659c462a01$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));

});


parcelRegister("kwDS1", function(module, exports) {

$parcel$export(module.exports, "default", () => $19a3bebc831e1e20$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $PtOw7 = parcelRequire("PtOw7");
class $19a3bebc831e1e20$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $PtOw7.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("PtOw7", function(module, exports) {

$parcel$export(module.exports, "default", () => $91e10201005ed209$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $bKnKN = parcelRequire("bKnKN");

var $8yr9w = parcelRequire("8yr9w");

var $kXQqt = parcelRequire("kXQqt");

var $aCQsl = parcelRequire("aCQsl");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");

var $iJ7Hz = parcelRequire("iJ7Hz");

var $f1QVj = parcelRequire("f1QVj");

var $g8LB7 = parcelRequire("g8LB7");

var $aeBLd = parcelRequire("aeBLd");

var $jyOn7 = parcelRequire("jyOn7");
const $91e10201005ed209$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $91e10201005ed209$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $91e10201005ed209$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($kXQqt))) : (0, (/*@__PURE__*/$parcel$interopDefault($aCQsl)));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        as: "span",
        xcss: $91e10201005ed209$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor"
        })
    });
}
function $91e10201005ed209$var$InnerPagination({ components: components = (0, $aeBLd.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $aeBLd.emptyObject), max: max = 7, onChange: onChange = (0, $bKnKN.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $g8LB7.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $8yr9w.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$91e10201005ed209$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
            as: "li",
            xcss: $91e10201005ed209$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f1QVj.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iJ7Hz.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($91e10201005ed209$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $91e10201005ed209$var$styles.paginationMenu,
                    children: (0, $jyOn7.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iJ7Hz.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($91e10201005ed209$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $91e10201005ed209$var$Pagination = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)($91e10201005ed209$var$InnerPagination));
var $91e10201005ed209$export$2e2bcd8739ae039 = $91e10201005ed209$var$Pagination;

});
parcelRegister("kXQqt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8f114aeec843a8c754b38083d324c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f431fc1028e06487$var$_react = $f431fc1028e06487$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f431fc1028e06487$var$_chevronLeft = $f431fc1028e06487$var$_interopRequireDefault((parcelRequire("eBgkU")));

var $f431fc1028e06487$var$_chevronLeftLarge = $f431fc1028e06487$var$_interopRequireDefault((parcelRequire("doPom")));
function $f431fc1028e06487$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f431fc1028e06487$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $f431fc1028e06487$var$_react.default.createElement($f431fc1028e06487$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $f431fc1028e06487$var$_chevronLeftLarge.default
    }, props));
$f431fc1028e06487$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $f431fc1028e06487$var$_default = module.exports.default = $f431fc1028e06487$var$ChevronLeftIcon;

});
parcelRegister("eBgkU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f3eb59553566fe46c3ae42f5cce545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa11316e1b9a50e5$var$_react = $aa11316e1b9a50e5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aa11316e1b9a50e5$var$_baseNew = $aa11316e1b9a50e5$var$_interopRequireDefault((parcelRequire("enEmH")));
function $aa11316e1b9a50e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aa11316e1b9a50e5$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $aa11316e1b9a50e5$var$_react.default.createElement($aa11316e1b9a50e5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$aa11316e1b9a50e5$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $aa11316e1b9a50e5$var$_default = module.exports.default = $aa11316e1b9a50e5$var$ChevronLeftIcon;

});

parcelRegister("doPom", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c156198aff068d9$var$_react = $9c156198aff068d9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $9c156198aff068d9$var$_chevronLeft = $9c156198aff068d9$var$_interopRequireDefault((parcelRequire("eBgkU")));
function $9c156198aff068d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9c156198aff068d9$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $9c156198aff068d9$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $9c156198aff068d9$var$_chevronLeft.default,
        iconType: "utility"
    }));
$9c156198aff068d9$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $9c156198aff068d9$var$_default = module.exports.default = $9c156198aff068d9$var$ChevronLeftLargeIcon;

});


parcelRegister("aCQsl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc9d13c7d9aac3b58cfed9b747dada0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bc624ae76a75667$var$_react = $7bc624ae76a75667$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7bc624ae76a75667$var$_chevronRight = $7bc624ae76a75667$var$_interopRequireDefault((parcelRequire("LD2gx")));

var $7bc624ae76a75667$var$_chevronRightLarge = $7bc624ae76a75667$var$_interopRequireDefault((parcelRequire("asO21")));
function $7bc624ae76a75667$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7bc624ae76a75667$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $7bc624ae76a75667$var$_react.default.createElement($7bc624ae76a75667$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $7bc624ae76a75667$var$_chevronRightLarge.default
    }, props));
$7bc624ae76a75667$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $7bc624ae76a75667$var$_default = module.exports.default = $7bc624ae76a75667$var$ChevronRightIcon;

});
parcelRegister("asO21", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79e3541f2bdfe48d$var$_react = $79e3541f2bdfe48d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $79e3541f2bdfe48d$var$_chevronRight = $79e3541f2bdfe48d$var$_interopRequireDefault((parcelRequire("LD2gx")));
function $79e3541f2bdfe48d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $79e3541f2bdfe48d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $79e3541f2bdfe48d$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $79e3541f2bdfe48d$var$_chevronRight.default,
        iconType: "utility"
    }));
$79e3541f2bdfe48d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $79e3541f2bdfe48d$var$_default = module.exports.default = $79e3541f2bdfe48d$var$ChevronRightLargeIcon;

});


parcelRegister("iJ7Hz", function(module, exports) {

$parcel$export(module.exports, "default", () => $68429c818e1bccf1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");
function $68429c818e1bccf1$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("f1QVj", function(module, exports) {

$parcel$export(module.exports, "default", () => $57683c779a270b1e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");
function $57683c779a270b1e$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("g8LB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $37065f33cd465684$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
var $k9nuy = parcelRequire("k9nuy");

var $cBCgC = parcelRequire("cBCgC");
const $37065f33cd465684$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $37065f33cd465684$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        as: "li",
        testId: testId,
        xcss: $37065f33cd465684$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $k9nuy.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cBCgC.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("aeBLd", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $e96752320d8ebdcb$export$3f860eba1218f8d3);
const $e96752320d8ebdcb$export$3f860eba1218f8d3 = {};

});

parcelRegister("jyOn7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed4cd84ee61a68bf$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $ed4cd84ee61a68bf$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $8QpSo.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $ed4cd84ee61a68bf$export$2e2bcd8739ae039 = $ed4cd84ee61a68bf$var$collapseRange;

});



parcelRegister("2CS2C", function(module, exports) {

$parcel$export(module.exports, "default", () => $7743ec6945b03629$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $ij3f3 = parcelRequire("ij3f3");

var $Y6nvS = parcelRequire("Y6nvS");

var $6zHVQ = parcelRequire("6zHVQ");

var $kJnN1 = parcelRequire("kJnN1");

var $jMIMt = parcelRequire("jMIMt");

var $7VUM5 = parcelRequire("7VUM5");
class $7743ec6945b03629$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $ij3f3.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $ij3f3.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponentOld = isRankable ? (0, $kJnN1.default) : (0, $7VUM5.default);
        const HeadCellComponent = isRankable ? (0, $6zHVQ.default) : (0, $jMIMt.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Y6nvS.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return (0, $fHpHg.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index) : /*#__PURE__*/ (0, $2OMIu.jsx)(HeadCellComponentOld, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        onClick: isSortable ? onSort(cell) : undefined,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7743ec6945b03629$export$2e2bcd8739ae039 = $7743ec6945b03629$var$TableHead;

});
parcelRegister("Y6nvS", function(module, exports) {

$parcel$export(module.exports, "Head", () => $2025e7fb6aa79e5a$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $2025e7fb6aa79e5a$export$4e8024263ace498b);
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");



var $aWmPD = parcelRequire("aWmPD");
const $2025e7fb6aa79e5a$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $2025e7fb6aa79e5a$var$rankingStyles = null;
const $2025e7fb6aa79e5a$var$headStyles = null;
const $2025e7fb6aa79e5a$var$overflowTruncateStyles = null;
const $2025e7fb6aa79e5a$var$truncationWidthStyles = null;
const $2025e7fb6aa79e5a$var$fixedSizeTruncateStyles = null;
const $2025e7fb6aa79e5a$var$cellStyles = null;
const $2025e7fb6aa79e5a$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $bwpsq.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};
const $2025e7fb6aa79e5a$var$headCellBaseStyles = null;
const $2025e7fb6aa79e5a$var$headCellBaseStylesOld = null;
const $2025e7fb6aa79e5a$var$onClickStyles = null;
const $2025e7fb6aa79e5a$var$baseStyles = null;
const $2025e7fb6aa79e5a$var$ascendingStyles = null;
const $2025e7fb6aa79e5a$var$descendingStyles = null;
const $2025e7fb6aa79e5a$export$4e8024263ace498b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $aWmPD.getTruncationStyleVars)({
            width: width
        }),
        [$2025e7fb6aa79e5a$var$CSS_VAR_TEXT_COLOR]: `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$e2ef2124cf4024b1)})`
    };
    const isASC = sortOrder === (0, $dd4c19bf39ff9e0d$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $dd4c19bf39ff9e0d$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    const isVisuallyRefreshed = (0, $fHpHg.fg)('platform-component-visual-refresh');
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: !isVisuallyRefreshed ? onClick : undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $bwpsq.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            isVisuallyRefreshed ? "_11c8dcr7 _179r1on0 _mqm2glyw _vchhusvi _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4nkob _1ygbvd8c" : "_11c8dcr7 _179r1on0 _mqm2glyw _t51zglyw _191wglyw _vchhusvi _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4jp4b _1ygbvd8c",
            !isVisuallyRefreshed && onClick && "_irr3yw9d _d0altlke",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            !isVisuallyRefreshed && isSortable && "_173zglyw _pw6dglyw _1xgk3acm _1wfn3acm _y9yonqa1 _997wnqa1 _sklb1l7b _1j091l7b _19w61ule _1w611ule _1hvvidpf _n56nidpf _wyc4idpf _1d4oidpf _no7mstnw _qh32stnw _4b5mb3bt _hn3bb3bt _14gsx0bf _cigmx0bf _c77kvia6 _qzvtu2gc _f473via6 _1fpyidpf _a04fh2mm _xv14glyw _58ej1kw7 _1ay31kw7 _mdbq1kw7 _10pp1kw7 _1yw3ze3t _n2fdze3t _8607ze3t _szhwze3t _1g2wwc43 _ze9fwc43 _1lcgnqa1 _at5qnqa1 _o4d71l7b _npl51l7b _1rp11onz _1iornqa1 _oi051l7b _1ehx1onz _19t8nqa1 _1bog1l7b",
            !isVisuallyRefreshed && isASC && "_c77k1thn _142s94yt",
            !isVisuallyRefreshed && isDESC && "_f4731thn _17x894yt"
        ]),
        children: children
    });
});

});

parcelRegister("6zHVQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5450d9bbffcc8125$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eYd2T = parcelRequire("eYd2T");

var $ij3f3 = parcelRequire("ij3f3");

var $jMIMt = parcelRequire("jMIMt");
class $5450d9bbffcc8125$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $ij3f3.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jMIMt.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $5450d9bbffcc8125$var$RankableTableHeadCell = (0, $eYd2T.default)($5450d9bbffcc8125$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5450d9bbffcc8125$export$2e2bcd8739ae039 = $5450d9bbffcc8125$var$RankableTableHeadCell;

});
parcelRegister("eYd2T", function(module, exports) {

$parcel$export(module.exports, "default", () => $12e90393582023be$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $12e90393582023be$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("jMIMt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b03bb1c9491f1dae$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $egUrW = parcelRequire("egUrW");

var $2VhaU = parcelRequire("2VhaU");

var $5sRpy = parcelRequire("5sRpy");
var $AX5oF = parcelRequire("AX5oF");
var $7rJgC = parcelRequire("7rJgC");
var $k9nuy = parcelRequire("k9nuy");

var $5KCCi = parcelRequire("5KCCi");


var $Y6nvS = parcelRequire("Y6nvS");
const $b03bb1c9491f1dae$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk18uv _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $b03bb1c9491f1dae$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o"
};
const $b03bb1c9491f1dae$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $b03bb1c9491f1dae$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
            content: sortOrder === (0, $dd4c19bf39ff9e0d$export$1dee026a19752d6b) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7rJgC.default), {
                onClick: onClick,
                xcss: $b03bb1c9491f1dae$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $AX5oF.default), {
                        xcss: isVisibleIconOnlyHeader ? $b03bb1c9491f1dae$var$styles.hideIconHeaderWrapper : $b03bb1c9491f1dae$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                            size: "small",
                            color: "color.text.subtle",
                            weight: "bold",
                            maxLines: 1,
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $AX5oF.default), {
                        xcss: isSortIconVisible ? $b03bb1c9491f1dae$var$styles.sortIconVisibleWrapper : $b03bb1c9491f1dae$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $dd4c19bf39ff9e0d$export$1dee026a19752d6b) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2VhaU))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($egUrW))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Y6nvS.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b03bb1c9491f1dae$export$2e2bcd8739ae039 = $b03bb1c9491f1dae$var$TableHeadCell;

});
parcelRegister("egUrW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a63e59051f36f4fc$var$_react = $a63e59051f36f4fc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a63e59051f36f4fc$var$_baseNew = $a63e59051f36f4fc$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a63e59051f36f4fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a63e59051f36f4fc$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $a63e59051f36f4fc$var$_react.default.createElement($a63e59051f36f4fc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$a63e59051f36f4fc$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $a63e59051f36f4fc$var$_default = module.exports.default = $a63e59051f36f4fc$var$ArrowDownIcon;

});

parcelRegister("2VhaU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $220e3a34bc1119f8$var$_react = $220e3a34bc1119f8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $220e3a34bc1119f8$var$_baseNew = $220e3a34bc1119f8$var$_interopRequireDefault((parcelRequire("enEmH")));
function $220e3a34bc1119f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $220e3a34bc1119f8$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $220e3a34bc1119f8$var$_react.default.createElement($220e3a34bc1119f8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$220e3a34bc1119f8$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $220e3a34bc1119f8$var$_default = module.exports.default = $220e3a34bc1119f8$var$ArrowUpIcon;

});



parcelRegister("kJnN1", function(module, exports) {

$parcel$export(module.exports, "default", () => $66ca8f1593bf284a$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eYd2T = parcelRequire("eYd2T");

var $ij3f3 = parcelRequire("ij3f3");

var $7VUM5 = parcelRequire("7VUM5");
class $66ca8f1593bf284a$var$RankableTableHeadCellComponentOld extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $ij3f3.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7VUM5.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $66ca8f1593bf284a$var$RankableTableHeadCellOld = (0, $eYd2T.default)($66ca8f1593bf284a$var$RankableTableHeadCellComponentOld);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$66ca8f1593bf284a$export$2e2bcd8739ae039 = $66ca8f1593bf284a$var$RankableTableHeadCellOld;

});
parcelRegister("7VUM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d987b690ad45b553$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $Y6nvS = parcelRequire("Y6nvS");
const $d987b690ad45b553$var$TableHeadCellOld = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Y6nvS.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable,
        children: isSortable ? /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            type: "button",
            "aria-roledescription": "Sort button",
            children: content
        }) : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d987b690ad45b553$export$2e2bcd8739ae039 = $d987b690ad45b553$var$TableHeadCellOld;

});



parcelRegister("d6J9p", function(module, exports) {

let $98aedbe81d989584$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $98aedbe81d989584$var$load("cM9em"),
    $98aedbe81d989584$var$load("fr9NE"),
    $98aedbe81d989584$var$load("avfDe")
]).then(()=>parcelRequire('l80GF'));

});



parcelRegister("5fRXP", function(module, exports) {

$parcel$export(module.exports, "useRows", () => $caddb64b51d42382$export$f74098d2a1be340c);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eOat1 = parcelRequire("eOat1");

var $bEDVx = parcelRequire("bEDVx");
const $caddb64b51d42382$export$f74098d2a1be340c = ({ organizations: organizations, onRemove: onRemove, showOrgStatus: showOrgStatus })=>{
    const rows = (0, $5uXOq.useMemo)(()=>{
        if (!organizations) return [];
        return organizations.map((organization, orgIndex)=>{
            // @ts-expect-error - TS2304 - Cannot find name 'RowCellType'.
            const cells = [];
            const { name: name, status: status } = organization;
            cells.push({
                key: `display-org-${orgIndex}`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($caddb64b51d42382$var$Inline, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($caddb64b51d42382$var$Label, null, name), showOrgStatus && status && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
                    maxWidth: 90,
                    isBold: true
                }, status)),
                colSpan: 80
            });
            cells.push({
                key: `remove-org-${orgIndex}`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEDVx.EditorCell), {
                    name: name,
                    onRemove: ()=>{
                        onRemove(organizations.filter((_, idx)=>idx !== orgIndex));
                    }
                }),
                colSpan: 20
            });
            return {
                key: `organization-name-${orgIndex}`,
                cells: cells
            };
        });
    }, [
        onRemove,
        organizations,
        showOrgStatus
    ]);
    return rows;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $caddb64b51d42382$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $caddb64b51d42382$var$Inline = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _19bv12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bEDVx", function(module, exports) {

$parcel$export(module.exports, "EditorCell", () => $bd4f66046794251c$export$c1f633b9199aef47);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $1hvXK = parcelRequire("1hvXK");

var $koVbs = parcelRequire("koVbs");

var $90hCi = parcelRequire("90hCi");

var $4Vnnd = parcelRequire("4Vnnd");
const $bd4f66046794251c$export$c1f633b9199aef47 = ({ name: name, onRemove: onRemove })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $90hCi.RowActiveCellWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        testId: "servicedesk-customers-organization-common.common.ui.editable-table.editor-cell.button",
        appearance: "subtle",
        "aria-label": formatMessage((0, $4Vnnd.default).removeOption, {
            name: name
        }),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1hvXK))), {
            spacing: "spacious",
            label: ""
        }),
        onClick: onRemove
    }));
};

});
parcelRegister("1hvXK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bce2e8cefeb7a1e23af480e5534534d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ef02c1a2a418954$var$_react = $0ef02c1a2a418954$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0ef02c1a2a418954$var$_delete = $0ef02c1a2a418954$var$_interopRequireDefault((parcelRequire("bGsST")));

var $0ef02c1a2a418954$var$_remove = $0ef02c1a2a418954$var$_interopRequireDefault((parcelRequire("c6G5t")));
function $0ef02c1a2a418954$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DeleteIcon.
 * This component is DeleteIcon, with `UNSAFE_fallbackIcon` set to "EditorRemoveIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0ef02c1a2a418954$var$DeleteIcon = (props)=>/*#__PURE__*/ $0ef02c1a2a418954$var$_react.default.createElement($0ef02c1a2a418954$var$_delete.default, Object.assign({
        LEGACY_fallbackIcon: $0ef02c1a2a418954$var$_remove.default
    }, props));
$0ef02c1a2a418954$var$DeleteIcon.Name = 'DeleteIconMigration';
var $0ef02c1a2a418954$var$_default = module.exports.default = $0ef02c1a2a418954$var$DeleteIcon;

});
parcelRegister("c6G5t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02464d2e668f1757$var$_react = $02464d2e668f1757$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $02464d2e668f1757$var$_delete = $02464d2e668f1757$var$_interopRequireDefault((parcelRequire("bGsST")));
function $02464d2e668f1757$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $02464d2e668f1757$var$EditorRemoveIcon = (props)=>/*#__PURE__*/ $02464d2e668f1757$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m2.78 11a1 1 0 0 1-.97-.757L7.156 10.62A.5.5 0 0 1 7.64 10h8.72a.5.5 0 0 1 .485.621l-1.656 6.622a1 1 0 0 1-.97.757zM11 6h2a1 1 0 0 1 1 1h-4a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $02464d2e668f1757$var$_delete.default
    }));
$02464d2e668f1757$var$EditorRemoveIcon.displayName = 'EditorRemoveIcon';
var $02464d2e668f1757$var$_default = module.exports.default = $02464d2e668f1757$var$EditorRemoveIcon;

});


parcelRegister("90hCi", function(module, exports) {

$parcel$export(module.exports, "RowActiveCellWrapper", () => $89f6e50e866e794c$export$aa416bd4626093c2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");
const $89f6e50e866e794c$export$aa416bd4626093c2 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $89f6e50e866e794c$var$activeCellWrapperStyles,
        "data-class": "RowActiveCellWrapper"
    }, children);
const $89f6e50e866e794c$var$activeCellWrapperStyles = (0, $2s57o.xcss)({
    cursor: 'pointer',
    opacity: 0,
    ':hover': {
        opacity: 1
    },
    ':focus': {
        opacity: 1
    },
    ':focus-within': {
        opacity: 1
    }
});
const $89f6e50e866e794c$export$d3153e190f75eb24 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_113ekb7n _1lp8kb7n _ohpokb7n",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4Vnnd", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fdb85925172b377$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9fdb85925172b377$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    removeOption: {
        "id": "servicedesk-customers-organization-common.common.editable-table.editor-cell.remove-option",
        "defaultMessage": "Remove {name}."
    }
});

});




parcelRegister("9FH9E", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5118d01afadb7d5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c5118d01afadb7d5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addOrganizations: {
        "id": "servicedesk-customers.header-actions.add-organizations-dialog.form.add-organizations",
        "defaultMessage": "Add organizations"
    },
    successfullyAddedOrganizations: {
        "id": "servicedesk-customers.header-actions.add-organizations-dialog.form.successfully-added-organizations",
        "defaultMessage": "Success! Your {organizationsCount, plural, =1 {organization} other {organizations}} have been added."
    },
    selectOrgLabel: {
        "id": "servicedesk-customers.header-actions.add-organizations-dialog.form.select-org-label",
        "defaultMessage": "Choose or create an organization"
    }
});

});



parcelRegister("i5aET", function(module, exports) {

$parcel$export(module.exports, "default", () => $87e1eb8d3e39812a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $87e1eb8d3e39812a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addOrganizations: {
        "id": "servicedesk-customers.header-actions.add-organizations-dialog.add-organizations",
        "defaultMessage": "Add organizations"
    }
});

});



parcelRegister("dlyOv", function(module, exports) {

$parcel$export(module.exports, "SearchWithResults", () => $dac0d4dc7bdb70df$export$2992fdd014352a12);

var $5uXOq = parcelRequire("5uXOq");

var $3s0xG = parcelRequire("3s0xG");

var $2Eqc8 = parcelRequire("2Eqc8");
var $2s57o = parcelRequire("2s57o");

var $3FeVC = parcelRequire("3FeVC");

var $3bt7q = parcelRequire("3bt7q");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $5oFIy = parcelRequire("5oFIy");
var $bngFq = parcelRequire("bngFq");

var $8PRuf = parcelRequire("8PRuf");

var $3TpKp = parcelRequire("3TpKp");

var $jEJ7g = parcelRequire("jEJ7g");

var $3Ypxa = parcelRequire("3Ypxa");

var $kOrgQ = parcelRequire("kOrgQ");

var $Hxan5 = parcelRequire("Hxan5");

var $dAUxP = parcelRequire("dAUxP");

var $dk2ke = parcelRequire("dk2ke");

var $iib8U = parcelRequire("iib8U");

var $em5sh = parcelRequire("em5sh");

var $aJvev = parcelRequire("aJvev");

var $5YiMX = parcelRequire("5YiMX");

var $jmh11 = parcelRequire("jmh11");
// Use longer-than-normal debounce because this is a costly
// endpoint which triggers alerts.  See JIG-335
const $dac0d4dc7bdb70df$var$DEBOUNCE_MILLISECONDS = 500;
const $dac0d4dc7bdb70df$export$2992fdd014352a12 = ()=>{
    const [{ searchString: searchString, loading: loading, pageData: pageData, userPermissions: { projectSimplified: // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    projectSimplified, serviceDeskOpenAccess: // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    serviceDeskOpenAccess, // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    canAdminister: canAdministerProject } = {}, error: error }, { updateSearchString: updateSearchString, updatePageNumber: updatePageNumber, fetchAndUpdatePageData: fetchAndUpdatePageData }] = (0, $iib8U.useAppStore)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { total: total, query: query } = pageData || {};
    const shouldShowSearchTip = !loading && Boolean(pageData || error) && Boolean(searchString);
    const showEmptyState = !loading && !total && !query;
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debounceSearchAction = (0, $5uXOq.useCallback)((0, $kOrgQ.debounce)(// @ts-expect-error - TS2345 - Argument of type '() => void | Promise<void>' is not assignable to parameter of type '(...rest: readonly any[]) => Promise<any>'.
    fetchAndUpdatePageData.bind(null, {
        createAnalyticsEvent: createAnalyticsEvent
    }), $dac0d4dc7bdb70df$var$DEBOUNCE_MILLISECONDS), []);
    const isEditable = projectSimplified && !serviceDeskOpenAccess && canAdministerProject;
    const { projectType: projectType } = (0, $3Ypxa.useCommonPageContext)();
    const isJCS = (0, $jEJ7g.useIsJCSProjectType)(projectType);
    const onSearchChange = (value)=>{
        updateSearchString(value);
        debounceSearchAction();
        (0, $Hxan5.customersSearchPageLoadExperience).start();
    };
    const onPageChange = (value)=>{
        updatePageNumber(value);
        debounceSearchAction();
        (0, $Hxan5.customersSearchPageLoadExperience).start();
    };
    if (error) {
        (0, $Hxan5.customersSearchPageLoadExperience).failure();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAUxP.ErrorView), null);
    }
    if (showEmptyState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        alignInline: "end",
        xcss: $dac0d4dc7bdb70df$var$EmptyStateHeaderActionsWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aJvev.HeaderActions), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        eventName: "customersOrgsEmptyState loaded"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
        header: "",
        maxImageWidth: 320,
        maxImageHeight: 300,
        description: formatMessage((0, $5YiMX.default).noCustomersJsm),
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $3bt7q.default))
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3FeVC.DirHeaderActionsContainer), {
        headerActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aJvev.HeaderActions), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dk2ke.Search), {
        shouldShowSearchTip: shouldShowSearchTip,
        onChange: onSearchChange,
        query: searchString,
        placeholder: formatMessage((0, $5YiMX.default).searchPlaceholder),
        description: formatMessage((0, $5YiMX.default).searchDescription)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jmh11.TableWithActions), {
        setPageData: fetchAndUpdatePageData,
        onPageChange: onPageChange,
        loading: loading,
        pageData: pageData,
        isEditable: isEditable,
        hasActions: !isJCS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3TpKp.JsmPageInteractiveEvent), {
        metricKey: "servicedesk.customers",
        withMarks: [
            (0, $8PRuf.appBundleReadyMark)
        ],
        appName: "servicedesk.customers",
        // @ts-expect-error - TS2322 - Type 'PageLoadMetric' is not assignable to type 'BM3Metric'.
        metric: (0, $em5sh.customersPageLoad),
        extra: {
            version: 2
        }
    }));
};
const $dac0d4dc7bdb70df$var$EmptyStateHeaderActionsWrapperStyles = (0, $2s57o.xcss)({
    marginTop: 'space.300'
});

});
parcelRegister("3FeVC", function(module, exports) {

$parcel$export(module.exports, "DirHeaderActionsContainer", () => $74a00657ff393e0f$export$9a37b99d18581dcf);

var $5uXOq = parcelRequire("5uXOq");

var $2Eqc8 = parcelRequire("2Eqc8");

var $3HwlS = parcelRequire("3HwlS");
const $74a00657ff393e0f$export$9a37b99d18581dcf = ({ headerActions: headerActions, children: children })=>{
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        spread: "space-between",
        alignBlock: "end"
    }, children, headerActions);
    return children;
};

});

parcelRegister("3bt7q", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ac09af3ccced4f9$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $jWRcK = parcelRequire("jWRcK");
const $1ac09af3ccced4f9$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($jWRcK)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($jWRcK))
});
var $1ac09af3ccced4f9$export$2e2bcd8739ae039 = $1ac09af3ccced4f9$var$Illustration;
// for advanced use only
const $1ac09af3ccced4f9$export$a179c88182cb9d56 = [
    0,
    0,
    600,
    386
];

});
parcelRegister("jWRcK", function(module, exports) {
module.exports = new URL("task-board-with-people.e468116d.svg", import.meta.url).toString();

});


parcelRegister("dk2ke", function(module, exports) {

$parcel$export(module.exports, "Search", () => $b4f1456b9df814fe$export$4b85d3515bd863a5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7Jxgt = parcelRequire("7Jxgt");

var $bEIgH = parcelRequire("bEIgH");

var $koVbs = parcelRequire("koVbs");

var $2xSAL = parcelRequire("2xSAL");

var $4R6GH = parcelRequire("4R6GH");

var $dVLDr = parcelRequire("dVLDr");
const $b4f1456b9df814fe$export$4b85d3515bd863a5 = ({ StyledSearchContainer: StyledSearchContainer = $b4f1456b9df814fe$var$StyledSearchContainerDI, SearchTip: SearchTip = $b4f1456b9df814fe$var$SearchTipDI, shouldShowSearchTip: shouldShowSearchTip = false, onChange: onChange, placeholder: placeholder, description: description, query: query })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const descriptionId = (0, $5uXOq.useMemo)(()=>(0, $7Jxgt.v4)(), []);
    return (0, $4R6GH.fg)('jsm_contacts_search_no_org_filter') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyledSearchContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
        placeholder: placeholder,
        isAlwaysExpanded: true,
        increasedWidth: true,
        onChange: onChange,
        value: query,
        placeholderAlwaysVisible: true,
        isAutocompleteDisabled: true,
        describedById: description && descriptionId,
        isCompact: true
    }), shouldShowSearchTip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SearchTip, {
        "data-testid": "servicedesk-customers-organization-common.ui.search.search-tip"
    }, formatMessage((0, $dVLDr.default).searchTip)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        id: descriptionId,
        hidden: true
    }, description))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyledSearchContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
        placeholder: placeholder,
        isAlwaysExpanded: true,
        increasedWidth: true,
        onChange: onChange,
        value: query,
        placeholderAlwaysVisible: true,
        isAutocompleteDisabled: true,
        describedById: description && descriptionId,
        isCompact: true
    }), shouldShowSearchTip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SearchTip, {
        "data-testid": "servicedesk-customers-organization-common.ui.search.search-tip"
    }, formatMessage((0, $dVLDr.default).searchTip)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        id: descriptionId,
        hidden: true
    }, description));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4f1456b9df814fe$var$SearchTipDI = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _18u0pxbi _y3gn1h6o _o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4f1456b9df814fe$var$StyledSearchContainerDI = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qv47k",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dVLDr", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d508304514ddb25$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3d508304514ddb25$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    searchTip: {
        "id": "servicedesk-customers-organization-common.search.search-tip",
        "defaultMessage": "Customer not found? Try refining your search."
    }
});

});


parcelRegister("em5sh", function(module, exports) {

$parcel$export(module.exports, "customersPageLoad", () => $5b72ee6e60b0787f$export$f681daf850d5e9e4);

var $2nKjG = parcelRequire("2nKjG");
const $5b72ee6e60b0787f$export$f681daf850d5e9e4 = (0, $2nKjG.metrics).pageLoad({
    key: 'service-management.customers'
});

});

parcelRegister("5YiMX", function(module, exports) {

$parcel$export(module.exports, "default", () => $01f9cf3a8774c0ce$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $01f9cf3a8774c0ce$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    customersBreadcrumbTitle: {
        "id": "servicedesk-customers.customers-breadcrumb-title",
        "defaultMessage": "Customers"
    },
    noCustomersJsm: {
        "id": "servicedesk-customers.no-customers-jsm",
        "defaultMessage": "There are no customers yet. Invite some to your service project."
    },
    searchPlaceholder: {
        "id": "servicedesk-customers.search-placeholder",
        "defaultMessage": "Search customers and organizations"
    },
    searchDescription: {
        "id": "servicedesk-customers.search-description",
        "defaultMessage": "Typing in the search field will update the results in the below table."
    }
});

});

parcelRegister("jmh11", function(module, exports) {

$parcel$export(module.exports, "TableWithActions", () => $76ee6be365905a17$export$5ac09e049b32e384);

var $5uXOq = parcelRequire("5uXOq");

var $34Vv8 = parcelRequire("34Vv8");

var $3Ypxa = parcelRequire("3Ypxa");

var $8L2oS = parcelRequire("8L2oS");

var $7MSYo = parcelRequire("7MSYo");

var $Hxan5 = parcelRequire("Hxan5");

var $NwEQm = parcelRequire("NwEQm");

var $8EAk1 = parcelRequire("8EAk1");

var $dCnF8 = parcelRequire("dCnF8");

var $lAlfB = parcelRequire("lAlfB");
const $76ee6be365905a17$var$resendVerificationEmail = 'resendVerificationEmail';
const $76ee6be365905a17$var$TableWithActionsView = ({ flagService: { showFlag: showFlag }, setPageData: setPageData, onPageChange: onPageChange, loading: loading, pageData: pageData, isEditable: isEditable, hasActions: hasActions = true })=>{
    const { baseUrl: baseUrl, projectKey: projectKey, projectName: projectName } = (0, $3Ypxa.useCommonPageContext)();
    const { loading: removeCustomerLoading, data: removeCustomerData, fetch: removeCustomer, error: removeCustomerError } = (0, $dCnF8.useRemoveCustomerService)(baseUrl, projectKey);
    const [isRemoveOrganizationDialogOpen, toggleRemoveOrganizationDialog, closeRemoveOrganizationDialog] = (0, $8L2oS.usePopupController)();
    const [toBeRemovedOrganizationInfo, setToBeRemovedOrganizationInfo] = (0, $5uXOq.useState)({
        id: null,
        displayName: ''
    });
    const [toBeRemovedUserInfo, setToBeRemovedUserInfo] = (0, $5uXOq.useState)({
        identifier: '',
        displayName: ''
    });
    const onRemoveClick = (0, $5uXOq.useCallback)((customer)=>{
        const orgProfile = (0, $7MSYo.normalizeToOrgProfile)(customer);
        if (orgProfile) {
            const { id: id, displayName: displayName } = orgProfile;
            setToBeRemovedOrganizationInfo({
                id: id,
                displayName: displayName
            });
            toggleRemoveOrganizationDialog();
            return;
        }
        const userProfile = (0, $7MSYo.normalizeToUserProfile)(customer);
        if (userProfile) {
            const { identifier: identifier, displayName: displayName } = userProfile;
            setToBeRemovedUserInfo({
                displayName: displayName,
                identifier: identifier
            });
            removeCustomer(identifier);
        }
    }, [
        removeCustomer,
        toggleRemoveOrganizationDialog
    ]);
    const onRemoveOrganizationSuccess = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'orgName' implicitly has an 'any' type.
    ({ orgName: orgName })=>{
        showFlag({
            messageId: 'servicedesk-customers.ui.table.show-flag.success',
            messageType: 'transactional',
            type: 'success',
            title: [
                (0, $lAlfB.default).flagTitle,
                {
                    customerName: orgName,
                    projectName: projectName
                }
            ]
        });
        closeRemoveOrganizationDialog();
        setPageData();
    }, [
        closeRemoveOrganizationDialog,
        projectName,
        setPageData,
        showFlag
    ]);
    const onActionSuccess = (0, $5uXOq.useCallback)((email, successAction)=>{
        if (successAction === $76ee6be365905a17$var$resendVerificationEmail) showFlag({
            messageId: 'servicedesk-customers.ui.table.show-flag.success.resend-verification-email',
            messageType: 'transactional',
            type: 'success',
            title: (0, $lAlfB.default).resendVerificationEmailTitle,
            description: [
                (0, $lAlfB.default).resendVerificationEmailDescription,
                {
                    email: email
                }
            ]
        });
        else showFlag({
            messageId: 'servicedesk-customers.ui.table.show-flag.success.resent-invite-email-success',
            messageType: 'transactional',
            type: 'success',
            title: (0, $lAlfB.default).resendInviteSuccessFlagTitle,
            description: [
                (0, $lAlfB.default).resendInviteSuccessFlagDescription,
                {
                    email: email
                }
            ]
        });
    }, [
        showFlag
    ]);
    const onActionFailure = (0, $5uXOq.useCallback)((id, errorFlagComponent)=>{
        showFlag({
            messageId: 'servicedesk-customers.ui.table.show-flag.error',
            messageType: 'transactional',
            id: id,
            render: ()=>errorFlagComponent
        });
    }, [
        showFlag
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const { identifier: identifier, displayName: displayName } = toBeRemovedUserInfo;
        if (Boolean(removeCustomerData) && removeCustomerData === identifier) {
            showFlag({
                messageId: 'servicedesk-customers.ui.table.show-flag.success.1',
                messageType: 'transactional',
                type: 'success',
                title: [
                    (0, $lAlfB.default).flagTitle,
                    {
                        customerName: displayName,
                        projectName: projectName
                    }
                ]
            });
            setPageData();
        }
        if (removeCustomerError) showFlag({
            messageId: 'servicedesk-customers.ui.table.show-flag.error.remove-customer-error',
            messageType: 'transactional',
            type: 'error',
            title: (0, $lAlfB.default).removeCustomerError
        });
    }, [
        projectName,
        removeCustomerData,
        removeCustomerError,
        setPageData,
        showFlag,
        toBeRemovedUserInfo
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $Hxan5.customersSearchPageLoadExperience).success();
    }, [
        pageData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $NwEQm.RemoveOrganizationDialog), {
        isOpen: isRemoveOrganizationDialogOpen,
        onClose: closeRemoveOrganizationDialog,
        orgName: toBeRemovedOrganizationInfo.displayName,
        orgId: Number(toBeRemovedOrganizationInfo.id),
        onSuccess: onRemoveOrganizationSuccess
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8EAk1.Table), {
        loading: loading || removeCustomerLoading,
        // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        projectKey: projectKey,
        // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        projectName: projectName,
        pageData: pageData,
        onPageChange: onPageChange,
        isEditable: isEditable,
        onRemove: onRemoveClick,
        onActionSuccess: onActionSuccess,
        onActionFailure: onActionFailure,
        hasActions: hasActions
    }));
};
const $76ee6be365905a17$export$5ac09e049b32e384 = (0, $34Vv8.default)($76ee6be365905a17$var$TableWithActionsView);

});
parcelRegister("NwEQm", function(module, exports) {

$parcel$export(module.exports, "RemoveOrganizationDialog", () => $c23f44f3101a9bc1$export$4a49832503929763);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");
var $kW74I = parcelRequire("kW74I");

var $7NYq5 = parcelRequire("7NYq5");

var $9fuVs = parcelRequire("9fuVs");

var $8RXs9 = parcelRequire("8RXs9");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $3Ypxa = parcelRequire("3Ypxa");

var $5pxMj = parcelRequire("5pxMj");

var $Hxan5 = parcelRequire("Hxan5");

var $hhvGs = parcelRequire("hhvGs");

var $93ov7 = parcelRequire("93ov7");
const $c23f44f3101a9bc1$var$RemoveOrganizationConfirmation = ({ isOpen: isOpen = false, onClose: onClose, onSuccess: onSuccess, intl: { formatMessage: formatMessage }, orgName: orgName, orgId: orgId, confirmMessage: confirmMessage = '' })=>{
    const { baseUrl: baseUrl, projectId: projectId, projectName: projectName, projectKey: projectKey } = (0, $3Ypxa.useCommonPageContext)();
    const [isErrorSectionOpen, setIsErrorSectionOpen] = (0, $5uXOq.useState)(true);
    const { error: isError, data: data, fetch: removeOrganization, loading: loading } = (0, $hhvGs.useRemoveOrganizationService)(baseUrl, projectId);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleClick = (_, analyticsEvent)=>{
        (0, $Hxan5.organizationsRemoveFromProjectExperience).start();
        removeOrganization(orgId, analyticsEvent);
    };
    (0, $5uXOq.useEffect)(()=>{
        if (Boolean(data) && data === orgId) /* @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string' */ onSuccess({
            projectKey: projectKey,
            orgName: orgName
        });
        if (isError) {
            (0, $Hxan5.organizationsRemoveFromProjectExperience).failure();
            setIsErrorSectionOpen(true);
        }
    }, [
        isError,
        onSuccess,
        orgId,
        orgName,
        projectKey,
        projectName,
        data
    ]);
    const actions = [
        {
            text: confirmMessage || formatMessage((0, $93ov7.default).confirm),
            onClick: handleClick,
            'data-test-id': 'jsd.servicedesk.customers-organization-common.confirm-button',
            appearance: 'default',
            isLoading: loading
        },
        {
            text: formatMessage((0, $93ov7.default).cancel),
            onClick: onClose,
            'data-test-id': 'jsd.servicedesk.customers-organization-common.close-button',
            appearance: 'link'
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kW74I.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "servicedesk-customers-organization-common.ui.remove-organization-dialog.modal-dialog.modal",
        messageType: "transactional",
        autoFocus: true,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUaFh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Sb4G.default), null, formatMessage((0, $93ov7.default).header, {
        orgName: orgName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1QfP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "removeOrganization",
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
    }, isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5pxMj.CollapsibleSectionMessage), {
        appearance: "error",
        message: formatMessage((0, $93ov7.default).errorMessage),
        isOpen: isErrorSectionOpen,
        title: formatMessage((0, $93ov7.default).errorMessageTitle),
        onClose: setIsErrorSectionOpen
    }), formatMessage((0, $93ov7.default).information, {
        projectName: projectName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CjwE.default), null, actions.map((props, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
            key: index,
            ...props,
            appearance: index === 0 ? props.appearance || 'primary' : props.appearance || 'subtle'
        }, props.text))))));
};
const $c23f44f3101a9bc1$export$4a49832503929763 = (0, $8RXs9.default)($c23f44f3101a9bc1$var$RemoveOrganizationConfirmation);

});
parcelRegister("5pxMj", function(module, exports) {

$parcel$export(module.exports, "CollapsibleSectionMessage", () => $577d829cb584c954$export$763cd1d5b7849cf8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $kweMg = parcelRequire("kweMg");

var $9FSw2 = parcelRequire("9FSw2");

var $koVbs = parcelRequire("koVbs");

var $edzlU = parcelRequire("edzlU");
const $577d829cb584c954$export$763cd1d5b7849cf8 = ({ message: message, appearance: appearance, isOpen: isOpen, title: title, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($577d829cb584c954$var$SectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($577d829cb584c954$var$CloseButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        onClick: ()=>onClose(false),
        appearance: "subtle",
        spacing: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kweMg))), {
        LEGACY_size: "small",
        label: formatMessage((0, $edzlU.default).closeModal)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FSw2.default), {
        appearance: appearance,
        title: title
    }, message)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $577d829cb584c954$var$SectionMessageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _otyrpxbi",
            __cmplp.className
        ])
    });
});
const $577d829cb584c954$var$CloseButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1xi2u2gc _154iu2gc _80omtlke",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9FSw2", function(module, exports) {

$parcel$export(module.exports, "default", () => $992999896a95fc30$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bWfiu = parcelRequire("bWfiu");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $gOkqF = parcelRequire("gOkqF");

var $fPYPu = parcelRequire("fPYPu");
const $992999896a95fc30$var$sectionMessageStyles = {
    container: "_2rkoglpi _1nmz1hna",
    bleed: "_1mou1i6y _1e0c1txw",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $992999896a95fc30$var$SectionMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $fPYPu.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        as: "section",
        backgroundColor: $992999896a95fc30$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $992999896a95fc30$var$sectionMessageStyles.container,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    xcss: $992999896a95fc30$var$sectionMessageStyles.bleed,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    children: [
                        !!title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                            xcss: $992999896a95fc30$var$sectionMessageStyles.content,
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            role: "list",
                            xcss: (0, $fHpHg.fg)('platform_ads_explicit_font_styles') && $992999896a95fc30$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                                    role: "listitem",
                                    children: action
                                }, id))
                        })
                    ]
                })
            ]
        })
    });
});
const $992999896a95fc30$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$992999896a95fc30$var$SectionMessage.displayName = 'SectionMessage';
var $992999896a95fc30$export$2e2bcd8739ae039 = $992999896a95fc30$var$SectionMessage;

});
parcelRegister("fPYPu", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $c121b5ea31b69b1c$export$e9b82d2e21ac0c1f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5E93O = parcelRequire("5E93O");

var $k01Ou = parcelRequire("k01Ou");

var $3vNgn = parcelRequire("3vNgn");

var $bMdrA = parcelRequire("bMdrA");

var $85eFT = parcelRequire("85eFT");

const $c121b5ea31b69b1c$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $a7f8c6b391092279$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($k01Ou))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $a7f8c6b391092279$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $a7f8c6b391092279$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($85eFT))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $a7f8c6b391092279$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $a7f8c6b391092279$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5E93O))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $a7f8c6b391092279$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $a7f8c6b391092279$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $a7f8c6b391092279$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3vNgn))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $a7f8c6b391092279$export$147899de772240ec)})`
    }
};
function $c121b5ea31b69b1c$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $c121b5ea31b69b1c$var$appearanceIconSchema[appearance] || $c121b5ea31b69b1c$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});


parcelRegister("edzlU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6504e403ed002f4a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6504e403ed002f4a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    closeModal: {
        "id": "servicedesk-customers-organization-common.common.collapsible-section-message.close-modal",
        "defaultMessage": "Close"
    }
});

});


parcelRegister("hhvGs", function(module, exports) {

$parcel$export(module.exports, "useRemoveOrganizationService", () => $1fc062b46fa99f5b$export$693e5ab5cf9df2e2);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $a7EYT = parcelRequire("a7EYT");

var $Hxan5 = parcelRequire("Hxan5");

var $gDWLV = parcelRequire("gDWLV");
const $1fc062b46fa99f5b$export$693e5ab5cf9df2e2 = (baseUrl, projectId)=>{
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [data, setData] = (0, $5uXOq.useState)(null);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const fetch = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
    async (organizationId, analyticsEvent)=>{
        setLoading(true);
        setError(null);
        (0, $Hxan5.removeOrganizationExperience).start();
        try {
            await (0, $a7EYT.performPostRequest)((0, $gDWLV.getUrl)(baseUrl, projectId, organizationId));
            setData(organizationId);
            setLoading(false);
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'organization removed', `${organizationId}`);
            (0, $Hxan5.removeOrganizationExperience).success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setLoading(false);
            setError(err);
            // Only fire analytics for unexpected errors. In this case the backend really
            // only returns a 403 if the current user doesn't have permission to manage
            // organizations. I'm not sure how to replicate that situation so I'll leave it as
            // unexpected, based on an assumption that such users wouldn't see the delete button
            (0, $jcw0u.default)({
                error: err,
                meta: {
                    id: 'useRemoveOrganizationService',
                    packageName: 'jiraServicedeskCustomersOrganizationCommon',
                    teamName: 'boysenberry'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            (0, $Hxan5.removeOrganizationExperience).failure();
        }
    }, [
        baseUrl,
        projectId
    ]);
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type '((Error | ValidationErrors | { statusCode: number; message?: string | undefined; }) & ValidationErrors) | null'.
        error,
        data: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceData<Data>'.
        data,
        fetch: // @ts-expect-error - TS2322 - Type '(organizationId: number, analyticsEvent: any) => Promise<void>' is not assignable to type '(() => Promise<void>) & ((organizationId: number, analyticsEvent: UIAnalyticsEventInterface) => Promise<void>)'.
        fetch
    };
};

});
parcelRegister("gDWLV", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $44913af568c05191$export$94df0e59ebebf4a7);
const $44913af568c05191$export$94df0e59ebebf4a7 = (baseUrl, projectId, organizationId)=>`${baseUrl}/rest/servicedesk/1/servicedesk/${projectId}/organisation/${organizationId}/dissasociate`;

});


parcelRegister("93ov7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eb977d94523d684$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0eb977d94523d684$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    information: {
        "id": "servicedesk-customers-organization-common.remove-organization-dialog.information",
        "defaultMessage": "Organization members will lose access to {projectName} unless they have the Customers role for the project."
    },
    confirm: {
        "id": "servicedesk-customers-organization-common.remove-organization-dialog.confirm",
        "defaultMessage": "Confirm"
    },
    header: {
        "id": "servicedesk-customers-organization-common.remove-organization-dialog.header",
        "defaultMessage": "Remove {orgName} from project"
    },
    cancel: {
        "id": "servicedesk-customers-organization-common.remove-organization-dialog.cancel",
        "defaultMessage": "Cancel"
    },
    errorMessage: {
        "id": "servicedesk-customers-organization-common.remove-organization-dialog.error-message",
        "defaultMessage": "Something has gone wrong with your request. If symptoms persist contact your System Administrator."
    },
    errorMessageTitle: {
        "id": "servicedesk-customers-organization-common.remove-organization-dialog.error-message-title",
        "defaultMessage": "Error"
    }
});

});


parcelRegister("8EAk1", function(module, exports) {

$parcel$export(module.exports, "Table", () => $ccfdf04f09ee7426$export$54ec01a60f47d33d);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $cTmPi = parcelRequire("cTmPi");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");

var $7MSYo = parcelRequire("7MSYo");

var $kSXw6 = parcelRequire("kSXw6");

var $dvemE = parcelRequire("dvemE");

var $h95b0 = parcelRequire("h95b0");

var $bQCSU = parcelRequire("bQCSU");

var $iYENh = parcelRequire("iYENh");

var $2XO17 = parcelRequire("2XO17");

var $cpkrl = parcelRequire("cpkrl");

var $g3UsO = parcelRequire("g3UsO");
const $ccfdf04f09ee7426$export$54ec01a60f47d33d = (props)=>{
    const { loading: loading, pageData: pageData, onPageChange: onPageChange, hasActions: hasActions = true, scimManaged: scimManaged = false } = props;
    const intl = (0, $koVbs.default)();
    const { page: page, total: total, customers: customers, totalHasBeenDetermined: totalHasBeenDetermined, lastDeterminedPaged: lastDeterminedPaged } = pageData || (0, $dvemE.DEFAULT_PAGE_DATA);
    const hasOrganisationRow = customers?.some((0, $7MSYo.isOrganization));
    const head = props.head ? props.head : (0, $h95b0.getHeader)(intl, props.isEditable || hasOrganisationRow, hasActions, scimManaged);
    const { rows: rows, tablePage: tablePage, setTablePage: setTablePage } = (0, $iYENh.useTableRows)(props);
    const { query: query } = pageData || {
        query: ''
    };
    const paginationProps = {
        query: query,
        totalHasBeenDetermined: totalHasBeenDetermined,
        total: total,
        pageNumber: page,
        lastDeterminedPaged: lastDeterminedPaged
    };
    const { isMaxLimitReached: isMaxLimitReached, paginationLabel: paginationLabel, showPagination: showPagination, totalPages: totalPages, bracketSize: bracketSize, hideRightEllipsis: hideRightEllipsis } = (0, $g3UsO.usePaginationHook)(paginationProps);
    (0, $5uXOq.useEffect)(()=>{
        if (query !== '') setTablePage(1);
    }, [
        query,
        setTablePage
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const checkIfNeedsQuery = (pageNum)=>{
        const next = pageNum + 1;
        onPageChange(next);
        setTablePage(next);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $ccfdf04f09ee7426$var$overflowWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $ccfdf04f09ee7426$var$tableContainerStyles,
        "data-testId": "servicedesk-customers-organization-common.ui.dynamic-table.table-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cTmPi.default), {
        head: head,
        rows: rows,
        isLoading: loading,
        isFixedSize: true,
        emptyView: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cpkrl.EmptyState), null)
    }), rows.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !loading && isMaxLimitReached && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bQCSU.LimitReached), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $ccfdf04f09ee7426$var$paginationContainerStyles,
        "aria-disabled": "true"
    }, !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2XO17.PaginationLabel), {
        label: paginationLabel,
        justifyCenter: showPagination
    }), showPagination && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kSXw6.default), {
        isDisabled: loading,
        pages: totalPages,
        selectedIndex: tablePage - 1,
        onChange: (newIndex)=>checkIfNeedsQuery(newIndex),
        bracketSize: bracketSize,
        hideRightEllipsis: hideRightEllipsis
    }))), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        eventName: "customersOrgsTable loaded"
    })));
};
$ccfdf04f09ee7426$export$54ec01a60f47d33d.defaultProps = {
    loading: false,
    onPageChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    isEditable: false,
    onRemove: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $ccfdf04f09ee7426$var$tableContainerStyles = (0, $2s57o.xcss)({
    cursor: 'pointer',
    marginTop: 'space.0',
    // @ts-expect-error - TS2322 - Object literal may only specify known properties
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    thead: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderBottom: `2px solid ${"var(--ds-border, #091E4224)"}`,
        position: 'sticky',
        top: 0,
        zIndex: 1,
        background: `${"var(--ds-surface, #FFFFFF)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    tbody: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderBottom: `2px solid ${"var(--ds-border, #091E4224)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    tfoot: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderBottom: `2px solid ${"var(--ds-border, #091E4224)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    table: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        borderBottom: 'none !important'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    div: {
        marginBottom: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    td: {
        wordBreak: 'break-word',
        padding: `0 ${"var(--ds-space-025, 2px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    th: {
        wordBreak: 'break-word',
        padding: `${"var(--ds-space-100, 8px)"} 0`
    }
});
const $ccfdf04f09ee7426$var$overflowWrapperStyles = (0, $2s57o.xcss)({
    overflow: 'auto',
    maxHeight: '100%',
    marginTop: 'space.250'
});
const $ccfdf04f09ee7426$var$paginationContainerStyles = (0, $2s57o.xcss)({
    transition: `
        left 300ms cubic-bezier(0.2, 0, 0, 1) 0s,
        right 300ms cubic-bezier(0.2, 0, 0, 1) 0s,
        width 300ms cubic-bezier(0.2, 0, 0, 1) 0s;
    `,
    borderTop: '2px solid',
    zIndex: 'navigation',
    overflow: 'visible',
    borderTopColor: 'color.border',
    padding: 'space.200',
    boxSizing: 'border-box',
    background: 'color.elevation.surface',
    display: 'grid'
});

});
parcelRegister("kSXw6", function(module, exports) {

$parcel$export(module.exports, "default", () => $15f384fd89feeecb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7Jxgt = parcelRequire("7Jxgt");

var $bngFq = parcelRequire("bngFq");

var $cNW3X = parcelRequire("cNW3X");

var $kXQqt = parcelRequire("kXQqt");

var $aCQsl = parcelRequire("aCQsl");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");


var $g4p17 = parcelRequire("g4p17");
const $15f384fd89feeecb$var$renderLeftEllipsis = (currentBatch)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15f384fd89feeecb$var$BackupWrapper, {
        hide: currentBatch === 1,
        direction: "left"
    }, "...");
const $15f384fd89feeecb$var$renderRightEllipsis = (hideEllipsis)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15f384fd89feeecb$var$BackupWrapper, {
        hide: hideEllipsis,
        direction: "right"
    }, "...");
const $15f384fd89feeecb$var$renderChevron = (selectedIndex, pages, onClick, direction)=>{
    const onChevronClick = (event, analyticsEvent)=>{
        const pageNumber = direction === 'LEFT' ? selectedIndex - 1 : selectedIndex + 1;
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $6572960f51edb891$export$728b190245c34e32), {
            pageNumber: pageNumber
        });
        onClick(pageNumber, analyticsEvent);
    };
    const isDisabled = ()=>{
        if (direction === 'LEFT') return selectedIndex <= 0;
        if (direction === 'RIGHT') return selectedIndex >= (pages ? pages - 1 : 0);
        return true;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        onClick: (event, analyticsEvent)=>onChevronClick(event, analyticsEvent),
        appearance: "subtle",
        spacing: "compact",
        isDisabled: isDisabled(),
        testId: `servicedesk-customers-organization-common.ui.table.bracket-pagination.${direction.toLowerCase()}-button`
    }, direction === 'LEFT' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kXQqt))), {
        spacing: "spacious",
        label: "previous"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aCQsl))), {
        spacing: "spacious",
        label: "next"
    }));
};
const $15f384fd89feeecb$var$renderMarkup = (selectedIndex, pages, currentBatch, onPaginationChange, bracketSize, formatMessage)=>{
    const onClick = (_, analyticsEvent, index)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $6572960f51edb891$export$728b190245c34e32), {
            pageNumber: index
        });
        onPaginationChange(index, analyticsEvent);
    };
    const markupBatch = [];
    let batches = [];
    Array.from({
        length: pages
    }, (_, index)=>index).forEach((value)=>{
        const isSelected = value === selectedIndex;
        const pageNumber = value + 1;
        batches.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15f384fd89feeecb$var$NumberWrapper, {
            key: `pagination-${value}`,
            "data-testId": "servicedesk-customers-organization-common.ui.table.bracket-pagination.page-number"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
            onClick: (event, analyticsEvent)=>onClick(event, analyticsEvent, value),
            appearance: "subtle",
            spacing: "compact",
            isSelected: isSelected,
            "aria-label": formatMessage(isSelected ? (0, $g4p17.default).pageLabelSelected : (0, $g4p17.default).pageLabel, {
                pageNumber: pageNumber
            })
        }, pageNumber)));
        if (pageNumber % bracketSize === 0) {
            markupBatch.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15f384fd89feeecb$var$MarkupWrapper, null, batches));
            batches = [];
        }
    });
    if (batches.length > 0) {
        // add remaining item in the batch
        markupBatch.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15f384fd89feeecb$var$MarkupWrapper, null, batches));
        batches = [];
    }
    return markupBatch;
};
const $15f384fd89feeecb$var$renderFirstPageLink = (selectedIndex, onPaginationChange)=>{
    const onClick = (event, analyticsEvent, index)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $6572960f51edb891$export$728b190245c34e32), {
            pageNumber: index
        });
        onPaginationChange(index, analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15f384fd89feeecb$var$NumberWrapper, {
        key: `pagination-first-${1}`,
        "data-testId": "servicedesk-customers-organization-common.ui.table.bracket-pagination.page-number"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        onClick: (event, analyticsEvent)=>onClick(event, analyticsEvent, 0),
        appearance: "subtle",
        spacing: "compact",
        isSelected: selectedIndex === 0
    }, 1));
};
const $15f384fd89feeecb$export$6a496545c3e44b7e = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const descriptionId = (0, $5uXOq.useMemo)(()=>(0, $7Jxgt.v4)(), []);
    const { currentBatch: currentBatch, selectedIndex: selectedIndex, pages: pages, onChange: onChange, bracketSize: bracketSize, hideRightEllipsis: hideRightEllipsis } = props;
    const hideEllipsis = undefined === hideRightEllipsis ? selectedIndex >= (pages ? pages - 1 : 0) : hideRightEllipsis;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15f384fd89feeecb$export$60cc8ca389d37b4f, {
        as: "nav",
        "aria-label": formatMessage((0, $g4p17.default).navigationLabel),
        "aria-describedby": descriptionId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        id: descriptionId,
        hidden: true
    }, formatMessage((0, $g4p17.default).navigationDescription)), $15f384fd89feeecb$var$renderChevron(selectedIndex, pages, onChange, 'LEFT'), selectedIndex + 1 > bracketSize ? $15f384fd89feeecb$var$renderFirstPageLink(selectedIndex, onChange) : '', $15f384fd89feeecb$var$renderLeftEllipsis(currentBatch), $15f384fd89feeecb$var$renderMarkup(selectedIndex, pages ?? 0, currentBatch, onChange, bracketSize, formatMessage)[currentBatch - 1], $15f384fd89feeecb$var$renderRightEllipsis(hideEllipsis), $15f384fd89feeecb$var$renderChevron(selectedIndex, pages, onChange, 'RIGHT'));
};
$15f384fd89feeecb$export$6a496545c3e44b7e.defaultProps = {
    currentBatch: 1
};
const $15f384fd89feeecb$var$BracketPagination = (props)=>{
    // isPaginationDisabled is passed because for any click bucket change happens,
    // and in case of fast click where things are still loading we don't want any action to happen
    // This cant be controlled at table layer because bucket logic exists in pagination
    // https://jdog.jira-dev.com/browse/DWP-297
    const { pages: pages, selectedIndex: selectedIndex, bracketSize: bracketSize, onChange: onChange, isDisabled: isDisabled, hideRightEllipsis: hideRightEllipsis } = props; // Batch is 1 based index
    const [currentBatch, updateBatch] = (0, $5uXOq.useState)(Math.ceil((selectedIndex + 1) / bracketSize));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: (0, $6572960f51edb891$export$d6a1e2db2153a1c3),
        actionSubject: (0, $6572960f51edb891$export$d3fecc7a37c6d2a2)
    });
    (0, $5uXOq.useEffect)(()=>{
        if (!isDisabled) updateBatch(Math.ceil((selectedIndex + 1) / bracketSize));
    }, [
        selectedIndex,
        bracketSize,
        isDisabled
    ]);
    const onPaginationChange = (newIndex)=>{
        if (!isDisabled) {
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $6572960f51edb891$export$728b190245c34e32), {
                pageNumberRequested: newIndex + 1
            });
            onChange(newIndex);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15f384fd89feeecb$export$6a496545c3e44b7e, {
        selectedIndex: selectedIndex,
        currentBatch: currentBatch,
        pages: pages,
        bracketSize: bracketSize,
        onChange: onPaginationChange,
        hideRightEllipsis: hideRightEllipsis
    });
};
$15f384fd89feeecb$var$BracketPagination.defaultProps = {
    bracketSize: 5
};
var $15f384fd89feeecb$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $15f384fd89feeecb$var$BracketPagination;
const $15f384fd89feeecb$var$MarkupWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _y3gn1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $15f384fd89feeecb$var$BackupWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hide: hide, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1wpz1h6o _ca0qidpf _u5f3u2gc _n3tdidpf _19bvu2gc",
            __cmplp.hide ? "_1e0cglyw" : "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $15f384fd89feeecb$var$NumberWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hide: hide, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.hide ? "_3um015vq" : "_3um0ewfl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $15f384fd89feeecb$export$60cc8ca389d37b4f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _1bsb1wug _1bah1h6o _ae4v1h6o _1461kb7n _p3z3kb7n _10fpusic _94n5ze3t",
            __cmplp.className
        ])
    });
});

});
const $6572960f51edb891$export$728b190245c34e32 = 'customersTable';
const $6572960f51edb891$export$d6a1e2db2153a1c3 = 'changed';
const $6572960f51edb891$export$d3fecc7a37c6d2a2 = 'pageNumber';

parcelRegister("g4p17", function(module, exports) {

$parcel$export(module.exports, "default", () => $69060ba6a3bb3d13$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $69060ba6a3bb3d13$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    navigationLabel: {
        "id": "servicedesk-customers-organization-common.table.bracket-pagination.navigation-label",
        "defaultMessage": "Customers pagination"
    },
    navigationDescription: {
        "id": "servicedesk-customers-organization-common.table.bracket-pagination.navigation-description",
        "defaultMessage": "Activating a pagination button will update the results above."
    },
    pageLabel: {
        "id": "servicedesk-customers-organization-common.table.bracket-pagination.page-label",
        "defaultMessage": "Page {pageNumber}"
    },
    pageLabelSelected: {
        "id": "servicedesk-customers-organization-common.table.bracket-pagination.page-label-selected",
        "defaultMessage": "Page {pageNumber}, current page"
    }
});

});


parcelRegister("dvemE", function(module, exports) {

$parcel$export(module.exports, "SEARCH_PER_PAGE", () => $6023f98d6d1537d0$export$74fcd9f6dcadebd3);
$parcel$export(module.exports, "LIST_PER_PAGE", () => $6023f98d6d1537d0$export$2f9c012b71c09d3b);
$parcel$export(module.exports, "DEFAULT_PAGE_DATA", () => $6023f98d6d1537d0$export$4271758629eddc5);
const $6023f98d6d1537d0$export$74fcd9f6dcadebd3 = 20;
const $6023f98d6d1537d0$export$2f9c012b71c09d3b = 50;
const $6023f98d6d1537d0$export$4271758629eddc5 = {
    total: 0,
    customers: [],
    rowsPerPage: $6023f98d6d1537d0$export$2f9c012b71c09d3b,
    page: 1,
    totalHasBeenDetermined: true,
    lastDeterminedPaged: 1,
    query: ''
};

});

parcelRegister("h95b0", function(module, exports) {

$parcel$export(module.exports, "getHeader", () => $c50d27393281ff83$export$47ed31abc613cf55);
$parcel$export(module.exports, "InlineMessageWrapper", () => $c50d27393281ff83$export$6ced824235fb25b2);
$parcel$export(module.exports, "InlineMessageContent", () => $c50d27393281ff83$export$cf18a118761851fd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aUcIH = parcelRequire("aUcIH");

var $4R6GH = parcelRequire("4R6GH");

var $d2fzL = parcelRequire("d2fzL");
const $c50d27393281ff83$export$47ed31abc613cf55 = ({ formatMessage: formatMessage }, isEditable, hasActions, scimManaged)=>{
    const cells = (0, $4R6GH.fg)('jsm_lock_scim_managed_customer_and_org') ? [
        {
            key: 'displayName',
            content: formatMessage((0, $d2fzL.default).nameColumn),
            width: 58
        },
        {
            key: 'openRequests',
            content: formatMessage((0, $d2fzL.default).openRequestsColumn),
            width: 20
        },
        {
            key: 'closedRequests',
            content: formatMessage((0, $d2fzL.default).closedRequestsColumn),
            width: 20
        },
        {
            key: 'status',
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c50d27393281ff83$export$6ced824235fb25b2, null, formatMessage((0, $d2fzL.default).statusColumn), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aUcIH.default), {
                appearance: "info",
                placement: "bottom-end"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c50d27393281ff83$export$cf18a118761851fd, null, formatMessage((0, $d2fzL.default).statusAbsentAaDescription)))),
            width: 15
        },
        ...!scimManaged && (hasActions || hasActions === undefined) ? [
            {
                key: 'actions',
                content: formatMessage((0, $d2fzL.default).actionsColumn),
                width: 17
            }
        ] : [],
        ...!scimManaged && isEditable ? [
            {
                key: 'editableColumn',
                content: '',
                width: 5
            }
        ] : []
    ] : [
        {
            key: 'displayName',
            content: formatMessage((0, $d2fzL.default).nameColumn),
            width: 58
        },
        {
            key: 'openRequests',
            content: formatMessage((0, $d2fzL.default).openRequestsColumn),
            width: 20
        },
        {
            key: 'closedRequests',
            content: formatMessage((0, $d2fzL.default).closedRequestsColumn),
            width: 20
        },
        {
            key: 'status',
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c50d27393281ff83$export$6ced824235fb25b2, null, formatMessage((0, $d2fzL.default).statusColumn), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aUcIH.default), {
                appearance: "info",
                placement: "bottom-end"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c50d27393281ff83$export$cf18a118761851fd, null, formatMessage((0, $d2fzL.default).statusAbsentAaDescription)))),
            width: 15
        },
        ...hasActions || hasActions === undefined ? [
            {
                key: 'actions',
                content: formatMessage((0, $d2fzL.default).actionsColumn),
                width: 17
            }
        ] : [],
        ...isEditable ? [
            {
                key: 'editableColumn',
                content: '',
                width: 5
            }
        ] : []
    ];
    return {
        cells: cells
    };
};
const $c50d27393281ff83$export$6ced824235fb25b2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _jq8gpxbi _igocpxbi _k6cgpxbi _1d42pxbi _1sla131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c50d27393281ff83$export$cf18a118761851fd = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _k48pi7a9 _p12fs1ma",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aUcIH", function(module, exports) {

$parcel$export(module.exports, "default", () => $11d1058d97996ffb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $55tuP = parcelRequire("55tuP");

var $5sLH0 = parcelRequire("5sLH0");
var $k9nuy = parcelRequire("k9nuy");

var $4QxdL = parcelRequire("4QxdL");
const $11d1058d97996ffb$var$rootStyles = null;
const $11d1058d97996ffb$var$iconColor = {
    connectivity: "_x5v91r2e",
    confirmation: "_x5v91fgg",
    info: "_x5v913wx",
    warning: "_x5v9f6ss",
    error: "_x5v9k8x7"
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ const $11d1058d97996ffb$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', type: type = 'connectivity', appearance: appearance, children: children, testId: testId, iconLabel: iconLabel })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const toggleDialog = (0, $5uXOq.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    if (!appearance) appearance = type;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _p12f1osq _nt751r31 _49pcnqa1 _1hvwt94y _kvh018uv _38q98stv _1o0knqa1 _1yyu1kum",
            $11d1058d97996ffb$var$iconColor[appearance]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $55tuP.default), {
            onClose: onCloseDialog,
            content: children,
            isOpen: isOpen,
            placement: placement,
            testId: testId && `${testId}--inline-dialog`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                "data-ds--inline-message--button": true,
                appearance: "subtle-link",
                onClick: toggleDialog,
                spacing: "none",
                testId: testId && `${testId}--button`,
                "aria-expanded": isOpen,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                    space: "space.050",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4QxdL.default), {
                            isOpen: isOpen,
                            appearance: appearance,
                            label: iconLabel
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                            space: "space.100",
                            children: [
                                title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                                    weight: "medium",
                                    testId: testId && `${testId}--title`,
                                    children: title
                                }),
                                secondaryText && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                                    weight: "medium",
                                    color: "color.text.subtlest",
                                    maxLines: 1,
                                    testId: testId && `${testId}--text`,
                                    children: secondaryText
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $11d1058d97996ffb$export$2e2bcd8739ae039 = $11d1058d97996ffb$var$InlineMessage;

});
parcelRegister("4QxdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $12eee54571ecf193$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3nZ0X = parcelRequire("3nZ0X");
const $12eee54571ecf193$var$iconColor = {
    connectivity: "_1b3i1c86",
    confirmation: "_1b3icdx1",
    info: "_1b3ige5s",
    warning: "_1b3i1n6p",
    error: "_1b3i1378"
};
const $12eee54571ecf193$var$iconWrapperStyles = null;
const $12eee54571ecf193$var$iconColorStyles = null;
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ const $12eee54571ecf193$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $3nZ0X.typesMapping);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _syazkr0v",
            isOpen && "_syaz1kum",
            $12eee54571ecf193$var$iconColor[appearance]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
            testId: "inline-message-icon",
            label: label || defaultLabel,
            color: "currentColor",
            LEGACY_size: "medium",
            spacing: "spacious"
        })
    });
};
var $12eee54571ecf193$export$2e2bcd8739ae039 = $12eee54571ecf193$var$SelectedIcon;

});
parcelRegister("3nZ0X", function(module, exports) {

$parcel$export(module.exports, "typesMapping", () => $f033e99722d4c1b8$export$4d111645c0b39d5d);

var $5E93O = parcelRequire("5E93O");

var $k01Ou = parcelRequire("k01Ou");

var $bMdrA = parcelRequire("bMdrA");

var $85eFT = parcelRequire("85eFT");
const $f033e99722d4c1b8$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($85eFT))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($k01Ou))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($85eFT))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5E93O))),
        defaultLabel: 'error inline message'
    }
};

});



parcelRegister("d2fzL", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ad1463871141ff8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9ad1463871141ff8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    nameColumn: {
        "id": "servicedesk-customers-organization-common.table.header.name-column",
        "defaultMessage": "Name"
    },
    orgColumn: {
        "id": "servicedesk-customers-organization-common.table.header.org-column",
        "defaultMessage": "Organizations"
    },
    openRequestsColumn: {
        "id": "servicedesk-customers-organization-common.table.header.open-requests-column",
        "defaultMessage": "Open requests"
    },
    closedRequestsColumn: {
        "id": "servicedesk-customers-organization-common.table.header.closed-requests-column",
        "defaultMessage": "Closed requests"
    },
    statusColumn: {
        "id": "servicedesk-customers-organization-common.table.header.status-column",
        "defaultMessage": "Status"
    },
    statusAbsentAaDescription: {
        "id": "servicedesk-customers-organization-common.table.header.status-absent-aa-description",
        "defaultMessage": "Customers without status are Atlassian account users managed by your organization admins"
    },
    actionsColumn: {
        "id": "servicedesk-customers-organization-common.table.header.actions-column",
        "defaultMessage": "Actions"
    }
});

});


parcelRegister("bQCSU", function(module, exports) {

$parcel$export(module.exports, "LimitReached", () => $fa63f8cf628cfafb$export$8ff9a255f76a015d);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l5jpf = parcelRequire("l5jpf");

var $koVbs = parcelRequire("koVbs");

var $eBXWR = parcelRequire("eBXWR");
const $fa63f8cf628cfafb$export$8ff9a255f76a015d = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa63f8cf628cfafb$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l5jpf.JiraBanner), {
        messageId: "servicedesk-customers-organization-common.ui.table.limit-reached.banner",
        messageType: "transactional",
        appearance: "announcement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa63f8cf628cfafb$var$Header, null, formatMessage((0, $eBXWR.default).header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa63f8cf628cfafb$var$Description, null, formatMessage((0, $eBXWR.default).description))));
};
const $fa63f8cf628cfafb$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qpxbi _u5f3idpf _n3tdpxbi _19bvidpf _88dh16xe _1grgyw7e _1g6a1h6o _65g01fxt _18fj1ule _1nz71osq",
            __cmplp.className
        ])
    });
});
const $fa63f8cf628cfafb$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h5", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1nu9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fa63f8cf628cfafb$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1nu9 _18u01b66 _syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eBXWR", function(module, exports) {

$parcel$export(module.exports, "default", () => $308dd77b95ca492e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $308dd77b95ca492e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "servicedesk-customers-organization-common.table.limit-reached.header",
        "defaultMessage": "We can't load any more results."
    },
    description: {
        "id": "servicedesk-customers-organization-common.table.limit-reached.description",
        "defaultMessage": "Use the search bar to find the customers or organizations you're looking for."
    }
});

});


parcelRegister("iYENh", function(module, exports) {

$parcel$export(module.exports, "useTableRows", () => $1195ed53908d9e7e$export$a190e1af00082b41);

var $5uXOq = parcelRequire("5uXOq");

var $ij7C8 = parcelRequire("ij7C8");

var $4R6GH = parcelRequire("4R6GH");

var $7MSYo = parcelRequire("7MSYo");

var $li0Zv = parcelRequire("li0Zv");

var $dvemE = parcelRequire("dvemE");

var $ieb8i = parcelRequire("ieb8i");

var $kLSnD = parcelRequire("kLSnD");

var $am28C = parcelRequire("am28C");

var $2C5Rr = parcelRequire("2C5Rr");
const $1195ed53908d9e7e$export$a190e1af00082b41 = ({ pageData: pageData, isEditable: isEditable, projectKey: projectKey, projectName: projectName, onRemove: onRemove, onActionSuccess: onActionSuccess, onActionFailure: onActionFailure, showRemoveCustomerTooltip: showRemoveCustomerTooltip, rows: customRows, hasActions: hasActions = true, scimManaged: scimManaged = false })=>{
    const { total: total, page: page, rowsPerPage: rowsPerPage, customers: customers } = pageData || (0, $dvemE.DEFAULT_PAGE_DATA);
    const [tablePage, setTablePage] = (0, $5uXOq.useState)(1);
    const rows = (0, $5uXOq.useMemo)(()=>{
        let totalRows = [];
        if (!customers) return totalRows;
        const emptyRow = {
            cells: []
        };
        const numberOfPreviousRows = (page - 1) * rowsPerPage;
        const numberOfNextRows = Math.max(0, total - rowsPerPage - numberOfPreviousRows);
        const previousRows = (0, (/*@__PURE__*/$parcel$interopDefault($ij7C8)))(Array(numberOfPreviousRows), emptyRow);
        const nextRows = (0, (/*@__PURE__*/$parcel$interopDefault($ij7C8)))(Array(numberOfNextRows), emptyRow);
        if (customRows) return [
            ...previousRows,
            ...customRows,
            ...nextRows
        ];
        const hasOrganisationRow = customers.some((0, $7MSYo.isOrganization));
        const visibleRows = customers.map((customer)=>{
            const cells = [];
            cells.push({
                key: `name-${customer.identifier}`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ieb8i.CustomerCell), {
                    profile: customer,
                    projectKey: projectKey
                })
            });
            cells.push({
                key: `open-requests-${customer.identifier}`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2C5Rr.OpenRequestsCell), {
                    profile: customer
                })
            });
            cells.push({
                key: `closed-requests-${customer.identifier}`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2C5Rr.ClosedRequestsCell), {
                    profile: customer
                })
            });
            cells.push({
                key: `customer-logged-in-status-${customer.identifier}`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $am28C.LoggedInStatusCellView), {
                    profile: customer
                })
            });
            if ((0, $4R6GH.fg)('jsm_lock_scim_managed_customer_and_org')) {
                if (hasActions && !scimManaged) cells.push({
                    key: `resend-invite-${customer.identifier}`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $li0Zv.ActionsCellView), {
                        profile: customer,
                        onActionSuccess: onActionSuccess,
                        onActionFailure: onActionFailure
                    })
                });
            } else if (hasActions) cells.push({
                key: `resend-invite-${customer.identifier}`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $li0Zv.ActionsCellView), {
                    profile: customer,
                    onActionSuccess: onActionSuccess,
                    onActionFailure: onActionFailure
                })
            });
            const isOrganizationRow = (0, $7MSYo.isOrganization)(customer);
            if ((0, $4R6GH.fg)('jsm_lock_scim_managed_customer_and_org')) {
                if (!scimManaged && (isEditable || isOrganizationRow)) cells.push({
                    key: `modify-${customer.identifier}`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kLSnD.EditorCell), {
                        profile: customer,
                        projectName: projectName,
                        onRemove: onRemove,
                        showRemoveCustomerTooltip: showRemoveCustomerTooltip
                    })
                });
                else if (hasOrganisationRow) cells.push({
                    key: `modify-${customer.identifier}`,
                    content: null
                });
            } else if (isEditable || isOrganizationRow) cells.push({
                key: `modify-${customer.identifier}`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kLSnD.EditorCell), {
                    profile: customer,
                    projectName: projectName,
                    onRemove: onRemove,
                    showRemoveCustomerTooltip: showRemoveCustomerTooltip
                })
            });
            else if (hasOrganisationRow) cells.push({
                key: `modify-${customer.identifier}`,
                content: null
            });
            return {
                key: `customer-${customer.identifier}`,
                cells: cells
            };
        });
        totalRows = [
            ...previousRows,
            ...visibleRows,
            ...nextRows
        ];
        return totalRows;
    }, [
        customers,
        page,
        rowsPerPage,
        total,
        customRows,
        projectKey,
        hasActions,
        isEditable,
        onActionSuccess,
        onActionFailure,
        projectName,
        onRemove,
        showRemoveCustomerTooltip,
        scimManaged
    ]);
    return {
        rows: rows,
        tablePage: tablePage,
        setTablePage: setTablePage
    };
};

});
parcelRegister("ij7C8", function(module, exports) {

var $bTFL0 = parcelRequire("bTFL0");

var $4rDUz = parcelRequire("4rDUz");
/**
 * Fills elements of `array` with `value` from `start` up to, but not
 * including, `end`.
 *
 * **Note:** This method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Array
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _.fill(array, 'a');
 * console.log(array);
 * // => ['a', 'a', 'a']
 *
 * _.fill(Array(3), 2);
 * // => [2, 2, 2]
 *
 * _.fill([4, 6, 8, 10], '*', 1, 3);
 * // => [4, '*', '*', 10]
 */ function $d53fe857806ab26c$var$fill(array, value, start, end) {
    var length = array == null ? 0 : array.length;
    if (!length) return [];
    if (start && typeof start != 'number' && $4rDUz(array, value, start)) {
        start = 0;
        end = length;
    }
    return $bTFL0(array, value, start, end);
}
module.exports = $d53fe857806ab26c$var$fill;

});
parcelRegister("bTFL0", function(module, exports) {

var $kPZpS = parcelRequire("kPZpS");

var $6u9J6 = parcelRequire("6u9J6");
/**
 * The base implementation of `_.fill` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 */ function $8a9538e21a24514e$var$baseFill(array, value, start, end) {
    var length = array.length;
    start = $kPZpS(start);
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end === undefined || end > length ? length : $kPZpS(end);
    if (end < 0) end += length;
    end = start > end ? 0 : $6u9J6(end);
    while(start < end)array[start++] = value;
    return array;
}
module.exports = $8a9538e21a24514e$var$baseFill;

});
parcelRegister("6u9J6", function(module, exports) {

var $gPWEE = parcelRequire("gPWEE");

var $kPZpS = parcelRequire("kPZpS");
/** Used as references for the maximum length and index of an array. */ var $4b8d16e2178c6ba7$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Converts `value` to an integer suitable for use as the length of an
 * array-like object.
 *
 * **Note:** This method is based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toLength(3.2);
 * // => 3
 *
 * _.toLength(Number.MIN_VALUE);
 * // => 0
 *
 * _.toLength(Infinity);
 * // => 4294967295
 *
 * _.toLength('3.2');
 * // => 3
 */ function $4b8d16e2178c6ba7$var$toLength(value) {
    return value ? $gPWEE($kPZpS(value), 0, $4b8d16e2178c6ba7$var$MAX_ARRAY_LENGTH) : 0;
}
module.exports = $4b8d16e2178c6ba7$var$toLength;

});
parcelRegister("gPWEE", function(module, exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $c41ee85d08292e29$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = $c41ee85d08292e29$var$baseClamp;

});




parcelRegister("li0Zv", function(module, exports) {

$parcel$export(module.exports, "ActionsCellView", () => $5e08c3a0c661c3a6$export$f9f040b096bdc636);

var $5uXOq = parcelRequire("5uXOq");

var $i95f5 = parcelRequire("i95f5");

var $4R6GH = parcelRequire("4R6GH");

var $7HGHK = parcelRequire("7HGHK");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $3Ypxa = parcelRequire("3Ypxa");

var $9OXo1 = parcelRequire("9OXo1");

var $bmKPg = parcelRequire("bmKPg");

var $4jnIy = parcelRequire("4jnIy");

var $7MSYo = parcelRequire("7MSYo");

var $5wcCt = parcelRequire("5wcCt");

var $6Maa1 = parcelRequire("6Maa1");

var $diTwL = parcelRequire("diTwL");

var $bmIyD = parcelRequire("bmIyD");

var $bRJgJ = parcelRequire("bRJgJ");
const $5e08c3a0c661c3a6$export$f9f040b096bdc636 = ({ profile: profile, onActionSuccess: onActionSuccess, onActionFailure: onActionFailure })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { projectKey: projectKey } = (0, $3Ypxa.useCommonPageContext)();
    const userProfile = (0, $7MSYo.normalizeToUserProfile)(profile);
    const [organizationId] = (0, $bmKPg.usePathParam)('organizationId');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { invitedSuccess: invitedSuccess, loading: loading, error: error, errorMessage: errorMessage, fetch: inviteCustomersFetch } = (0, $diTwL.useReinviteCustomerService)(projectKey);
    // Hardcoded date to be used as a cut-off date for the feature gate cut-off-date-for-customer-invite-verification
    const getCutoffDateForCustomerVerification = '2024-01-18T00:00:00Z';
    const { resendVerificationEmailSuccess: resendVerificationEmailSuccess, resendVerificationEmailLoading: resendVerificationEmailLoading, resendVerificationEmailError: resendVerificationEmailError, resendVerificationEmailFetch: resendVerificationEmailFetch, isRateLimited: isRateLimited } = (0, $bmIyD.useResendVerificationEmailService)();
    const actionType = {
        resendVerificationEmail: 'resendVerificationEmail',
        resendInvite: 'resendInvite'
    };
    const { email: email, loggedInStatus: loggedInStatus, emailVerifiedStatus: emailVerifiedStatus, scimManaged: scimManaged } = userProfile || {
        email: '',
        scimManaged: false
    };
    (0, $5uXOq.useEffect)(()=>{
        if (error || resendVerificationEmailError) {
            if (error) {
                const id = (0, $7HGHK.toFlagId)('resend-invite-error-flag');
                onActionFailure(id, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5wcCt.ResendInviteErrorFlag), {
                    id: id,
                    errorMessage: errorMessage
                }));
                const analyticsEventForResendVerificationEmailLinkGenericError = createAnalyticsEvent({
                    actionSubject: 'resendInvite',
                    action: 'clicked GenericError'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEventForResendVerificationEmailLinkGenericError);
            } else if (resendVerificationEmailError) {
                const id = (0, $7HGHK.toFlagId)('resend-verification-email-error-flag');
                onActionFailure(id, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Maa1.ResendVerificationEmailErrorFlag), {
                    id: id,
                    isRateLimited: isRateLimited
                }));
                if (isRateLimited) {
                    const analyticsEventForResendVerificationEmailLinkRateLimitError = createAnalyticsEvent({
                        actionSubject: actionType.resendVerificationEmail,
                        action: 'clicked RateLimitError'
                    });
                    (0, $8zOmE.fireUIAnalytics)(analyticsEventForResendVerificationEmailLinkRateLimitError);
                } else {
                    const analyticsEventForResendVerificationEmailLinkGenericError = createAnalyticsEvent({
                        actionSubject: actionType.resendVerificationEmail,
                        action: 'clicked GenericError'
                    });
                    (0, $8zOmE.fireUIAnalytics)(analyticsEventForResendVerificationEmailLinkGenericError);
                }
            }
        } else if (invitedSuccess || resendVerificationEmailSuccess) {
            const successAction = invitedSuccess ? actionType.resendInvite : actionType.resendVerificationEmail;
            onActionSuccess(email, successAction);
            if (resendVerificationEmailSuccess) {
                const analyticsEventForResendVerificationEmailLink = createAnalyticsEvent({
                    actionSubject: actionType.resendVerificationEmail,
                    action: 'clicked Success'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEventForResendVerificationEmailLink);
            }
        }
    }, [
        error,
        onActionSuccess,
        onActionFailure,
        invitedSuccess,
        email,
        errorMessage,
        resendVerificationEmailSuccess,
        resendVerificationEmailError,
        isRateLimited,
        actionType.resendInvite,
        actionType.resendVerificationEmail,
        createAnalyticsEvent
    ]);
    const tenantContext = (0, $9OXo1.useTenantContext)();
    if (tenantContext) {
        const { firstActivationDateMs: firstActivationDateMs } = tenantContext;
        const cutOffDate = getCutoffDateForCustomerVerification;
        const isTenantActivationAfterCutOffDate = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        new Date(firstActivationDateMs) >= new Date(cutOffDate);
        const isFeatureFlagEnabledToShowResendVerificationLink = (0, $4R6GH.fg)('sptn-1697-email-verified-signal-on-customers-page') && isTenantActivationAfterCutOffDate;
        // logged status is Active and email is not verified, show resend email verification link
        const shouldShowResendVerificationEmail = loggedInStatus === (0, $4jnIy.HAS_LOGGED_IN) && emailVerifiedStatus === false;
        if (isFeatureFlagEnabledToShowResendVerificationLink && shouldShowResendVerificationEmail) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i95f5.default), {
            appearance: "link",
            spacing: "none",
            isLoading: resendVerificationEmailLoading,
            onClick: ()=>{
                resendVerificationEmailFetch(email);
            }
        }, formatMessage((0, $bRJgJ.default).resendVerificationEmailLabel));
    }
    const shouldShowResendInviteLink = (0, $4R6GH.fg)('jsm_lock_scim_managed_customer_and_org') ? loggedInStatus === (0, $4jnIy.PENDING_LOGIN) && !scimManaged : loggedInStatus === (0, $4jnIy.PENDING_LOGIN);
    if (!shouldShowResendInviteLink) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i95f5.default), {
        appearance: "link",
        spacing: "none",
        isLoading: loading,
        onClick: ()=>{
            inviteCustomersFetch(email, (0, $4R6GH.fg)('berry-4881-fix-reinvite-for-non-csm-organizations') ? undefined : organizationId);
        }
    }, formatMessage((0, $bRJgJ.default).resendInviteLinkLabel));
};

});
parcelRegister("5wcCt", function(module, exports) {

$parcel$export(module.exports, "ResendInviteErrorFlag", () => $80c2f76c102e7022$export$489d4eae7c01f5fb);

var $5uXOq = parcelRequire("5uXOq");

var $5E93O = parcelRequire("5E93O");

var $d4xRU = parcelRequire("d4xRU");

var $pa9q9 = parcelRequire("pa9q9");

var $7HGHK = parcelRequire("7HGHK");

var $koVbs = parcelRequire("koVbs");

var $eJ7hJ = parcelRequire("eJ7hJ");

var $avVOT = parcelRequire("avVOT");
const $80c2f76c102e7022$export$489d4eae7c01f5fb = ({ id: id, errorMessage: errorMessage })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { dismissFlag: dismissFlag } = (0, $pa9q9.useFlagService)();
    const onDismissed = (0, $5uXOq.useCallback)(()=>{
        dismissFlag({
            command: (0, $7HGHK.DISMISS_COMMAND),
            id: id
        });
    }, [
        dismissFlag,
        id
    ]);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const onRefresh = (0, $5uXOq.useCallback)(()=>window.location.reload(), []);
    return (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4xRU.default), {
            id: (0, $7HGHK.fromFlagId)(id),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
                spacing: "spacious",
                label: "error",
                color: "var(--ds-icon-danger, #C9372C)"
            }),
            title: formatMessage((0, $avVOT.default).resendInviteFailureFlagTitle),
            messageId: "servicedesk-customers-organization-common.common.ui.resend-invite-error-flag.flag",
            messageType: "transactional",
            description: errorMessage ? // eslint-disable-next-line react/no-danger
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                dangerouslySetInnerHTML: {
                    __html: (0, $eJ7hJ.sanitizeHtml)(errorMessage)
                }
            }) : formatMessage((0, $avVOT.default).resendInviteFailureFlagDescription),
            onDismissed: onDismissed,
            actions: [
                {
                    content: formatMessage((0, $avVOT.default).refreshThePage),
                    onClick: onRefresh
                }
            ]
        }), [
        id,
        formatMessage,
        errorMessage,
        onDismissed,
        onRefresh
    ]);
};

});
parcelRegister("eJ7hJ", function(module, exports) {

$parcel$export(module.exports, "sanitizeHtml", () => $44c3ff950c8d99a7$export$c0fc46c8edd7094a);

var $hXLCJ = parcelRequire("hXLCJ");
const $44c3ff950c8d99a7$export$c0fc46c8edd7094a = (errorMessage)=>(0, (/*@__PURE__*/$parcel$interopDefault($hXLCJ))).sanitize(errorMessage, {
        ALLOWED_TAGS: [
            'p',
            'a',
            'ol',
            'ul',
            'li'
        ],
        ALLOWED_ATTR: [
            'href',
            'target'
        ]
    });

});
parcelRegister("hXLCJ", function(module, exports) {
/*! @license DOMPurify 2.5.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.7/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.7';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});


parcelRegister("avVOT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fc5b4b5d05e51af$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3fc5b4b5d05e51af$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    resendInviteFailureFlagDescription: {
        "id": "servicedesk-customers-organization-common.table.resend-invite-cell.error-flag.resend-invite-failure-flag-description",
        "defaultMessage": "Check your network connection, refresh the page and try again."
    },
    resendInviteFailureFlagTitle: {
        "id": "servicedesk-customers-organization-common.table.resend-invite-cell.error-flag.resend-invite-failure-flag-title",
        "defaultMessage": "We couldn\u2019t resend the invite"
    },
    refreshThePage: {
        "id": "servicedesk-customers-organization-common.table.resend-invite-cell.error-flag.refresh-the-page",
        "defaultMessage": "Refresh the page"
    }
});

});


parcelRegister("6Maa1", function(module, exports) {

$parcel$export(module.exports, "ResendVerificationEmailErrorFlag", () => $0b85ff254bec9994$export$9e77eb81c350f1bb);

var $5uXOq = parcelRequire("5uXOq");

var $5E93O = parcelRequire("5E93O");

var $d4xRU = parcelRequire("d4xRU");

var $pa9q9 = parcelRequire("pa9q9");

var $7HGHK = parcelRequire("7HGHK");

var $koVbs = parcelRequire("koVbs");

var $373eK = parcelRequire("373eK");
const $0b85ff254bec9994$export$9e77eb81c350f1bb = ({ id: id, isRateLimited: isRateLimited = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { dismissFlag: dismissFlag } = (0, $pa9q9.useFlagService)();
    const onDismissed = (0, $5uXOq.useCallback)(()=>{
        dismissFlag({
            command: (0, $7HGHK.DISMISS_COMMAND),
            id: id
        });
    }, [
        dismissFlag,
        id
    ]);
    let flagDescription = '';
    let flagTitle = '';
    if (isRateLimited) {
        flagDescription = formatMessage((0, $373eK.default).resendVerificationEmailRateLimitFailureFlagDescription);
        flagTitle = formatMessage((0, $373eK.default).resendVerificationEmailRateLimitFailureFlagTitle);
    } else {
        flagDescription = formatMessage((0, $373eK.default).resendVerificationEmailGenericFailureFlagDescription);
        flagTitle = formatMessage((0, $373eK.default).resendVerificationEmailGenericFailureFlagTitle);
    }
    return (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4xRU.default), {
            id: (0, $7HGHK.fromFlagId)(id),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
                spacing: "spacious",
                label: "error",
                color: "var(--ds-icon-danger, #C9372C)"
            }),
            title: flagTitle,
            description: flagDescription,
            onDismissed: onDismissed,
            messageId: "servicedesk-customers-organization-common.common.ui.resend-verification-email-error-flag.flag",
            messageType: "transactional"
        }), [
        id,
        flagTitle,
        flagDescription,
        onDismissed
    ]);
};

});
parcelRegister("373eK", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc7dddb0382d5d25$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dc7dddb0382d5d25$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    resendVerificationEmailGenericFailureFlagDescription: {
        "id": "servicedesk-customers-organization-common.common.resend-verification-email-error-flag.resend-verification-email-generic-failure-flag-description",
        "defaultMessage": "An error occurred while sending the verification email. Try again later."
    },
    resendVerificationEmailGenericFailureFlagTitle: {
        "id": "servicedesk-customers-organization-common.common.resend-verification-email-error-flag.resend-verification-email-generic-failure-flag-title",
        "defaultMessage": "We couldn\u2019t send verification email"
    },
    resendVerificationEmailRateLimitFailureFlagDescription: {
        "id": "servicedesk-customers-organization-common.common.resend-verification-email-error-flag.resend-verification-email-rate-limit-failure-flag-description",
        "defaultMessage": "An error occurred while sending the verification email. Resend it after 24 hours."
    },
    resendVerificationEmailRateLimitFailureFlagTitle: {
        "id": "servicedesk-customers-organization-common.common.resend-verification-email-error-flag.resend-verification-email-rate-limit-failure-flag-title",
        "defaultMessage": "Verification email couldn\u2019t be sent"
    }
});

});


parcelRegister("diTwL", function(module, exports) {

$parcel$export(module.exports, "useReinviteCustomerService", () => $df3571a0bfd98f55$export$18671b9f790ecb4c);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $a7EYT = parcelRequire("a7EYT");
const $df3571a0bfd98f55$export$18671b9f790ecb4c = (projectKey)=>{
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [invitedSuccess, setInvitedSuccess] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [errorMessage, setErrorMessage] = (0, $5uXOq.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fetch = (0, $5uXOq.useCallback)(async (email, organizationId)=>{
        setLoading(true);
        setError(null);
        setInvitedSuccess(false);
        setErrorMessage(null);
        try {
            await (0, $a7EYT.performPostRequest)(`/rest/servicedesk/1/pages/people/customers/pagination/${projectKey}/invite/resend`, {
                body: JSON.stringify({
                    email: email,
                    organizationId: organizationId
                })
            });
            setInvitedSuccess(true);
            setLoading(false);
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'customerInvite success');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const { response: response } = err;
            if (response?.failed?.length > 0) setErrorMessage(response.failed[0].error);
            else if (response?.errors?.length > 0) setErrorMessage(response?.errors[0].errorMessage);
            setLoading(false);
            setError(err);
            (0, $jcw0u.default)({
                event: createAnalyticsEvent({}),
                error: err,
                meta: {
                    id: 'resendInviteButton',
                    packageName: 'customerOrganisationCommon'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        createAnalyticsEvent,
        projectKey
    ]);
    return {
        loading: loading,
        error: error,
        invitedSuccess: invitedSuccess,
        errorMessage: errorMessage,
        fetch: fetch
    };
};

});

parcelRegister("bmIyD", function(module, exports) {

$parcel$export(module.exports, "useResendVerificationEmailService", () => $0f4ffc83d9a930ff$export$55652cef9139f6ed);

var $5uXOq = parcelRequire("5uXOq");

var $a7EYT = parcelRequire("a7EYT");
const $0f4ffc83d9a930ff$export$55652cef9139f6ed = ()=>{
    const [resendVerificationEmailLoading, setLoading] = (0, $5uXOq.useState)(false);
    const [isRateLimited, setIsRateLimited] = (0, $5uXOq.useState)(false);
    const [resendVerificationEmailSuccess, setResendVerificationEmailSuccess] = (0, $5uXOq.useState)(false);
    const [resendVerificationEmailError, setError] = (0, $5uXOq.useState)(null);
    const resendVerificationEmailFetch = (0, $5uXOq.useCallback)(async (email)=>{
        setLoading(true);
        setError(null);
        setResendVerificationEmailSuccess(false);
        try {
            await (0, $a7EYT.performPostRequest)('/rest/servicedesk/1/customer/pages/user/resend-verification-email', {
                body: JSON.stringify({
                    email: email,
                    verificationContext: {
                        portalId: null
                    }
                })
            });
            setResendVerificationEmailSuccess(true);
            setLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const { statusCode: statusCode } = err;
            if (statusCode === 429) setIsRateLimited(true);
            else setIsRateLimited(false);
            setLoading(false);
            setError(err);
        }
    }, []);
    return {
        resendVerificationEmailLoading: resendVerificationEmailLoading,
        resendVerificationEmailError: resendVerificationEmailError,
        resendVerificationEmailSuccess: resendVerificationEmailSuccess,
        resendVerificationEmailFetch: resendVerificationEmailFetch,
        isRateLimited: isRateLimited
    };
};

});

parcelRegister("bRJgJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e48717fd108f8455$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e48717fd108f8455$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    resendInviteLinkLabel: {
        "id": "servicedesk-customers-organization-common.table.actions-cell-view.resend-invite-link-label",
        "defaultMessage": "Resend Invite"
    },
    resendVerificationEmailLabel: {
        "id": "servicedesk-customers-organization-common.table.actions-cell-view.resend-verification-email-label",
        "defaultMessage": "Resend verification email"
    }
});

});


parcelRegister("ieb8i", function(module, exports) {

$parcel$export(module.exports, "CustomerCell", () => $79e4e5db1de568ec$export$24dc00c93079305a);

var $5uXOq = parcelRequire("5uXOq");

var $7MSYo = parcelRequire("7MSYo");

var $1uM1M = parcelRequire("1uM1M");

var $8LtxU = parcelRequire("8LtxU");
const $79e4e5db1de568ec$export$24dc00c93079305a = ({ profile: profile, projectKey: projectKey })=>{
    const orgProfile = (0, $7MSYo.normalizeToOrgProfile)(profile);
    if (orgProfile) {
        const { id: id, displayName: displayName } = orgProfile;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1uM1M.OrganizationCell), {
            id: id,
            displayName: displayName,
            projectKey: projectKey
        });
    }
    const userProfile = (0, $7MSYo.normalizeToUserProfile)(profile);
    if (userProfile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8LtxU.UserCell), {
        profile: userProfile
    });
    return null;
};

});
parcelRegister("1uM1M", function(module, exports) {

$parcel$export(module.exports, "OrganizationCell", () => $cea3b629f956ce5d$export$6f59e9f7993195f3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $IoPSi = parcelRequire("IoPSi");

var $lVJAU = parcelRequire("lVJAU");
const $cea3b629f956ce5d$export$6f59e9f7993195f3 = ({ id: id, displayName: displayName, projectKey: projectKey })=>{
    const baseUrl = '';
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const organizationUrl = (0, $5uXOq.useMemo)(()=>`${baseUrl}/jira/servicedesk/projects/${projectKey}/organization/${id}`, [
        baseUrl,
        id,
        projectKey
    ]);
    const onClick = (0, $5uXOq.useCallback)((e)=>{
        // modifier key + click should open in a new tab/window so we let the default
        // href behaviour occur in that case. For a regular left click we want to prevent
        // the href behaviour since we're using the router to navigate.
        // Without this, we try to load the page twice which causes resources to start
        // loading and then be cut off, creating 'Failed to fetch' errors
        if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) return;
        e.preventDefault();
        push(organizationUrl);
    }, [
        organizationUrl,
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cea3b629f956ce5d$var$StyledWrapper, {
        "data-testid": "servicedesk-customers-organization-common.ui.table.customer-cell.organization.styled-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($IoPSi))), {
            color: "var(--ds-icon, #44546F)",
            label: displayName
        }),
        onClick: onClick,
        href: organizationUrl
    }, displayName));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cea3b629f956ce5d$var$StyledWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i14no _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8LtxU", function(module, exports) {

$parcel$export(module.exports, "UserCell", () => $30249f816ff19fc1$export$dc0ef711c0db7c30);
$parcel$export(module.exports, "Label", () => $30249f816ff19fc1$export$b04be29aa201d4f5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ew55A = parcelRequire("ew55A");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $2s57o = parcelRequire("2s57o");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $kYYfm = parcelRequire("kYYfm");


var $fo16D = parcelRequire("fo16D");

var $ifXSr = parcelRequire("ifXSr");
const $30249f816ff19fc1$export$dc0ef711c0db7c30 = ({ profile: { identifier: identifier, avatarUrl: avatarUrl, displayName: displayName, email: email, organisationNames: organisationNames } })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const privateEmail = formatMessage((0, $ifXSr.default).privateEmail);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kYYfm.AsyncProfileCardNext), {
        accountId: identifier,
        actions: [
            (0, $e6a2e0952e4731b8$export$23cedd3261bd8015)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $30249f816ff19fc1$var$wrapperStyles,
        testId: "servicedesk-customers-organization-common.ui.table.customer-cell.user.user-cell"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $30249f816ff19fc1$var$agentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew55A.default), {
        src: avatarUrl,
        size: "small",
        borderColor: "transparent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $30249f816ff19fc1$var$emailStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        as: "span",
        xcss: $30249f816ff19fc1$var$labelStyles
    }, displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        as: "span",
        xcss: [
            $30249f816ff19fc1$var$labelStyles,
            $30249f816ff19fc1$var$privateEmailStyles
        ]
    }, email || privateEmail)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fo16D.LozengeGroup), {
        organizationNames: organisationNames
    }))));
};
const $30249f816ff19fc1$var$wrapperStyles = (0, $2s57o.xcss)({
    padding: 'space.050',
    display: 'flex',
    textAlign: 'left'
});
const $30249f816ff19fc1$var$agentStyles = (0, $2s57o.xcss)({
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    border: 0,
    borderRadius: 'border.radius',
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.050',
    paddingRight: 'space.050',
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $gwIPs.gridSize) * 4.5}px`,
    overflowX: 'hidden'
});
const $30249f816ff19fc1$var$labelStyles = (0, $2s57o.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '1.4',
    paddingLeft: 'space.050',
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    textAlign: 'left'
});
const $30249f816ff19fc1$var$emailStyles = (0, $2s57o.xcss)({
    display: 'flex',
    flexDirection: 'column'
});
const $30249f816ff19fc1$var$privateEmailStyles = (0, $2s57o.xcss)({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest'
});
const $30249f816ff19fc1$export$b04be29aa201d4f5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz419ii _19bv1b66 _1reo15vq _1bto1l2s _o5721q9c _y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kYYfm", function(module, exports) {

$parcel$export(module.exports, "AsyncProfileCardNext", () => $15521008cc986085$export$a3c0845f856d4292);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $gcl1l = parcelRequire("gcl1l");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $15521008cc986085$var$LazyComponent = (0, $b7Svb.lazy)(()=>(parcelRequire("19c0Q")).then((module)=>module.ProfileCard), {
    moduleId: "./src/packages/profilecard-next/src/main.tsx"
});
const $15521008cc986085$export$a3c0845f856d4292 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "AsyncProfileCardNext",
        packageName: "jiraProfilecardNext",
        render: ()=>// props.children in this context is the code being wrapped
            // in a <ProfileCardTrigger> (I.e. it is the thing a user hovers over to
            // display a profile card).
            // In the event of an unexpected error within @atlaskit/profilecard,
            // just render the unwrapped children (I.e. they will render but nothing
            // happens on hover)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada",
        attributes: (0, $gcl1l.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-profile-card-next-view",
        fallback: props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15521008cc986085$var$LazyComponent, props)));
var $15521008cc986085$export$2e2bcd8739ae039 = $15521008cc986085$export$a3c0845f856d4292;

});
parcelRegister("19c0Q", function(module, exports) {

let $0d5ff32adb804d7c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0d5ff32adb804d7c$var$load("h2MrD"),
    $0d5ff32adb804d7c$var$load("bYT2S"),
    $0d5ff32adb804d7c$var$load("cM9em"),
    $0d5ff32adb804d7c$var$load("fr9NE"),
    $0d5ff32adb804d7c$var$load("ek7ue")
]).then(()=>parcelRequire('jO6eK'));

});


const $e6a2e0952e4731b8$export$81319ffa9c0d18d7 = 'profileCardNext';
const $e6a2e0952e4731b8$export$50632e21ea714398 = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $e6a2e0952e4731b8$export$23cedd3261bd8015 = 'viewProfile';
const $e6a2e0952e4731b8$export$6bef782d14a92db8 = 'assignedIssues';
const $e6a2e0952e4731b8$export$6b36f20db7a18a86 = 'reportedIssues';
const $e6a2e0952e4731b8$export$56da0dd0b0aa67b9 = 'viewFilters';

parcelRegister("fo16D", function(module, exports) {

$parcel$export(module.exports, "LozengeGroup", () => $bf15c3eb22395b97$export$23762007a3044933);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eOat1 = parcelRequire("eOat1");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");
const $bf15c3eb22395b97$export$23762007a3044933 = ({ organizationNames: organizationNames })=>{
    if (!organizationNames || !organizationNames.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $bf15c3eb22395b97$var$wrapperStyles,
        tabIndex: 0
    }, organizationNames.map((organizationName)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bf15c3eb22395b97$var$Spaced, {
            key: organizationName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
            value: "default"
        }, organizationName))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bf15c3eb22395b97$var$Spaced = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $bf15c3eb22395b97$var$wrapperStyles = (0, $2s57o.xcss)({
    marginLeft: 'space.100'
});

});

parcelRegister("ifXSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d1ae3849e0f068$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $55d1ae3849e0f068$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    privateEmail: {
        "id": "servicedesk-customers-organization-common.table.customer-cell.user.private-email",
        "defaultMessage": "private email address"
    },
    moreOrgs: {
        "id": "servicedesk-customers-organization-common.table.customer-cell.user.more-orgs",
        "defaultMessage": "+ {moreCount}"
    }
});

});



parcelRegister("kLSnD", function(module, exports) {

$parcel$export(module.exports, "EditorCell", () => $a0a019a049a6a3a8$export$c1f633b9199aef47);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $1hvXK = parcelRequire("1hvXK");

var $5KCCi = parcelRequire("5KCCi");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $7MSYo = parcelRequire("7MSYo");

var $7QdGH = parcelRequire("7QdGH");
const $a0a019a049a6a3a8$export$c1f633b9199aef47 = ({ projectName: projectName, profile: profile, onRemove: onRemove, showRemoveCustomerTooltip: showRemoveCustomerTooltip, fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics) })=>{
    const { displayName: displayName } = profile;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tooltipMessage = showRemoveCustomerTooltip === true ? formatMessage((0, $7QdGH.default).removeCustomerFromOrganization) : formatMessage((0, $7QdGH.default).removeProfile, {
        displayName: displayName,
        projectName: projectName
    });
    const handleRemoveClick = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        onRemove(profile);
        const actionSubjectId = (0, $7MSYo.isOrganization)(profile) ? 'removeOrganizationButton' : 'removeCustomerButton';
        fireUIAnalytics(analyticsEvent, actionSubjectId);
    }, [
        onRemove,
        profile,
        fireUIAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: tooltipMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "subtle",
        testId: "servicedesk-customers-organization-common.ui.table.editor-cell.button",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1hvXK))), {
            spacing: "spacious",
            label: tooltipMessage
        }),
        onClick: handleRemoveClick
    }));
};

});
parcelRegister("7QdGH", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f535efad956a7f1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8f535efad956a7f1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    removeProfile: {
        "id": "servicedesk-customers-organization-common.table.editor-cell.remove-profile",
        "defaultMessage": "Remove {displayName} from {projectName}."
    },
    removeCustomerFromOrganization: {
        "id": "servicedesk-customers-organization-common.table.editor-cell.remove-customer-from-organization",
        "defaultMessage": "Remove customer from organization"
    }
});

});


parcelRegister("am28C", function(module, exports) {

$parcel$export(module.exports, "LoggedInStatusCellView", () => $85554a912648b75d$export$43f24582ef577545);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aUcIH = parcelRequire("aUcIH");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $9OXo1 = parcelRequire("9OXo1");

var $4jnIy = parcelRequire("4jnIy");

var $7MSYo = parcelRequire("7MSYo");

var $eXyvn = parcelRequire("eXyvn");
const $85554a912648b75d$export$43f24582ef577545 = ({ profile: profile })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const userProfile = (0, $7MSYo.normalizeToUserProfile)(profile);
    const tenantContext = (0, $9OXo1.useTenantContext)();
    // Hardcoded date to be used as a cut-off date for the feature gate cut-off-date-for-customer-invite-verification
    const getCutoffDateForCustomerVerification = '2024-01-18T00:00:00Z';
    if (tenantContext) {
        const { firstActivationDateMs: firstActivationDateMs } = tenantContext;
        const cutOffDate = getCutoffDateForCustomerVerification;
        const isTenantActivationAfterCutOffDate = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        new Date(firstActivationDateMs) >= new Date(cutOffDate);
        if (userProfile) {
            const { loggedInStatus: loggedInStatus, emailVerifiedStatus: emailVerifiedStatus } = userProfile;
            if (loggedInStatus === (0, $4jnIy.NOT_AVAILABLE)) return null;
            const appendUnverifiedEmailText = (0, $4R6GH.fg)('sptn-1697-email-verified-signal-on-customers-page') && isTenantActivationAfterCutOffDate;
            if (appendUnverifiedEmailText && emailVerifiedStatus === false) {
                let status = '';
                if (loggedInStatus === (0, $4jnIy.HAS_LOGGED_IN)) status = formatMessage((0, $eXyvn.default).activeStatusLabel);
                else if (loggedInStatus === (0, $4jnIy.PENDING_LOGIN)) status = formatMessage((0, $eXyvn.default).inviteStatusLabel);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, status), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85554a912648b75d$var$PrivateEmailLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85554a912648b75d$var$InlineMessageWrapper, null, formatMessage((0, $eXyvn.default).unverifiedEmail), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aUcIH.default), {
                    appearance: "info",
                    placement: "bottom-end"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85554a912648b75d$var$InlineMessageContent, null, formatMessage((0, $eXyvn.default).unverifiedEmailTooltip))))));
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, loggedInStatus === (0, $4jnIy.HAS_LOGGED_IN) ? formatMessage((0, $eXyvn.default).activeStatusLabel) : formatMessage((0, $eXyvn.default).inviteStatusLabel));
        }
    }
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $85554a912648b75d$var$InlineMessageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _jq8gpxbi _igocpxbi _k6cgpxbi _1d42pxbi _1sla131l",
            __cmplp.className
        ])
    });
});
const $85554a912648b75d$var$InlineMessageContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _k48pi7a9 _p12fs1ma _o5724jg8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $85554a912648b75d$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _1bto1l2s _o5721q9c _y3gn1e5h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $85554a912648b75d$var$PrivateEmailLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $85554a912648b75d$var$Label, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eXyvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a661d5935434f124$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a661d5935434f124$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    activeStatusLabel: {
        "id": "servicedesk-customers-organization-common.table.logged-in-status-cell.active-status-label",
        "defaultMessage": "Active"
    },
    inviteStatusLabel: {
        "id": "servicedesk-customers-organization-common.table.logged-in-status-cell.invite-status-label",
        "defaultMessage": "Invited"
    },
    unverifiedEmail: {
        "id": "servicedesk-customers-organization-common.table.logged-in-status-cell.unverified-email",
        "defaultMessage": "Unverified email"
    },
    unverifiedEmailTooltip: {
        "id": "servicedesk-customers-organization-common.table.logged-in-status-cell.unverified-email-tooltip",
        "defaultMessage": "Customer needs to verify email address to receive notifications"
    }
});

});


parcelRegister("2C5Rr", function(module, exports) {

$parcel$export(module.exports, "OpenRequestsCell", () => $241fe4965fda1236$export$6232c8d38dd75a76);
$parcel$export(module.exports, "ClosedRequestsCell", () => $241fe4965fda1236$export$217e2042d93a264e);

var $ipQaV = parcelRequire("ipQaV");
const $241fe4965fda1236$export$6232c8d38dd75a76 = (0, $ipQaV.OpenRequestsCellView);
const $241fe4965fda1236$export$217e2042d93a264e = (0, $ipQaV.ClosedRequestsCellView);

});
parcelRegister("ipQaV", function(module, exports) {

$parcel$export(module.exports, "OpenRequestsCellView", () => $b61ef87555d1e238$export$769d59d9cebdd255);
$parcel$export(module.exports, "ClosedRequestsCellView", () => $b61ef87555d1e238$export$9d1a10e8875012df);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $6eFvr = parcelRequire("6eFvr");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $dDgAS = parcelRequire("dDgAS");
const $b61ef87555d1e238$var$REQUESTS_STATUS = {
    OPEN: 'Open',
    CLOSED: 'Closed'
};
const $b61ef87555d1e238$var$LinkButton = ({ jqlString: jqlString, label: label, type: type })=>{
    const baseUrl = '';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onClick = (_x, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, `viewRequests${type}`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        spacing: "none",
        appearance: "link",
        href: `${baseUrl}/issues/?jql=${jqlString}`,
        target: "_blank",
        onClick: onClick
    }, label);
};
const $b61ef87555d1e238$export$769d59d9cebdd255 = ({ profile: { openRequestsJql: openRequestsJql, openRequestCount: openRequestCount, showCounts: showCounts } })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!showCounts) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b61ef87555d1e238$var$LinkButton, {
        label: formatMessage((0, $dDgAS.default).viewOpen),
        jqlString: openRequestsJql,
        type: $b61ef87555d1e238$var$REQUESTS_STATUS.OPEN
    });
    if (openRequestCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b61ef87555d1e238$var$LinkButton, {
        label: formatMessage((0, $dDgAS.default).openRequests, {
            requestsCount: openRequestCount
        }),
        jqlString: openRequestsJql,
        type: $b61ef87555d1e238$var$REQUESTS_STATUS.OPEN
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, formatMessage((0, $dDgAS.default).openRequests, {
        requestsCount: openRequestCount
    }));
};
const $b61ef87555d1e238$export$9d1a10e8875012df = ({ profile: { closedRequestCount: closedRequestCount, closedRequestsJql: closedRequestsJql, showCounts: showCounts } })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!showCounts) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b61ef87555d1e238$var$LinkButton, {
        label: formatMessage((0, $dDgAS.default).viewClosed),
        jqlString: closedRequestsJql,
        type: $b61ef87555d1e238$var$REQUESTS_STATUS.CLOSED
    });
    if (closedRequestCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b61ef87555d1e238$var$LinkButton, {
        label: formatMessage((0, $dDgAS.default).closedRequests, {
            requestsCount: closedRequestCount
        }),
        jqlString: closedRequestsJql,
        type: $b61ef87555d1e238$var$REQUESTS_STATUS.CLOSED
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, formatMessage((0, $dDgAS.default).closedRequests, {
        requestsCount: closedRequestCount
    }));
};

});
parcelRegister("dDgAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $815cc70136dae317$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $815cc70136dae317$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewOpen: {
        "id": "servicedesk-customers-organization-common.table.requests-cell.view-open",
        "defaultMessage": "View open"
    },
    openRequests: {
        "id": "servicedesk-customers-organization-common.table.requests-cell.open-requests",
        "defaultMessage": "{requestsCount} open"
    },
    viewClosed: {
        "id": "servicedesk-customers-organization-common.table.requests-cell.view-closed",
        "defaultMessage": "View closed"
    },
    closedRequests: {
        "id": "servicedesk-customers-organization-common.table.requests-cell.closed-requests",
        "defaultMessage": "{requestsCount} closed"
    }
});

});




parcelRegister("2XO17", function(module, exports) {

$parcel$export(module.exports, "PaginationLabel", () => $80bc45b7bf09b6a3$export$5742121915cb78c6);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $cBCgC = parcelRequire("cBCgC");

var $koVbs = parcelRequire("koVbs");

var $jQfuF = parcelRequire("jQfuF");
const $80bc45b7bf09b6a3$export$a7bb072605d6094c = 'servicedesk-customers-organization-common.ui.table.pagination-count-label';
const $80bc45b7bf09b6a3$export$5742121915cb78c6 = ({ label: label = '', start: start = 0, end: end = 0, size: size = 0, justifyCenter: justifyCenter = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (label) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "p",
        xcss: [
            $80bc45b7bf09b6a3$var$labelStyles,
            !justifyCenter && $80bc45b7bf09b6a3$var$justifyRightStyles
        ],
        "aria-live": "polite",
        "data-testId": $80bc45b7bf09b6a3$export$a7bb072605d6094c
    }, label);
    if (size > 0 && end >= start) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "p",
        xcss: $80bc45b7bf09b6a3$var$labelStyles,
        "aria-live": "polite",
        "data-testId": $80bc45b7bf09b6a3$export$a7bb072605d6094c
    }, formatMessage((0, $jQfuF.default).paginationMessage, {
        start: start,
        end: end,
        size: size,
        span: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cBCgC.default), null, chunks)
    }));
    return null;
};
const $80bc45b7bf09b6a3$var$labelStyles = (0, $2s57o.xcss)({
    float: 'right',
    margin: 'space.0',
    position: 'relative',
    gridColumnStart: 1,
    gridRowStart: 1,
    justifySelf: 'center',
    bottom: 'space.0'
});
const $80bc45b7bf09b6a3$var$justifyRightStyles = (0, $2s57o.xcss)({
    justifySelf: 'right'
});

});
parcelRegister("jQfuF", function(module, exports) {

$parcel$export(module.exports, "default", () => $50860dee8ff9d09b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50860dee8ff9d09b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    paginationMessage: {
        "id": "servicedesk-customers-organization-common.table.pagination-count-label.pagination-message",
        "defaultMessage": "{start}-{end} for {size} <span>{size, plural, =1{result} other{results}} found</span>"
    }
});

});


parcelRegister("cpkrl", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $ed74b32a4a341fbe$export$fddf379e22a74b00);

var $5uXOq = parcelRequire("5uXOq");

var $3s0xG = parcelRequire("3s0xG");

var $koVbs = parcelRequire("koVbs");

var $cz3nR = parcelRequire("cz3nR");
const $ed74b32a4a341fbe$export$fddf379e22a74b00 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "servicedesk-customers-organization-common.ui.table.pagination.wrapper",
        "aria-live": "polite"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
        header: formatMessage((0, $cz3nR.default).noResults)
    }));
};

});
parcelRegister("cz3nR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e3afaef2645ff83$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5e3afaef2645ff83$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    paginationPrev: {
        "id": "servicedesk-customers-organization-common.table.pagination.pagination-prev",
        "defaultMessage": "Prev"
    },
    paginationNext: {
        "id": "servicedesk-customers-organization-common.table.pagination.pagination-next",
        "defaultMessage": "Next"
    },
    noResults: {
        "id": "servicedesk-customers-organization-common.table.pagination.no-results",
        "defaultMessage": "No matches for your search."
    }
});

});


parcelRegister("g3UsO", function(module, exports) {

$parcel$export(module.exports, "usePaginationHook", () => $229434620c808d96$export$107464500942a07f);

var $5uXOq = parcelRequire("5uXOq");

var $cBCgC = parcelRequire("cBCgC");

var $koVbs = parcelRequire("koVbs");

var $dvemE = parcelRequire("dvemE");

var $TbEw5 = parcelRequire("TbEw5");
const $229434620c808d96$var$DEFAULT_PAGE_RANGE = 40;
const $229434620c808d96$export$107464500942a07f = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { query: query, totalHasBeenDetermined: totalHasBeenDetermined, total: total, lastDeterminedPaged: lastDeterminedPaged, pageNumber: pageNumber } = props;
    const isSearching = query !== '';
    const rowsPerPage = isSearching ? (0, $dvemE.SEARCH_PER_PAGE) : (0, $dvemE.LIST_PER_PAGE);
    const start = (pageNumber - 1) * rowsPerPage + 1;
    const end = Math.min((pageNumber - 1) * rowsPerPage + rowsPerPage, total);
    // 1-100 of 100+
    const listLabel = formatMessage((0, $TbEw5.default).pageLabel, {
        start: start,
        end: end,
        total: total,
        hasPlusSign: !totalHasBeenDetermined,
        span: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cBCgC.default), null, chunks)
    });
    // 1-20 of 20, search is always limited to 20 results
    const searchLabel = formatMessage((0, $TbEw5.default).searchLabel, {
        start: start,
        end: end,
        total: total,
        span: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cBCgC.default), null, chunks)
    });
    const paginationLabel = isSearching ? searchLabel : listLabel;
    const isMaxLimitReached = lastDeterminedPaged > $229434620c808d96$var$DEFAULT_PAGE_RANGE;
    const defaultTotalPages = totalHasBeenDetermined || isMaxLimitReached ? pageNumber : lastDeterminedPaged;
    const totalPages = isSearching ? total : defaultTotalPages;
    const showPagination = !isSearching && totalPages > 1;
    const hideRightEllipsis = isMaxLimitReached || totalHasBeenDetermined;
    // < 1, 2, ... >
    const bracketSize = lastDeterminedPaged < 2 ? 2 : 5;
    return {
        isMaxLimitReached: isMaxLimitReached,
        paginationLabel: paginationLabel,
        showPagination: showPagination,
        totalPages: totalPages,
        bracketSize: bracketSize,
        hideRightEllipsis: hideRightEllipsis
    };
};

});
parcelRegister("TbEw5", function(module, exports) {

$parcel$export(module.exports, "default", () => $93a67dbe101a5405$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $93a67dbe101a5405$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pageLabel: {
        "id": "servicedesk-customers-organization-common.table.page-label",
        "defaultMessage": "{start}-{end} of {total}{hasPlusSign, select, true{+} other{}} <span>{total, plural, =1{result} other{results}} found</span>"
    },
    searchLabel: {
        "id": "servicedesk-customers-organization-common.table.search-label",
        "defaultMessage": "{start}-{end} for {total} <span>{total, plural, =1{result} other{results}} found</span>"
    }
});

});



parcelRegister("dCnF8", function(module, exports) {

$parcel$export(module.exports, "useRemoveCustomerService", () => $a67d7a2e27b3b3ba$export$fa0c75e7be8471fb);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");

var $6Nl1e = parcelRequire("6Nl1e");
const $a67d7a2e27b3b3ba$export$fa0c75e7be8471fb = (baseUrl, projectKey)=>{
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [data, setData] = (0, $5uXOq.useState)(null);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const fetch = (0, $5uXOq.useCallback)(async (customerId)=>{
        setLoading(true);
        setError(null);
        try {
            await (0, $eusud.performDeleteRequest)((0, $6Nl1e.getUrl)(baseUrl, projectKey, customerId));
            setData(customerId);
            setLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setLoading(false);
            setError(err);
            // Only fire analytics for unexpected errors. ValidationErrors are used when
            // the backend returns a 400. Expected 400 errors from the backend include:
            // - user is removed successfully from the customer role but still maintains access to Service Desk
            // This error message is used to let the user know that they may still need to adjust
            // permissions if removal of access is required, but it doesn't indicate a failure
            const shouldFireErrorAnalytics = !(0, $jJZqs.isValidationError)(err);
            if (shouldFireErrorAnalytics) (0, $jcw0u.default)({
                error: err,
                meta: {
                    id: 'useRemoveCustomerService',
                    packageName: 'jiraServicedeskCustomers',
                    teamName: 'boysenberry'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        baseUrl,
        projectKey
    ]);
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type '((Error | ValidationErrors | { statusCode: number; message?: string | undefined; }) & ValidationErrors) | null'.
        error,
        data: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceData<Data>'.
        data,
        fetch: // @ts-expect-error - TS2322 - Type '(customerId: string) => Promise<void>' is not assignable to type '(() => Promise<void>) & ((arg1: string) => Promise<void>)'.
        fetch
    };
};

});
parcelRegister("6Nl1e", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $8989c896ec43af8b$export$94df0e59ebebf4a7);
const $8989c896ec43af8b$export$94df0e59ebebf4a7 = (baseUrl, projectKey, customerId)=>`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/customerrole/${customerId}/remove`;

});


parcelRegister("lAlfB", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ed0e3796eb9b91f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7ed0e3796eb9b91f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flagTitle: {
        "id": "servicedesk-customers.table.flag-title",
        "defaultMessage": "{customerName} removed from {projectName}"
    },
    removeCustomerError: {
        "id": "servicedesk-customers.table.remove-customer-error",
        "defaultMessage": "Something has gone wrong with your request. If symptoms persist contact your System Administrator."
    },
    resendInviteSuccessFlagTitle: {
        "id": "servicedesk-customers.table.resend-invite-success-flag-title",
        "defaultMessage": "Invite sent successfully"
    },
    resendInviteSuccessFlagDescription: {
        "id": "servicedesk-customers.table.resend-invite-success-flag-description",
        "defaultMessage": "An email has been sent to {email} to set a password for their account."
    },
    resendVerificationEmailTitle: {
        "id": "servicedesk-customers.table.resend-verification-email-title",
        "defaultMessage": "Verification email sent successfully"
    },
    resendVerificationEmailDescription: {
        "id": "servicedesk-customers.table.resend-verification-email-description",
        "defaultMessage": "An email has been sent to {email} to verify the customer\u2019s email address."
    },
    resendInviteFailureFlagTitle: {
        "id": "servicedesk-customers.table.resend-invite-failure-flag-title",
        "defaultMessage": "We couldn\u2019t resend the invite"
    },
    resendInviteFailureFlagDescription: {
        "id": "servicedesk-customers.table.resend-invite-failure-flag-description",
        "defaultMessage": "Check your network connection, refresh the page and try again."
    }
});

});





parcelRegister("b2XdI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b693b7ac6b5692db$export$2e2bcd8739ae039);

var $6sNnq = parcelRequire("6sNnq");

var $2YP9W = parcelRequire("2YP9W");
const $b693b7ac6b5692db$var$useServiceProjectFeatures = ()=>(0, $2YP9W.useResource)((0, $6sNnq.featuresResource));
var $b693b7ac6b5692db$export$2e2bcd8739ae039 = $b693b7ac6b5692db$var$useServiceProjectFeatures;

});

parcelRegister("cf7yQ", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $8aa55ef5824c4e4d$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $8aa55ef5824c4e4d$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $8aa55ef5824c4e4d$export$c7732c55900cf0b9);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("sXYgA")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanel = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("2OvSt")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("f6mEW")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("1oRHz")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $8aa55ef5824c4e4d$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender, null));
$8aa55ef5824c4e4d$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $8aa55ef5824c4e4d$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanel, null));
$8aa55ef5824c4e4d$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton, null));
$8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $8aa55ef5824c4e4d$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight, null));
$8aa55ef5824c4e4d$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("sXYgA", function(module, exports) {

let $057122a3b41c04fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $057122a3b41c04fd$var$load("eNmuD"),
    $057122a3b41c04fd$var$load("chQyv")
]).then(()=>parcelRequire('hZyYK'));

});

parcelRegister("2OvSt", function(module, exports) {

let $20c8fa806ea6db90$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $20c8fa806ea6db90$var$load("eNmuD"),
    $20c8fa806ea6db90$var$load("cM9em"),
    $20c8fa806ea6db90$var$load("fr9NE"),
    $20c8fa806ea6db90$var$load("3Xgpx")
]).then(()=>parcelRequire('2NciN'));

});

parcelRegister("f6mEW", function(module, exports) {

let $afe8fe3c672ff16f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $afe8fe3c672ff16f$var$load("eNmuD"),
    $afe8fe3c672ff16f$var$load("cM9em"),
    $afe8fe3c672ff16f$var$load("fr9NE"),
    $afe8fe3c672ff16f$var$load("hlGg7")
]).then(()=>parcelRequire('4F6ZA'));

});

parcelRegister("1oRHz", function(module, exports) {

let $1051b0675adbeaab$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1051b0675adbeaab$var$load("eNmuD"),
    $1051b0675adbeaab$var$load("cM9em"),
    $1051b0675adbeaab$var$load("fr9NE"),
    $1051b0675adbeaab$var$load("eXDqW")
]).then(()=>parcelRequire('6Wput'));

});


parcelRegister("e33py", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $ae40b537a934bf9c$export$155581e8dc02007a);
$parcel$export(module.exports, "ServiceDeskDocumentTitle", () => $ae40b537a934bf9c$export$c7841d2c1c13065e);

var $5uXOq = parcelRequire("5uXOq");

var $9sGI6 = parcelRequire("9sGI6");

var $id7K0 = parcelRequire("id7K0");

var $koVbs = parcelRequire("koVbs");

var $2BHCj = parcelRequire("2BHCj");
const $ae40b537a934bf9c$export$155581e8dc02007a = (props)=>{
    const { DocumentTitle: DocumentTitle, section: section, projectName: projectName, subsection: subsection } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const title = subsection ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $2BHCj.default)[section])} - ${subsection} - ${formatMessage((0, $2BHCj.default).serviceProject)}` : // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $2BHCj.default)[section])} - ${formatMessage((0, $2BHCj.default).serviceProject)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DocumentTitle, {
        title: title
    });
};
const $ae40b537a934bf9c$export$c7841d2c1c13065e = (0, $9sGI6.default)($ae40b537a934bf9c$export$155581e8dc02007a, {
    DocumentTitle: (0, $id7K0.DocumentTitle)
});
var $ae40b537a934bf9c$export$2e2bcd8739ae039 = $ae40b537a934bf9c$export$c7841d2c1c13065e;

});
parcelRegister("2BHCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d7eb5ce3479323e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7d7eb5ce3479323e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    atlassianAnalytics: {
        "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
        "defaultMessage": "Atlassian Analytics"
    },
    serviceProject: {
        "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
        "defaultMessage": "Service project"
    },
    knowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
        "defaultMessage": "Knowledge base"
    },
    itsmFeatures: {
        "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
        "defaultMessage": "Features"
    },
    queues: {
        "id": "servicedesk-spa-commons.common.utils.document-title.queues",
        "defaultMessage": "Queues"
    },
    customers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customers",
        "defaultMessage": "Customers"
    },
    organizations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
        "defaultMessage": "Organizations"
    },
    customerServiceEscalations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
        "defaultMessage": "Developer escalations"
    },
    reports: {
        "id": "servicedesk-spa-commons.common.utils.document-title.reports",
        "defaultMessage": "Reports"
    },
    services: {
        "id": "servicedesk-spa-commons.common.utils.document-title.services",
        "defaultMessage": "Services"
    },
    oncall: {
        "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
        "defaultMessage": "On-call"
    },
    email: {
        "id": "servicedesk-spa-commons.common.utils.document-title.email",
        "defaultMessage": "Email request"
    },
    sla: {
        "id": "servicedesk-spa-commons.common.utils.document-title.sla",
        "defaultMessage": "Service level agreements"
    },
    csat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.csat",
        "defaultMessage": "Customer satisfaction"
    },
    details: {
        "id": "servicedesk-spa-commons.common.utils.document-title.details",
        "defaultMessage": "Details"
    },
    portal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal",
        "defaultMessage": "Customer portal"
    },
    externalLinks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
        "defaultMessage": "External resources"
    },
    portalSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
        "defaultMessage": "Portal settings"
    },
    automation: {
        "id": "servicedesk-spa-commons.common.utils.document-title.automation",
        "defaultMessage": "Automation"
    },
    advanced: {
        "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
        "defaultMessage": "Advanced"
    },
    languageSupport: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
        "defaultMessage": "Language support"
    },
    languageTranslations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
        "defaultMessage": "Language translations"
    },
    notificationEmail: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
        "defaultMessage": "Notification email"
    },
    notifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
        "defaultMessage": "Notifications"
    },
    internalNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
        "defaultMessage": "Internal notifications"
    },
    customerNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    widget: {
        "id": "servicedesk-spa-commons.common.utils.document-title.widget",
        "defaultMessage": "Widget"
    },
    customerPermissions: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    people: {
        "id": "servicedesk-spa-commons.common.utils.document-title.people",
        "defaultMessage": "Internal access"
    },
    issueType: {
        "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
        "defaultMessage": "Request types"
    },
    connectAppControls: {
        "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
        "defaultMessage": "Apps"
    },
    features: {
        "id": "servicedesk-spa-commons.common.utils.document-title.features",
        "defaultMessage": "Features"
    },
    calendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
        "defaultMessage": "Calendar"
    },
    projectSummary: {
        "id": "servicedesk-spa-commons.common.utils.document-title.project-summary",
        "defaultMessage": "Summary"
    },
    changeCalendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
        "defaultMessage": "Change calendar"
    },
    changeManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
        "defaultMessage": "Change management"
    },
    incidentManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
        "defaultMessage": "Incident management"
    },
    virtualAgentConversations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
        "defaultMessage": "Conversations"
    },
    virtualAgentIntents: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
        "defaultMessage": "Intents"
    },
    virtualAgentStandardFlows: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
        "defaultMessage": "Standard flows"
    },
    virtualAgentSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
        "defaultMessage": "Settings"
    },
    virtualAgentLanding: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
        "defaultMessage": "Virtual agent"
    },
    chat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.chat",
        "defaultMessage": "Chat"
    },
    proformaForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
        "defaultMessage": "Forms"
    },
    playbooks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
        "defaultMessage": "Playbooks"
    },
    dataClassifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
        "defaultMessage": "Data classification"
    },
    // EAX-256 - Finalise this string
    fieldsNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
        "defaultMessage": "Fields"
    },
    workflowScheme: {
        "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
        "defaultMessage": "Workflows"
    },
    journeysNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
        "defaultMessage": "Journeys"
    },
    journeyConfigNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
        "defaultMessage": "Journey configuration"
    },
    helpCenterForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.helpcenter-forms",
        "defaultMessage": "Forms"
    },
    helpCenterDetails: {
        "id": "servicedesk-spa-commons.common.utils.document-title.helpcenter-details",
        "defaultMessage": "Details"
    },
    virtualAgentAiAnswers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.ai-answers",
        "defaultMessage": "Atlassian Intelligence answers"
    },
    virtualAgentPerformance: {
        "id": "servicedesk-spa-commons.common.utils.document-title.performance",
        "defaultMessage": "Performance"
    },
    customerAccess: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-access",
        "defaultMessage": "Customer access"
    },
    articles: {
        "id": "servicedesk-spa-commons.common.utils.document-title.articles",
        "defaultMessage": "Articles"
    },
    createArticle: {
        "id": "servicedesk-spa-commons.common.utils.document-title.create-article",
        "defaultMessage": "Create articles"
    },
    viewArticle: {
        "id": "servicedesk-spa-commons.common.utils.document-title.view-article",
        "defaultMessage": "View article"
    },
    supportWebsite: {
        "id": "servicedesk-spa-commons.common.utils.document-title.support-website",
        "defaultMessage": "Support website"
    },
    supportWebsiteOverview: {
        "id": "servicedesk-spa-commons.common.utils.document-title.support-website-overview",
        "defaultMessage": "Support website overview"
    },
    supportWebsitePages: {
        "id": "servicedesk-spa-commons.common.utils.document-title.support-website-pages",
        "defaultMessage": "Support website pages"
    },
    viewsSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.view-settings",
        "defaultMessage": "Views Settings"
    },
    customerServiceAgentOverview: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-agent-overview",
        "defaultMessage": "Customer Service Agent"
    },
    customerServiceAgentKnowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-agent-knowledge",
        "defaultMessage": "Customer Service Agent Knowledge"
    },
    customerServiceAgentReview: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-agent-review",
        "defaultMessage": "Customer Service Agent Review"
    },
    customerServiceAgentSimulator: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-agent-simulator",
        "defaultMessage": "Customer Service Agent Test"
    }
});

});


parcelRegister("4S0uJ", function(module, exports) {

$parcel$export(module.exports, "PageStyle", () => $7307247c9fc02c84$export$c59987a647e9a55);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8jaNf = parcelRequire("8jaNf");
const $7307247c9fc02c84$export$c59987a647e9a55 = ({ Page: Page = (0, $8jaNf.default), children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7307247c9fc02c84$var$JSDSpaPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Page, null, children));
var $7307247c9fc02c84$export$2e2bcd8739ae039 = $7307247c9fc02c84$export$c59987a647e9a55;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7307247c9fc02c84$var$JSDSpaPageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1jfw _otyridpf _18u01jfw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8jaNf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0dbbbc94fbed9b4$export$2e2bcd8739ae039);

var $9DqAW = parcelRequire("9DqAW");

var $cigQb = parcelRequire("cigQb");

var $4KBRy = parcelRequire("4KBRy");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$b0dbbbc94fbed9b4$export$2e2bcd8739ae039 = (0, $9DqAW.default);

});
parcelRegister("9DqAW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f7afc820429f3d0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $ggIgZ = parcelRequire("ggIgZ");
function $6f7afc820429f3d0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6f7afc820429f3d0$var$bannerStyles = {
    name: "4oew4k",
    styles: "width:100%;position:fixed"
};
const $6f7afc820429f3d0$var$bannerContainerStyles = {
    name: "1x3pv69",
    styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
};
const $6f7afc820429f3d0$var$pageContentStyles = {
    name: "15n167b",
    styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
};
const $6f7afc820429f3d0$var$wrapperStyles = {
    name: "m5v4sl",
    styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
};
const $6f7afc820429f3d0$var$mainContainerStyles = {
    name: "1cete8c",
    styles: "display:flex;flex:1 1 auto"
};
const $6f7afc820429f3d0$var$navigationStyles = {
    name: "wrqbg1",
    styles: "position:relative;z-index:2"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $6f7afc820429f3d0$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $ggIgZ.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6f7afc820429f3d0$var$wrapperStyles,
        "data-testid": testId
    }, banner ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6f7afc820429f3d0$var$bannerContainerStyles,
        style: {
            height: isBannerOpen ? `${bannerHeight}px` : '0'
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? `${testId}--banner-container` : undefined
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6f7afc820429f3d0$var$bannerStyles
    }, banner)) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6f7afc820429f3d0$var$mainContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6f7afc820429f3d0$var$navigationStyles
    }, navigation), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6f7afc820429f3d0$var$pageContentStyles
    }, children)));
};
var $6f7afc820429f3d0$export$2e2bcd8739ae039 = $6f7afc820429f3d0$var$Page;

});



parcelRegister("cz40O", function(module, exports) {

$parcel$export(module.exports, "SpaPageWrapper", () => $2099b56eb86565d0$export$577514961fbf4842);
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $dJl1T = parcelRequire("dJl1T");

var $9sGI6 = parcelRequire("9sGI6");

var $9dbF6 = parcelRequire("9dbF6");

var $9NiTW = parcelRequire("9NiTW");

var $aTz47 = parcelRequire("aTz47");

var $cYaqS = parcelRequire("cYaqS");

var $8pMQX = parcelRequire("8pMQX");
const $2099b56eb86565d0$export$91f88695e0d311a5 = (props)=>{
    const { projectContext: projectContext, isLoading: isLoading, error: error, children: children, AccessCheck: AccessCheck, AuthenticationCheck: AuthenticationCheck, ProjectNotFound: ProjectNotFound, ServiceHubNotFound: ServiceHubNotFound, GenericError: GenericError, SubProductUpdater: SubProductUpdater } = props;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
    if (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jsdspa-page-wrapper', 'rendering-error-page', error);
        const isHelpCenterSettingsRoute = (0, $aTz47.isHelpCenterSettingsPath)();
        if (isHelpCenterSettingsRoute) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AuthenticationCheck, null, error.statusCode === 404 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ServiceHubNotFound, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(GenericError, null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AuthenticationCheck, null, error.statusCode === 404 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProjectNotFound, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(GenericError, null));
    }
    if (projectContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SubProductUpdater, {
        subProduct: "serviceDesk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AuthenticationCheck, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AccessCheck, null, children)));
    return null;
};
const $2099b56eb86565d0$export$577514961fbf4842 = (0, $9sGI6.default)($2099b56eb86565d0$export$91f88695e0d311a5, {
    AccessCheck: (0, $cYaqS.default),
    GenericError: (0, $8pMQX.GenericError),
    ProjectNotFound: (0, $8pMQX.ProjectNotFound),
    ServiceHubNotFound: (0, $8pMQX.ServiceHubNotFound),
    AuthenticationCheck: (0, $9NiTW.AuthenticationCheck),
    SubProductUpdater: (0, $9dbF6.SubProductUpdater)
});
var $2099b56eb86565d0$export$2e2bcd8739ae039 = $2099b56eb86565d0$export$577514961fbf4842;

});
parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $dJl1T = parcelRequire("dJl1T");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $dJl1T.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("cYaqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f72fff5a1e4c8937$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $aTz47 = parcelRequire("aTz47");


var $4UFLs = parcelRequire("4UFLs");

var $g3A84 = parcelRequire("g3A84");
const $f72fff5a1e4c8937$var$AccessCheck = ({ children: children })=>{
    const isSettingsRoute = (0, $6jY6G.useCurrentRoute)().path.includes(`${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
    const isHelpCenterSettingsRoute = (0, $aTz47.isHelpCenterSettingsPath)();
    const Gate = isSettingsRoute || isHelpCenterSettingsRoute ? (0, $g3A84.default) : (0, $4UFLs.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Gate, null, children);
};
var $f72fff5a1e4c8937$export$2e2bcd8739ae039 = $f72fff5a1e4c8937$var$AccessCheck;

});
const $7c914880cb332728$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';
const $7c914880cb332728$export$16a37d277dff22d6 = '/jira/helpcenter/projects';

parcelRegister("4UFLs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9befbeaff9f5385d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $daoB1 = parcelRequire("daoB1");

var $7tQej = parcelRequire("7tQej");
var $bmKPg = parcelRequire("bmKPg");

var $iDvG9 = parcelRequire("iDvG9");
const $9befbeaff9f5385d$var$ProductAccessCheck = ({ children: children })=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $daoB1.useApplicationPermissions)();
    const [projectKey = ''] = (0, $bmKPg.usePathParam)('projectKey');
    if (projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDvG9.default), null, children);
    return hasServiceDeskAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira"
    });
};
var $9befbeaff9f5385d$export$2e2bcd8739ae039 = $9befbeaff9f5385d$var$ProductAccessCheck;

});
parcelRegister("iDvG9", function(module, exports) {

$parcel$export(module.exports, "default", () => $34dd3dc578b1a167$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
var $bmKPg = parcelRequire("bmKPg");

var $dFOAR = parcelRequire("dFOAR");


var $fhAnU = parcelRequire("fhAnU");
const $34dd3dc578b1a167$var$AgentCheck = ({ children: children })=>{
    const [projectKey = ''] = (0, $bmKPg.usePathParam)('projectKey');
    const [{ data: data, error: error }] = (0, $dFOAR.useServiceDeskContext)();
    if (data || error) {
        // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
        if (!(0, $fhAnU.isAccessError)(error)) {
            const { userRole: userRole = '' } = data || {};
            if (userRole === 'agent' || userRole === 'agent-project-admin') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
            if (error) throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
        });
    }
    return null;
};
var $34dd3dc578b1a167$export$2e2bcd8739ae039 = $34dd3dc578b1a167$var$AgentCheck;

});
parcelRegister("fhAnU", function(module, exports) {

$parcel$export(module.exports, "isAccessError", () => $1a790f4bb1355504$export$ddaebe4928e793cb);

const $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES = [
    (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3),
    (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef),
    (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)
];
const $1a790f4bb1355504$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;

});



parcelRegister("g3A84", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e7d6646168c089$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aTz47 = parcelRequire("aTz47");

var $8pMQX = parcelRequire("8pMQX");

var $dFOAR = parcelRequire("dFOAR");

var $fhAnU = parcelRequire("fhAnU");
const $60e7d6646168c089$var$SettingsAccessCheck = ({ children: children })=>{
    const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, $dFOAR.useServiceDeskContext)();
    const userRole = serviceDeskContext?.userRole;
    // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
    const hasAccessError = (0, $fhAnU.isAccessError)(serviceDeskContextError);
    // Service desk context is updated on every route change
    // If context fails to give us an indicative result (e.g. fetch failed, 500 error)
    // We will continue to use current value to assess permissions
    if (userRole === 'agent-project-admin' && !hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    if (userRole !== undefined || hasAccessError) {
        const isHelpCenterSettingsRoute = (0, $aTz47.isHelpCenterSettingsPath)();
        if (isHelpCenterSettingsRoute) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.ServiceHubNotFound), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.ProjectNotFound), null);
    }
    if (serviceDeskContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.GenericError), null);
    return null;
};
var $60e7d6646168c089$export$2e2bcd8739ae039 = $60e7d6646168c089$var$SettingsAccessCheck;

});



parcelRegister("dxOZv", function(module, exports) {

$parcel$export(module.exports, "AsyncContactsAppLayout", () => $522fddb798409ed9$export$4a505c5c2222d386);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $522fddb798409ed9$export$55118fe902ecc07a = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("kESIN")), {
    moduleId: "./src/packages/spa-apps/servicedesk/contacts/src/index.tsx"
});
const $522fddb798409ed9$export$4a505c5c2222d386 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "servicedesk-contacts",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($522fddb798409ed9$export$55118fe902ecc07a, null));

});
parcelRegister("kESIN", function(module, exports) {

let $f0a1fda0e59ecfc1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f0a1fda0e59ecfc1$var$load("h2MrD"),
    $f0a1fda0e59ecfc1$var$load("bYT2S"),
    $f0a1fda0e59ecfc1$var$load("kKD37")
]).then(()=>parcelRequire('2XE2f'));

});





//# sourceMappingURL=async-servicedesk-customers-v2.b057efc4.js.map
